/* eslint-disable */
/*
 * ----------------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API-ES            ##
 * ## SOURCE: https://github.com/hunghg255/swagger-typescript-api-es   ##
 * ----------------------------------------------------------------------
 */

type UtilRequiredKeys<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

export type ApiMediatRUnit = object;

export interface ApiProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface ApiValidationProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors: Record<string, string[]>;
  [key: string]: any;
}

export type ApiInitAnalyticsResponse = object;

export interface ApiAccountResponse {
  account: ApiAccountPersisted;
}

export interface ApiAccountWithEmailExistsResponse {
  exists: boolean;
}

export interface ApiAccountsResponse {
  accounts: ApiAccountPersisted[];
  /** @format int32 */
  totalCount: number;
}

export interface ApiChangeAccountPasswordResponse {
  /** @format uuid */
  accountId: string;
  encryptedPassword: string;
}

export interface ApiChangeAccountStatusResponse {
  /** @format uuid */
  accountId: string;
  isActive: boolean;
}

export interface ApiCounterpartyProfileResponseBaseForEntrepreneurProfilePersisted {
  profilePersisted: ApiEntrepreneurProfilePersisted;
}

export interface ApiCounterpartyProfileResponseBaseForLegalEntityProfilePersisted {
  profilePersisted: ApiLegalEntityProfilePersisted;
}

export type ApiEntrepreneurProfileResponse =
  ApiCounterpartyProfileResponseBaseForEntrepreneurProfilePersisted;

export type ApiLegalEntityProfileResponse =
  ApiCounterpartyProfileResponseBaseForLegalEntityProfilePersisted;

export interface ApiProfileResponse {
  profile?:
    | ApiCounterpartyProfilePersistedBase
    | ApiEntrepreneurEmployeeProfilePersisted
    | ApiEntrepreneurProfilePersisted
    | ApiLegalEntityProfilePersisted
    | ApiLegalEntityEmployeeProfilePersisted
    | ApiOfficeEmployeeProfilePersisted
    | null;
}

export interface ApiProfilesResponse {
  profiles: (
    | ApiCounterpartyProfilePersistedBase
    | ApiEntrepreneurEmployeeProfilePersisted
    | ApiEntrepreneurProfilePersisted
    | ApiLegalEntityProfilePersisted
    | ApiLegalEntityEmployeeProfilePersisted
    | ApiOfficeEmployeeProfilePersisted
  )[];
}

export interface ApiAccount {
  login: string;
  email: string;
  isActive: boolean;
  isEmailConfirmed: boolean;
}

export interface ApiAccountPersisted {
  /** @format uuid */
  id: string;
  account: ApiAccount;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

/** @format int32 */
export enum ApiAccountSortingField {
  Login = 'Login',
  Email = 'Email',
  IsActive = 'IsActive',
  IsEmailConfirmed = 'IsEmailConfirmed',
  CreatedAt = 'CreatedAt',
  UpdatedAt = 'UpdatedAt',
}

export type ApiCounterpartyEmployeeProfileBase = ApiProfileBase & {
  /** @format int64 */
  number: number;
  inn?: string | null;
  snils?: string | null;
  /** @format uuid */
  externalId: string;
};

export type ApiCounterpartyProfileBase = ApiProfileBase;

export type ApiCounterpartyProfilePersistedBase = ApiProfilePersistedBase;

export interface ApiCounterpartyProfilePersistedBaseForEntrepreneurProfile {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  profile?: ApiEntrepreneurProfile;
}

export interface ApiCounterpartyProfilePersistedBaseForLegalEntityProfile {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  profile?: ApiLegalEntityProfile;
}

export interface ApiEmployeeProfilePersistedBaseForEntrepreneurEmployeeProfile {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format int64 */
  number: number;
  profile?: ApiEntrepreneurEmployeeProfile;
}

export interface ApiEmployeeProfilePersistedBaseForLegalEntityEmployeeProfile {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format int64 */
  number: number;
  profile?: ApiLegalEntityEmployeeProfile;
}

export interface ApiEmployeeProfilePersistedBaseForOfficeEmployeeProfile {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format int64 */
  number: number;
  profile?: ApiOfficeEmployeeProfile;
}

export type ApiEntrepreneurEmployeeProfile = ApiCounterpartyEmployeeProfileBase & {
  employerInn: string;
  employerOgrn: string;
  type: ApiProfileType;
};

export type ApiEntrepreneurEmployeeProfilePersisted =
  ApiEmployeeProfilePersistedBaseForEntrepreneurEmployeeProfile;

export type ApiEntrepreneurProfile = ApiCounterpartyProfileBase & {
  inn: string;
  ogrnIp: string;
  type: ApiProfileType;
};

export type ApiEntrepreneurProfilePersisted =
  ApiCounterpartyProfilePersistedBaseForEntrepreneurProfile;

export type ApiLegalEntityEmployeeProfile = ApiCounterpartyEmployeeProfileBase & {
  counterpartyInn: string;
  counterpartyOgrn: string;
  counterpartyKpp: string;
  type: ApiProfileType;
};

export type ApiLegalEntityEmployeeProfilePersisted =
  ApiEmployeeProfilePersistedBaseForLegalEntityEmployeeProfile;

export type ApiLegalEntityProfile = ApiCounterpartyProfileBase & {
  inn: string;
  ogrn: string;
  kpp: string;
  type: ApiProfileType;
};

export type ApiLegalEntityProfilePersisted =
  ApiCounterpartyProfilePersistedBaseForLegalEntityProfile;

export type ApiOfficeEmployeeProfile = UtilRequiredKeys<ApiProfileBase, 'type'> & {
  /** @format int64 */
  number: number;
  inn?: string | null;
  snils?: string | null;
  /** @format uuid */
  externalId: string;
  type: ApiProfileType;
};

export type ApiOfficeEmployeeProfilePersisted =
  ApiEmployeeProfilePersistedBaseForOfficeEmployeeProfile;

export interface ApiProfileBase {
  /** @format uuid */
  accountId?: string | null;
  isSignatureRequired: boolean;
  isActive: boolean;
  type: ApiProfileType;
  title: string;
  email: string;
  phone?: string | null;
  isPhoneConfirmed: boolean;
  /** @format uuid */
  divisionId?: string | null;
}

export interface ApiProfilePersistedBase {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

/** @format int32 */
export enum ApiProfileType {
  Unknown = 'Unknown',
  LegalEntity = 'LegalEntity',
  Entrepreneur = 'Entrepreneur',
  LegalEntityEmployee = 'LegalEntityEmployee',
  EntrepreneurEmployee = 'EntrepreneurEmployee',
  OfficeEmployee = 'OfficeEmployee',
}

export interface ApiAuthorizationAuthorizeEnterpriseServiceTransitionResponse {
  isAuthorized: boolean;
}

export interface ApiAuthorizationGetAppsResponse {
  apps: ApiAuthorizationApp[];
}

export interface ApiAuthorizationGetPermissionsResponse {
  permissions: ApiAuthorizationPermission[];
}

export interface ApiAuthorizationApp {
  /** @format int32 */
  id: number;
  name: string;
  url: string;
  alias: string;
  group?: string | null;
  /** @format int32 */
  displayOrder: number;
}

export interface ApiAuthorizationPermission {
  id: ApiAuthorizationPermissionEnum;
  name: string;
  value: string;
  description: string;
}

/** @format int32 */
export enum ApiAuthorizationPermissionEnum {
  CounterpartyRead = 'CounterpartyRead',
  CounterpartyCreate = 'CounterpartyCreate',
  CounterpartyUpdate = 'CounterpartyUpdate',
  CounterpartyEmployeeRead = 'CounterpartyEmployeeRead',
  CounterpartyEmployeeCreate = 'CounterpartyEmployeeCreate',
  CounterpartyEmployeeUpdate = 'CounterpartyEmployeeUpdate',
  CounterpartyEmployeeTrustRead = 'CounterpartyEmployeeTrustRead',
  CounterpartyEmployeeTrustCreate = 'CounterpartyEmployeeTrustCreate',
  CounterpartyEmployeeTrustAccept = 'CounterpartyEmployeeTrustAccept',
  CounterpartyEmployeeTrustDecline = 'CounterpartyEmployeeTrustDecline',
  CounterpartyFnsUpdate = 'CounterpartyFnsUpdate',
  CounterpartyFnsRead = 'CounterpartyFnsRead',
  CounterpartyMasterAccountUpdate = 'CounterpartyMasterAccountUpdate',
  CounterpartyMasterAccountCreate = 'CounterpartyMasterAccountCreate',
  CounterpartyMasterAccountRead = 'CounterpartyMasterAccountRead',
  CounterpartyBoatRead = 'CounterpartyBoatRead',
  CounterpartyBoatCreate = 'CounterpartyBoatCreate',
  CounterpartyBoatUpdate = 'CounterpartyBoatUpdate',
  CounterpartyBoatDelete = 'CounterpartyBoatDelete',
  EnterpriseEmployeeRead = 'EnterpriseEmployeeRead',
  EnterpriseEmployeeCreate = 'EnterpriseEmployeeCreate',
  EnterpriseEmployeeUpdate = 'EnterpriseEmployeeUpdate',
  AccountUpdate = 'AccountUpdate',
  AccountRead = 'AccountRead',
  MasterAccountApplicationRead = 'MasterAccountApplicationRead',
  MasterAccountApplicationUpdate = 'MasterAccountApplicationUpdate',
  ServiceRead = 'ServiceRead',
  TariffCreate = 'TariffCreate',
  TariffUpdate = 'TariffUpdate',
  TariffRead = 'TariffRead',
  TariffDelete = 'TariffDelete',
  AgreementRead = 'AgreementRead',
  DestinationCreate = 'DestinationCreate',
  DestinationRead = 'DestinationRead',
  DestinationUpdate = 'DestinationUpdate',
  DivisionContactRead = 'DivisionContactRead',
  DivisionContactCreate = 'DivisionContactCreate',
  DivisionContactUpdate = 'DivisionContactUpdate',
  DivisionContactDelete = 'DivisionContactDelete',
  EnterpriseRoleRead = 'EnterpriseRoleRead',
  EnterpriseRoleUpdate = 'EnterpriseRoleUpdate',
  EnterpriseRoleCreate = 'EnterpriseRoleCreate',
  EnterpriseRoleDelete = 'EnterpriseRoleDelete',
  ServiceApplicationOutsideOfPortalCreate = 'ServiceApplicationOutsideOfPortalCreate',
  EnterprisePropertyRead = 'EnterprisePropertyRead',
  EnterprisePropertyCreate = 'EnterprisePropertyCreate',
  EnterprisePropertyUpdate = 'EnterprisePropertyUpdate',
}

export interface ApiAxaptaDivisionSettings {
  /** @format uuid */
  divisionId: string;
  isActive: boolean;
  /** @format date-time */
  updatedAtUtc: string;
}

/** @format int32 */
export enum ApiChatAuthorKind {
  Customer = 'Customer',
  Staff = 'Staff',
}

export interface ApiChatMessage {
  /** @format uuid */
  id: string;
  message: string;
  /** @format date-time */
  dateTime: string;
  /** @format uuid */
  authorId: string;
  authorKind: ApiChatAuthorKind;
  names: ApiCounterpartyEmployeesNames;
}

/** @format int32 */
export enum ApiChatSourceKind {
  Contract = 'Contract',
  Service = 'Service',
  Ship = 'Ship',
}

/** @format int32 */
export enum ApiSortingDirection {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

/** @format int32 */
export enum ApiCounterpartiesSortingField {
  Id = 'Id',
  CounterpartyType = 'CounterpartyType',
  Title = 'Title',
  CreatedAt = 'CreatedAt',
  UpdatedAt = 'UpdatedAt',
  Inn = 'Inn',
  Ogrn = 'Ogrn',
  Kpp = 'Kpp',
}

/** @format int32 */
export enum ApiEntrepreneursSortingField {
  Id = 'Id',
  FullName = 'FullName',
  CreatedAt = 'CreatedAt',
  UpdatedAt = 'UpdatedAt',
  Inn = 'Inn',
  OgrnIp = 'OgrnIp',
}

export interface ApiCounterpartyBankAccountsResponse {
  bankAccounts: ApiBankAccountPersisted[];
}

export interface ApiCounterpartiesResponse {
  counterparties: (ApiEntrepreneurPersisted | ApiLegalEntityPersisted)[];
  /** @format int32 */
  totalCount: number;
}

export interface ApiCounterpartiesUpdatedResponse {
  counterparties: (ApiEntrepreneurPersisted | ApiLegalEntityPersisted)[];
}

export interface ApiCounterpartyCanBeDeletedCheckResponse {
  canBeDeleted: boolean;
  blockers: ApiCounterpartyDeletionBlockerType[];
}

/** @format int32 */
export enum ApiCounterpartyDeletionBlockerType {
  Employees = 'Employees',
  Accounts = 'Accounts',
}

export interface ApiCounterpartyResponse {
  counterparty?: ApiEntrepreneurPersisted | ApiLegalEntityPersisted | null;
}

export interface ApiCounterpartyEntrepreneurResponse {
  entrepreneurPersisted: ApiEntrepreneurPersisted;
}

export interface ApiCounterpartyEntrepreneursResponse {
  entrepreneurs: ApiEntrepreneurPersisted[];
}

export type ApiCounterpartyEntrepreneursUpdatedResponse = ApiCounterpartyEntrepreneursResponse;

export interface ApiCounterpartyLegalEntitiesResponse {
  legalEntities: ApiLegalEntityPersisted[];
}

export type ApiCounterpartyLegalEntitiesUpdatedResponse = ApiCounterpartyLegalEntitiesResponse;

export interface ApiBankAccount {
  bankAccountNumber: string;
  bankIdentificationCode: string;
  bankName: string;
  correspondentAccount: string;
}

export interface ApiBankAccountPersisted {
  /** @format uuid */
  id: string;
  /** @format uuid */
  counterpartyId: string;
  bankAccount: ApiBankAccount;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface ApiCounterpartyBase {
  description?: string | null;
  type: ApiCounterpartyType;
  taxKind?: ApiTaxKind;
  phone?: string | null;
  email?: string | null;
}

/** @format int32 */
export enum ApiCounterpartyType {
  Unknown = 'Unknown',
  LegalEntity = 'LegalEntity',
  Entrepreneur = 'Entrepreneur',
}

export interface ApiEgrulEgripEntrepreneur {
  inn: string;
  ogrn: string;
  opf: string;
  fullName: string;
  /** @format date */
  registrationDate?: string | null;
}

export interface ApiEgrulLegalEntity {
  inn: string;
  ogrn: string;
  kpp: string;
  opf: string;
  longName: string;
  shortName: string;
  legalAddress?: string | null;
  /** @format date */
  registrationDate?: string | null;
  heads: ApiEgrulLegalEntityHead[];
  branches: ApiEgrulLegalEntityBranch[];
}

export interface ApiEgrulLegalEntityBranch {
  name?: string | null;
  kpp?: string | null;
  legalAddress?: string | null;
}

export interface ApiEgrulLegalEntityHead {
  position: string;
  fullName: string;
  inn: string;
}

export type ApiCounterpartiesEntityIdentifiers = object;

export type ApiCounterpartiesIdentifiersEntrepreneur = ApiCounterpartiesEntityIdentifiers & {
  inn: string;
  ogrnIp: string;
};

export type ApiCounterpartiesIdentifiersLegalEntity = ApiCounterpartiesEntityIdentifiers & {
  inn: string;
  ogrn: string;
  kpp: string;
};

export interface ApiCounterpartyPersistedBase {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export type ApiEntrepreneur = UtilRequiredKeys<ApiCounterpartyBase, 'type'> & {
  inn: string;
  ogrnIp: string;
  fullName: string;
  /** @format date */
  registrationDate?: string | null;
  type: ApiCounterpartyType;
};

export type ApiEntrepreneurPersisted = ApiCounterpartyPersistedBase & {
  counterparty: ApiEntrepreneur;
};

export type ApiLegalEntity = UtilRequiredKeys<ApiCounterpartyBase, 'type'> & {
  inn: string;
  ogrn: string;
  kpp: string;
  opf: string;
  longName: string;
  shortName: string;
  legalAddress?: string | null;
  /** @format date */
  registrationDate?: string | null;
  legalEntityKind: ApiLegalEntityKind;
  /** @format uuid */
  parentId?: string | null;
  heads: ApiLegalEntityHead[];
  type: ApiCounterpartyType;
};

export interface ApiLegalEntityHead {
  position: string;
  fullName: string;
  inn: string;
  snils?: string | null;
  description?: string | null;
}

export interface ApiLegalEntityHeadPersisted {
  /** @format uuid */
  id: string;
  legalEntityHead: ApiLegalEntityHead;
}

/** @format int32 */
export enum ApiLegalEntityKind {
  Head = 'Head',
  Branch = 'Branch',
}

export type ApiLegalEntityPersisted = ApiCounterpartyPersistedBase & {
  counterparty: ApiLegalEntity;
};

/** @format int32 */
export enum ApiTaxKind {
  Common = 'Common',
  Simple = 'Simple',
}

/** @format int32 */
export enum ApiCounterpartyDocumentsDocumentSortingField {
  CreatedAt = 'CreatedAt',
  Name = 'Name',
  DocumentType = 'DocumentType',
  IsArchived = 'IsArchived',
  CreationDate = 'CreationDate',
  ExpirationDate = 'ExpirationDate',
  FileName = 'FileName',
}

export interface ApiCounterpartyDocumentsGetDocumentsResponse {
  documents: ApiCounterpartyDocumentsDocumentPersisted[];
  /** @format int32 */
  totalCount: number;
}

export interface ApiCounterpartyDocumentsDocument {
  documentType?: ApiCounterpartyDocumentsDocumentType;
  documentTypeText?: string | null;
  name: string;
  isArchived: boolean;
  /** @format uuid */
  fileId: string;
  /** @format uuid */
  counterpartyId: string;
  /** @format date */
  creationDate: string;
  /** @format date */
  expirationDate?: string | null;
}

export interface ApiCounterpartyDocumentsDocumentPersisted {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  document: ApiCounterpartyDocumentsDocument;
}

/** @format int32 */
export enum ApiCounterpartyDocumentsDocumentType {
  OrderAppointingTheHead = 'OrderAppointingTheHead',
  StatuteOfTheOrganization = 'StatuteOfTheOrganization',
  MemorandumOfAssociation = 'MemorandumOfAssociation',
}

export interface ApiCounterpartyEmployeeResponse {
  employeePersisted?:
    | ApiCounterpartyEmployeePersistedEntrepreneur
    | ApiCounterpartyEmployeePersistedLegalEntity
    | null;
}

export interface ApiCounterpartyEmployeesResponse {
  employees: (
    | ApiCounterpartyEmployeePersistedEntrepreneur
    | ApiCounterpartyEmployeePersistedLegalEntity
  )[];
}

export interface ApiCounterpartyEmployeesRolesResponse {
  roles: ApiRmpRole[];
}

export type ApiCounterpartyEmployeesUpdatedResponse = ApiCounterpartyEmployeesResponse;

export interface ApiCounterpartyEmployee {
  /** @format uuid */
  counterpartyId: string;
  email: string;
  position: string;
  inn?: string | null;
  snils?: string | null;
  lastName: string;
  firstName: string;
  middleName?: string | null;
  phone: string;
  description?: string | null;
  isActive: boolean;
  /** @format date */
  dateOfBirth?: string | null;
  roles: ApiRmpRole[];
}

export type ApiCounterpartyEmployeeEntrepreneur = ApiCounterpartyEmployee & {
  identifiersEntrepreneur: ApiCounterpartiesIdentifiersEntrepreneur;
};

export type ApiCounterpartyEmployeeLegalEntity = ApiCounterpartyEmployee & {
  identifiersLegalEntity: ApiCounterpartiesIdentifiersLegalEntity;
};

export interface ApiCounterpartyEmployeePersistedBase {
  /** @format uuid */
  id: string;
  /** @format int64 */
  number: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export type ApiCounterpartyEmployeePersistedEntrepreneur = ApiCounterpartyEmployeePersistedBase & {
  employee: ApiCounterpartyEmployeeEntrepreneur;
};

export type ApiCounterpartyEmployeePersistedLegalEntity = ApiCounterpartyEmployeePersistedBase & {
  employee: ApiCounterpartyEmployeeLegalEntity;
};

export interface ApiCounterpartyEmployeesNames {
  firstName: string;
  middleName: string | null;
  lastName: string;
}

/** @format int32 */
export enum ApiCounterpartyEmployeesServiceApplicationCreatedByRecipientNotificationSettingKind {
  Own = 'Own',
  All = 'All',
}

/** @format int32 */
export enum ApiCounterpartyEmployeesServiceApplicationStatusChangesNotificationSettingKind {
  DocumentsSigned = 'DocumentsSigned',
  All = 'All',
}

export interface ApiRmpDivisionAccessFilter {
  kind: ApiRmpDivisionAccessFilterKind;
  divisionIds: string[];
}

/** @format int32 */
export enum ApiRmpDivisionAccessFilterKind {
  Unrestricted = 'Unrestricted',
  Empty = 'Empty',
  Exact = 'Exact',
}

export type ApiAssignInvoiceDocumentTemplateResponse = object;

export interface ApiCreateAgreementDocumentTemplateResponse {
  documentTemplate: ApiDocumentTemplatePersisted;
}

export interface ApiCreateDocumentTemplateResponse {
  documentTemplate: ApiDocumentTemplatePersisted;
}

export interface ApiCreatePublicOfferDefinitionDocumentTemplateResponse {
  documentTemplate: ApiDocumentTemplatePersisted;
}

export interface ApiCreateServiceConfirmationDocumentTemplateResponse {
  documentTemplate: ApiDocumentTemplatePersisted;
}

export interface ApiGetAgreementDocumentTemplateByAgreementDefinitionIdResponse {
  documentTemplate: ApiDocumentTemplatePersisted;
}

export interface ApiGetDocumentTemplateResponse {
  documentTemplate: ApiDocumentTemplatePersisted;
}

export interface ApiValidateGuaranteeLetterDefinitionDocumentTemplateResponse {
  isValid: boolean;
  error?: string | null;
}

export interface ApiDocumentTemplate {
  /** @format uuid */
  fileId: string;
  name: string;
}

export interface ApiDocumentTemplatePersisted {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  documentTemplate: ApiDocumentTemplate;
}

/** @format int32 */
export enum ApiDocumentsExtension {
  Unknown = 'Unknown',
  DOCX = 'DOCX',
  XLSX = 'XLSX',
  XML = 'XML',
  PDF = 'PDF',
}

export interface ApiGeneratedDocumentResponse {
  /** @format byte */
  document: string;
  extension: ApiDocumentsExtension;
}

export interface ApiDivisionBankAccountResponse {
  bankAccount: ApiDivisionBankAccountPersisted;
}

export interface ApiDivisionBankAccountsResponse {
  bankAccounts: ApiDivisionBankAccountPersisted[];
}

export interface ApiDivisionCanBeDeletedCheckResponse {
  canBeDeleted: boolean;
  blockers: ApiDivisionDeletionBlockerType[];
}

export interface ApiDivisionContactByIdResponse {
  contact: ApiDivisionContactPersisted;
}

export interface ApiDivisionContactCreateResponse {
  divisionContact: ApiDivisionContactPersisted;
}

export type ApiDivisionContactDeleteResponse = object;

export interface ApiDivisionContactHoursCreateResponse {
  divisionContactHours: ApiDivisionContactHoursPersisted;
}

export type ApiDivisionContactHoursDeleteResponse = object;

export interface ApiDivisionContactHoursResponse {
  hours: ApiDivisionContactHoursPersisted[];
}

export interface ApiDivisionContactHoursUpdateResponse {
  divisionContactHours: ApiDivisionContactHoursPersisted;
}

export interface ApiDivisionContactResponse {
  contacts: ApiDivisionContactPersisted[];
}

export interface ApiDivisionContactUpdateResponse {
  divisionContact: ApiDivisionContactPersisted;
}

/** @format int32 */
export enum ApiDivisionDeletionBlockerType {
  Employee = 'Employee',
  Service = 'Service',
  ChildDivision = 'ChildDivision',
  Agreement = 'Agreement',
}

export interface ApiDivisionSettingsResponse {
  settings: ApiDivisionSettings[];
}

export interface ApiDivisionsResponse {
  divisions: (
    | ApiDivisionBranchBasinPersisted
    | ApiDivisionBranchBasinPersistedTree
    | ApiDivisionBranchPersisted
    | ApiDivisionBranchPersistedTree
    | ApiDivisionDepartmentPersisted
    | ApiDivisionDepartmentPersistedTree
    | ApiDivisionHeadPersisted
    | ApiDivisionHeadPersistedTree
    | ApiDivisionPersistedTreeBase
    | ApiDivisionPortPersisted
    | ApiDivisionPortPersistedTree
  )[];
  /** @format int32 */
  totalCount: number;
}

/** @format int32 */
export enum ApiDivisionsContactType {
  Phone = 'Phone',
  Email = 'Email',
  Fax = 'Fax',
  Vhf = 'Vhf',
  Other = 'Other',
}

export interface ApiDivisionBankAccount {
  bankAccountNumber: string;
  bankIdentificationCode: string;
  bankName: string;
  correspondentAccount: string;
  isArchived: boolean;
}

export type ApiDivisionBankAccountPersisted = ApiDivisionBankAccount & {
  /** @format uuid */
  id: string;
  /** @format uuid */
  divisionId: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
};

export interface ApiDivisionBase {
  fullName: string;
  code: string;
  timeZone: string;
  type: ApiDivisionKind;
  canActAsServiceProvider: boolean;
  isArchived: boolean;
}

export type ApiDivisionBranch = UtilRequiredKeys<ApiDivisionBase, 'type'> & {
  shortName: string;
  kpp: string;
  actualAddress: string;
  /** @format uuid */
  parentId: string;
  type: ApiDivisionKind;
};

export type ApiDivisionBranchBasin = UtilRequiredKeys<ApiDivisionBase, 'type'> & {
  shortName: string;
  actualAddress: string;
  kpp?: string | null;
  /** @format uuid */
  parentId: string;
  type: ApiDivisionKind;
};

export type ApiDivisionBranchBasinPersisted = ApiDivisionPersistedBase & {
  division: ApiDivisionBranchBasin;
};

export type ApiDivisionBranchBasinPersistedTree = ApiDivisionPersistedTreeBase & {
  division: ApiDivisionBranchBasin;
};

export type ApiDivisionBranchPersisted = ApiDivisionPersistedBase & {
  division: ApiDivisionBranch;
};

export type ApiDivisionBranchPersistedTree = ApiDivisionPersistedTreeBase & {
  division: ApiDivisionBranch;
};

export interface ApiDivisionContact {
  /** @format uuid */
  divisionId: string;
  contactPointTitle: string;
  type: ApiDivisionsContactType;
  value?: string | null;
  /** @format int32 */
  ext?: number | null;
  /** @format int32 */
  priority: number;
  timeZone?: string | null;
  isPublic: boolean;
  /** @format date */
  validFrom: string;
  /** @format date */
  validTo?: string | null;
  vhfChannels?: number[] | null;
  vhfCallsign?: string | null;
}

export interface ApiDivisionContactHours {
  /** @format int32 */
  dayOfWeek: number;
  /** @format time */
  startTime: string;
  /** @format time */
  endTime: string;
  note?: string | null;
}

export interface ApiDivisionContactHoursPersisted {
  /** @format uuid */
  id: string;
  divisionContactHours: ApiDivisionContactHours;
}

export interface ApiDivisionContactPersisted {
  /** @format uuid */
  id: string;
  divisionContact: ApiDivisionContact;
}

/** @format int32 */
export enum ApiDivisionContactSortField {
  Id = 'Id',
  ContactPointTitle = 'ContactPointTitle',
  Type = 'Type',
  Value = 'Value',
  Ext = 'Ext',
  Priority = 'Priority',
  TimeZone = 'TimeZone',
  ValidFrom = 'ValidFrom',
  ValidTo = 'ValidTo',
  VhfChannels = 'VhfChannels',
  VhfCallSign = 'VhfCallSign',
}

export type ApiDivisionDepartment = UtilRequiredKeys<ApiDivisionBase, 'type'> & {
  /** @format uuid */
  parentId: string;
  shortName: string;
  actualAddress: string;
  kpp?: string | null;
  type: ApiDivisionKind;
};

export type ApiDivisionDepartmentPersisted = ApiDivisionPersistedBase & {
  division: ApiDivisionDepartment;
};

export type ApiDivisionDepartmentPersistedTree = ApiDivisionPersistedTreeBase & {
  division: ApiDivisionDepartment;
};

export type ApiDivisionHead = UtilRequiredKeys<ApiDivisionBase, 'type'> & {
  shortName: string;
  opf: string;
  inn: string;
  ogrn: string;
  kpp: string;
  legalAddress: string;
  actualAddress: string;
  /** @format date */
  registrationDate: string;
  type: ApiDivisionKind;
};

export type ApiDivisionHeadPersisted = ApiDivisionPersistedBase & {
  division: ApiDivisionHead;
};

export type ApiDivisionHeadPersistedTree = ApiDivisionPersistedTreeBase & {
  division: ApiDivisionHead;
};

/** @format int32 */
export enum ApiDivisionKind {
  Head = 'Head',
  Branch = 'Branch',
  BranchBasin = 'BranchBasin',
  Department = 'Department',
  Port = 'Port',
}

export interface ApiDivisionPersistedBase {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export type ApiDivisionPersistedTreeBase = ApiDivisionPersistedBase & {
  childs: (
    | ApiDivisionBranchBasinPersistedTree
    | ApiDivisionBranchPersistedTree
    | ApiDivisionDepartmentPersistedTree
    | ApiDivisionHeadPersistedTree
    | ApiDivisionPortPersistedTree
  )[];
};

export type ApiDivisionPort = UtilRequiredKeys<ApiDivisionBase, 'type'> & {
  /** @format uuid */
  parentId: string;
  /** @format double */
  latitude: number;
  /** @format double */
  longitude: number;
  type: ApiDivisionKind;
};

export type ApiDivisionPortPersisted = ApiDivisionPersistedBase & {
  division: ApiDivisionPort;
};

export type ApiDivisionPortPersistedTree = ApiDivisionPersistedTreeBase & {
  division: ApiDivisionPort;
};

export interface ApiDivisionSettings {
  /** @format uuid */
  divisionId: string;
  harborDuesEnabled: boolean;
  konturDiadocEnabled: boolean;
  radiusEnabled: boolean;
  portFeesEnabled: boolean;
  operationalApprovalEnabled: boolean;
  axaptaEnabled: boolean;
  dispatchPortalEnabled: boolean;
}

/** @format int32 */
export enum ApiDivisionSortField {
  Id = 'Id',
  FullName = 'FullName',
  ShortName = 'ShortName',
  IsArchived = 'IsArchived',
  Type = 'Type',
  Kpp = 'Kpp',
}

/** @format int32 */
export enum ApiEmployeesSortingField {
  Id = 'Id',
  CreatedAt = 'CreatedAt',
  FirstName = 'FirstName',
  MiddleName = 'MiddleName',
  LastName = 'LastName',
  Fio = 'Fio',
  Position = 'Position',
  Inn = 'Inn',
  Snils = 'Snils',
  Email = 'Email',
  Phone = 'Phone',
  Description = 'Description',
  Roles = 'Roles',
  IsActive = 'IsActive',
  Number = 'Number',
}

/** @format int32 */
export enum ApiRoleSortingField {
  Id = 'Id',
  Name = 'Name',
  DivisionId = 'DivisionId',
  IsArchived = 'IsArchived',
  CreatedAt = 'CreatedAt',
}

export interface ApiArchiveRoleResponse {
  role: ApiRmpRole;
}

export interface ApiUnarchiveRoleResponse {
  role: ApiRmpRole;
}

export interface ApiCounterpartyEnterpriseBranchesResponse {
  enterpriseBranches: ApiBranchesCounterpartyEnterpriseBranchPersisted[];
}

export interface ApiEmployeeResponse {
  employeePersisted: ApiEmployeePersisted;
}

export interface ApiEmployeesResponse {
  employees: ApiEmployeePersisted[];
  /** @format int32 */
  totalCount: number;
}

export interface ApiEmployeesUpdatedResponse {
  employees: ApiEmployeePersisted[];
}

export interface ApiOfficeEmployeeResponse {
  employeePersisted: ApiOfficeEmployeePersisted;
}

export interface ApiOfficeEmployeesResponse {
  employees: ApiOfficeEmployeePersisted[];
  /** @format int32 */
  totalCount: number;
}

export interface ApiCreateRoleResponse {
  role: ApiRmpRole;
}

export type ApiDeleteRoleResponse = object;

export interface ApiRoleCanBeDeletedCheckResponse {
  canBeDeleted: boolean;
  blockers: ApiRoleDeletionBlockerType[];
}

/** @format int32 */
export enum ApiRoleDeletionBlockerType {
  Employee = 'Employee',
  Profile = 'Profile',
}

export interface ApiRolesResponse {
  roles: ApiRmpRole[];
  /** @format int32 */
  totalCount: number;
}

export interface ApiUpdateRoleAdditionalAuthorizedDivisionsResponse {
  role: ApiRmpRole;
}

export interface ApiUpdateRoleResponse {
  role: ApiRmpRole;
}

export interface ApiBranchesCounterpartyEnterpriseBranch {
  /** @format uuid */
  counterpartyId: string;
  /** @format uuid */
  enterpriseBranchId: string;
  isDefault: boolean;
}

export interface ApiBranchesCounterpartyEnterpriseBranchPersisted {
  /** @format uuid */
  id: string;
  counterpartyEnterpriseBranch: ApiBranchesCounterpartyEnterpriseBranch;
}

export type ApiEmployee = ApiOfficeEmployee & {
  /** @format uuid */
  divisionId: string;
  divisionName: string;
};

export interface ApiEmployeePersisted {
  /** @format uuid */
  id: string;
  /** @format int64 */
  number: number;
  employee: ApiEmployee;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface ApiOfficeEmployee {
  position: string;
  lastName: string;
  firstName: string;
  middleName?: string | null;
  inn?: string | null;
  snils?: string | null;
  email: string;
  phone?: string | null;
  description?: string | null;
  isActive: boolean;
  roles: ApiRmpRole[];
  canSignDocuments: boolean;
}

export interface ApiOfficeEmployeePersisted {
  /** @format uuid */
  id: string;
  /** @format int64 */
  number: number;
  employee: ApiOfficeEmployee | ApiEmployee;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

/** @format int32 */
export enum ApiCounterpartyBoatApplicationStatus {
  Created = 'Created',
  Approved = 'Approved',
  Declined = 'Declined',
}

/** @format int32 */
export enum ApiEnterprisePropertyType {
  Tugboat = 'Tugboat',
  Crewboat = 'Crewboat',
  FloatingCrane = 'FloatingCrane',
  Pier = 'Pier',
  Icebreaker = 'Icebreaker',
  EnvironmentalVessel = 'EnvironmentalVessel',
  HydrographicBoat = 'HydrographicBoat',
}

/** @format int32 */
export enum ApiServiceApplicationSubmissionDocumentKind {
  GraphicAnnex = 'GraphicAnnex',
  BuildingPermit = 'BuildingPermit',
  NatureInspectorateResolution = 'NatureInspectorateResolution',
  ChiefStateExpertise = 'ChiefStateExpertise',
  ProvidingWaterFacilityDecision = 'ProvidingWaterFacilityDecision',
  RosfishingConclusion = 'RosfishingConclusion',
}

/** @format int32 */
export enum ApiAgreementDefinitionSortingField {
  Name = 'Name',
  AmountLimit = 'AmountLimit',
  IsArchived = 'IsArchived',
  Id = 'Id',
}

export interface ApiCreateAdditionalServiceDefinitionRequest_AdditionalServiceDefinition {
  /** @format uuid */
  additionalServiceDefinitionId: string;
  comment?: string | null;
  isRequired: boolean;
}

export interface ApiGuaranteeLetterDefinitionForSave {
  /** @format uuid */
  serviceDefinitionId: string;
  /** @format double */
  limitAmount: number;
  templateName: string;
  /** @format uuid */
  templateFileId: string;
}

/** @format int32 */
export enum ApiGuaranteeLetterDefinitionSortingField {
  ServiceType = 'ServiceType',
  LimitAmount = 'LimitAmount',
  IsArchived = 'IsArchived',
  Id = 'Id',
}

/** @format int32 */
export enum ApiPublicOfferDefinitionSortingField {
  Name = 'Name',
  LimitAmount = 'LimitAmount',
  IsArchived = 'IsArchived',
  Id = 'Id',
}

export interface ApiServiceConfirmationDocumentSettingsForCreate {
  name: string;
  uploadRequired: boolean;
  multipleDocumentsAllowed: boolean;
}

export interface ApiServiceConfirmationDocumentSettingsForUpdate {
  name: string;
  uploadRequired: boolean;
  multipleDocumentsAllowed: boolean;
}

export interface ApiServiceDefinitionForCreate {
  name: string;
  nomenclatureCode: string;
  activityType: string;
  serviceType: ApiServiceType;
  /** @format uuid */
  divisionId: string;
  appliedDivisionIds: string[];
  /** @format uuid */
  serviceWorkflowId: string;
  portIds: string[];
  profile?: ApiServiceDefinitionProfile;
}

export interface ApiServiceDefinitionForUpdate {
  name: string;
  nomenclatureCode: string;
  activityType: string;
  portIds: string[];
  appliedDivisionIds: string[];
  profile: ApiServiceDefinitionProfile;
}

/** @format int32 */
export enum ApiServiceDefinitionSortingField {
  Name = 'Name',
  ServiceType = 'ServiceType',
  IsArchived = 'IsArchived',
  Id = 'Id',
}

/** @format int32 */
export enum ApiServicesTariffSortingField {
  Title = 'Title',
  Unit = 'Unit',
  UnitPrice = 'UnitPrice',
  AlgorithmTitle = 'AlgorithmTitle',
  ServiceType = 'ServiceType',
  PropertyName = 'PropertyName',
  DivisionName = 'DivisionName',
  Vat = 'Vat',
  IsArchived = 'IsArchived',
  CreatedAt = 'CreatedAt',
}

export interface ApiUpdateAdditionalServiceDefinitionRequest_AdditionalServiceDefinition {
  comment?: string | null;
  isRequired: boolean;
}

export interface ApiCreateAgreementDefinitionResponse {
  agreementDefinition: ApiServicesAgreementDefinition;
}

export interface ApiGetAgreementDefinitionByIdResponse {
  agreementDefinition: ApiServicesAgreementDefinition;
}

export interface ApiGetAgreementDefinitionsByDivisionIdResponse {
  agreementDefinition: ApiServicesAgreementDefinition[];
}

export interface ApiUpdateAgreementDefinitionResponse {
  agreementDefinition: ApiServicesAgreementDefinition;
}

export interface ApiCreateAdditionalServiceDefinitionResponse {
  serviceDefinitionRelation: ApiServiceDefinitionRelation;
}

export interface ApiServicesCreatePublicOfferResponse {
  publicOffer: ApiServicesPublicOffer;
}

export interface ApiCreateServiceConfirmationDocumentSettingsResponse {
  confirmationDocumentSettings: ApiServiceConfirmationDocumentSettings;
}

export interface ApiCreateServiceDefinitionResponse {
  serviceDefinition: ApiServiceDefinition;
}

export interface ApiGetAdditionalServiceDefinitionResponse {
  serviceDefinitionRelation: ApiServiceDefinitionRelation;
}

export interface ApiGetAdditionalServiceDefinitionsResponse {
  serviceDefinitionRelations: ApiServiceDefinitionRelation[];
}

export interface ApiServicesGetAgreementDefinitionWorkflowTransitionsResponse {
  transitions: ApiServicesAgreementWorkflowTransition[];
}

export interface ApiServicesGetRoleAgreementTransitionsResponse {
  transitions: ApiServicesGetRoleAgreementTransitionsResponse_TransitionRolesDto[];
}

export interface ApiServicesGetRoleAgreementTransitionsResponse_TransitionRolesDto {
  transition: ApiServicesAgreementWorkflowTransition;
  roleIds: number[];
}

export interface ApiGetServiceDefinitionProfileDefaultsResponse {
  profile: ApiServiceDefinitionProfile;
}

export interface ApiGetServiceDefinitionResponse {
  serviceDefinition: ApiServiceDefinition;
}

export interface ApiGetServiceDefinitionRoleTransitionsResponse {
  transitions: ApiServicesTransitionRolesDto[];
}

export interface ApiGetServiceDefinitionTransitionsResponse {
  transitions: ApiServiceWorkflowTransition[];
}

export interface ApiGetServiceDefinitionsResponse {
  serviceDefinitions: ApiServiceDefinition[];
}

export interface ApiServicesGetTariffAlgorithmsResponse {
  algorithms: ApiTariffAlgorithm[];
}

export interface ApiCreateGuaranteeLetterDefinitionResponse {
  guaranteeLetterDefinition: ApiServicesGuaranteeLetterDefinition;
}

export interface ApiGetGuaranteeLetterDefinitionByIdResponse {
  guaranteeLetterDefinition: ApiServicesGuaranteeLetterDefinition;
}

export interface ApiGetGuaranteeLetterDefinitionByServiceDefinitionIdResponse {
  guaranteeLetterDefinition: ApiServicesGuaranteeLetterDefinition;
}

export interface ApiGetGuaranteeLetterDefinitionsByDivisionIdResponse {
  guaranteeLetterDefinition: ApiServicesGuaranteeLetterDefinition[];
}

export interface ApiUpdateGuaranteeLetterDefinitionResponse {
  guaranteeLetterDefinition: ApiServicesGuaranteeLetterDefinition;
}

export interface ApiCreatePublicOfferDefinitionResponse {
  publicOfferDefinition: ApiServicesPublicOfferDefinition;
}

export interface ApiPublicOfferDefinitionsGetPublicOfferAcceptancesResponse {
  publicOfferAcceptances: ApiServicesPublicOfferAcceptance[];
  /** @format int32 */
  totalCount: number;
}

export interface ApiGetPublicOfferByPublicOfferDefinitionIdResponse {
  publicOffer: ApiServicesPublicOffer;
}

export interface ApiGetPublicOfferDefinitionByIdResponse {
  publicOfferDefinition: ApiServicesPublicOfferDefinition;
}

export interface ApiGetPublicOfferDefinitionsByDivisionIdResponse {
  publicOfferDefinition: ApiServicesPublicOfferDefinition[];
}

export interface ApiGetPublicOffersByPublicOfferDefinitionIdResponse {
  publicOffers: ApiServicesPublicOffer[];
}

export type ApiPublicOfferDefinitionsPublishPublicOfferResponse = object;

export type ApiPublicOfferDefinitionsSetPublicOfferFileResponse = object;

export interface ApiUpdatePublicOfferDefinitionResponse {
  publicOfferDefinition: ApiServicesPublicOfferDefinition;
}

export interface ApiToggleArchiveServiceDefinitionResponse {
  serviceDefinition: ApiServiceDefinition;
}

export interface ApiServicesTransitionRolesDto {
  transition: ApiServiceWorkflowTransition;
  roleIds: number[];
}

export interface ApiUpdateAdditionalServiceDefinitionResponse {
  serviceDefinitionRelation: ApiServiceDefinitionRelation;
}

export interface ApiUpdateServiceConfirmationDocumentSettingsResponse {
  confirmationDocumentSettings: ApiServiceConfirmationDocumentSettings;
}

export interface ApiUpdateServiceDefinitionResponse {
  serviceDefinition: ApiServiceDefinition;
}

export interface ApiServicesAgreementDefinition {
  /** @format uuid */
  id: string;
  name: string;
  /** @format uuid */
  divisionId: string;
  appliedDivisionIds: string[];
  portIds: string[] | null;
  serviceTypes: ApiServiceType[];
  /** @format double */
  amountLimit: number;
  isArchived: boolean;
}

/** @format int32 */
export enum ApiServicesAgreementWorkflowStateKind {
  New = 'New',
  Draft = 'Draft',
  Sent = 'Sent',
  Negotiated = 'Negotiated',
  FinallySignedByEnterprise = 'FinallySignedByEnterprise',
  FinallySignedByCounterparty = 'FinallySignedByCounterparty',
  Active = 'Active',
  NotActive = 'NotActive',
  Canceled = 'Canceled',
  Rejected = 'Rejected',
  Expired = 'Expired',
}

export interface ApiServicesAgreementWorkflowTransition {
  /** @format uuid */
  id: string;
  code: string;
  name: string;
  stateFrom: ApiServicesWorkflowState;
  stateTo: ApiServicesWorkflowState;
  executerType: ApiServicesAgreementWorkflowTransitionExecuterType;
  direction: ApiServicesWorkflowTransitionDirection;
}

/** @format int32 */
export enum ApiServicesAgreementWorkflowTransitionExecuterType {
  Enterprise = 'Enterprise',
  Counterparty = 'Counterparty',
}

export interface ApiServicesGuaranteeLetterDefinition {
  /** @format uuid */
  id: string;
  /** @format uuid */
  serviceDefinitionId: string;
  /** @format double */
  limitAmount: number;
  isArchived: boolean;
}

export interface ApiServicesPublicOffer {
  /** @format uuid */
  id: string;
  /** @format uuid */
  publicOfferDefinitionId: string;
  appliedDivisionIds: string[];
  /** @format uuid */
  fileId?: string | null;
  version: string;
  /** @format date */
  validFrom: string;
  /** @format date */
  validTo?: string | null;
  isPublished: boolean;
}

export interface ApiServicesPublicOfferAcceptance {
  /** @format uuid */
  serviceApplicationId: string;
  /** @format int64 */
  serviceApplicationNumber: number;
  /** @format uuid */
  counterpartyEmployeeId: string;
  /** @format uuid */
  serviceDefinitionId: string;
  /** @format uuid */
  portId: string;
  /** @format uuid */
  fileId: string;
  fileSha256: string;
  timeZone: string;
  noticeVersion: string;
  noticeText: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  publicOfferId: string;
  /** @format uuid */
  counterpartyId: string;
  employeeFullName: string;
  counterpartyFullName: string;
  counterpartyInn: string;
  serviceName: string;
  portName: string;
  mchdNumber?: string | null;
  publicOfferVersion: string;
  /** @format uuid */
  divisionId: string;
  /** @format date */
  serviceStartDate: string;
  /** @format time */
  serviceStartTime?: string | null;
  /** @format date-time */
  acceptedAt: string;
}

/** @format int32 */
export enum ApiServicesPublicOfferAcceptanceSortingField {
  EmployeeFullName = 'EmployeeFullName',
  CounterpartyFullName = 'CounterpartyFullName',
  CounterpartyInn = 'CounterpartyInn',
  ServiceName = 'ServiceName',
  PortName = 'PortName',
  MchdNumber = 'MchdNumber',
  ServiceStartDate = 'ServiceStartDate',
  AcceptedAt = 'AcceptedAt',
}

export interface ApiServicesPublicOfferDefinition {
  /** @format uuid */
  id: string;
  name: string;
  /** @format uuid */
  divisionId: string;
  appliedDivisionIds: string[];
  serviceTypes: ApiServiceType[];
  /** @format double */
  limitAmount: number;
  isArchived: boolean;
}

/** @format int32 */
export enum ApiServiceApplicationWorkflowTransitionKind {
  Complete = 'Complete',
  Cancel = 'Cancel',
  Reject = 'Reject',
  RequestCancellation = 'RequestCancellation',
  StartProviding = 'StartProviding',
  FinishProviding = 'FinishProviding',
  SignAccountingDocumentsByEnterprise = 'SignAccountingDocumentsByEnterprise',
  SubmitForPossibilityConfirmation = 'SubmitForPossibilityConfirmation',
  ConfirmPossibility = 'ConfirmPossibility',
  AssignResource = 'AssignResource',
  ScheduleService = 'ScheduleService',
  StartClosingDocumentsPreparation = 'StartClosingDocumentsPreparation',
  AttachAct = 'AttachAct',
  SignActByEnterprise = 'SignActByEnterprise',
  AttachAccountingDocuments = 'AttachAccountingDocuments',
  SignActByCounterparty = 'SignActByCounterparty',
  ApproveCancellation = 'ApproveCancellation',
  RejectCancellation = 'RejectCancellation',
  ReturnToProviding = 'ReturnToProviding',
  ReturnToProvided = 'ReturnToProvided',
  ReturnToClosingDocumentsPreparation = 'ReturnToClosingDocumentsPreparation',
  ReturnToActAttached = 'ReturnToActAttached',
  ReturnToActSignedByEnterprise = 'ReturnToActSignedByEnterprise',
  ReturnToAccountingDocumentsAttached = 'ReturnToAccountingDocumentsAttached',
}

/** @format int32 */
export enum ApiServiceBookingMode {
  None = 'None',
  Full = 'Full',
  Partial = 'Partial',
}

/** @format int32 */
export enum ApiServiceCapabilityRequirement {
  Disabled = 'Disabled',
  Optional = 'Optional',
  Required = 'Required',
}

export interface ApiServiceConfirmationDocumentSettings {
  /** @format uuid */
  id: string;
  /** @format uuid */
  serviceDefinitionId: string;
  name: string;
  uploadRequired: boolean;
  multipleDocumentsAllowed: boolean;
}

export interface ApiServiceDefinition {
  /** @format uuid */
  id: string;
  name: string;
  nomenclatureCode?: string | null;
  activityType?: string | null;
  serviceType: ApiServiceType;
  /** @format uuid */
  divisionId: string;
  appliedDivisionIds: string[];
  portIds: string[];
  isArchived: boolean;
  /** @format uuid */
  serviceWorkflowId: string;
  confirmationDocumentSettings?: ApiServiceConfirmationDocumentSettings;
  profile: ApiServiceDefinitionProfile;
}

export interface ApiServiceDefinitionProfile {
  tariffMode: ApiServiceTariffMode;
  applicationSubmissionCounterpartyBoatRequirement: ApiServiceCapabilityRequirement;
  fromTimeRequirement: ApiServiceCapabilityRequirement;
  tillTimeRequirement: ApiServiceCapabilityRequirement;
  supportedPropertyType?: ApiEnterprisePropertyType;
  destinationMode: ApiServiceDestinationMode;
  applicationSubmissionDocumentKinds: ApiServiceApplicationSubmissionDocumentKind[];
  applicationSubmissionDocumentsRequirement: ApiServiceCapabilityRequirement;
  bookingMode: ApiServiceBookingMode;
  serviceProvisionSpecialist: ApiServiceCapabilityRequirement;
  drinkingWaterBunkeringParameters: ApiServiceCapabilityRequirement;
}

export interface ApiServiceDefinitionRelation {
  /** @format uuid */
  id: string;
  /** @format uuid */
  serviceDefinitionId: string;
  additionalServiceDefinition: ApiServiceDefinitionRelation_ServiceDefinitionData;
  isRequired: boolean;
  comment?: string | null;
}

export interface ApiServiceDefinitionRelation_ServiceDefinitionData {
  /** @format uuid */
  id: string;
  name: string;
  serviceType: ApiServiceType;
}

/** @format int32 */
export enum ApiServiceDestinationMode {
  None = 'None',
  Catalog = 'Catalog',
  Custom = 'Custom',
}

/** @format int32 */
export enum ApiServiceTariffMode {
  None = 'None',
  Operation = 'Operation',
}

/** @format int32 */
export enum ApiServiceType {
  Undefined = 'Undefined',
  TugService = 'TugService',
  CrewBoatService = 'CrewBoatService',
  InformationService = 'InformationService',
  FloatingCraneService = 'FloatingCraneService',
  PierService = 'PierService',
  GeodeticHydrographicService = 'GeodeticHydrographicService',
  SnoInstallationService = 'SnoInstallationService',
  DredgingService = 'DredgingService',
  IcePilotService = 'IcePilotService',
  Consulting = 'Consulting',
  Icebreaking = 'Icebreaking',
  DeviationRemoval = 'DeviationRemoval',
  IndividualIcebreakerAssistance = 'IndividualIcebreakerAssistance',
  DrinkingWater = 'DrinkingWater',
  PilotTransfer = 'PilotTransfer',
  Ecological = 'Ecological',
  LinkspanBridge = 'LinkspanBridge',
}

export interface ApiServiceWorkflowState {
  /** @format uuid */
  id: string;
  name: string;
  alias: ApiServiceWorkflowStateKind;
}

/** @format int32 */
export enum ApiServiceWorkflowStateKind {
  Draft = 'Draft',
  Providing = 'Providing',
  Provided = 'Provided',
  AccountingDocumentsAttached = 'AccountingDocumentsAttached',
  Completed = 'Completed',
  Rejected = 'Rejected',
  CancellationRequested = 'CancellationRequested',
  PossibilityConfirmation = 'PossibilityConfirmation',
  PossibilityConfirmed = 'PossibilityConfirmed',
  ResourceAssigned = 'ResourceAssigned',
  Scheduled = 'Scheduled',
  Cancelled = 'Cancelled',
  ClosingDocumentsPreparation = 'ClosingDocumentsPreparation',
  ActAttached = 'ActAttached',
  ActSignedByEnterprise = 'ActSignedByEnterprise',
  AccountingDocumentsSignedByEnterprise = 'AccountingDocumentsSignedByEnterprise',
  ActSignedByCounterparty = 'ActSignedByCounterparty',
}

export interface ApiServiceWorkflowTransition {
  /** @format uuid */
  id: string;
  /** @deprecated */
  name: string;
  code: ApiServiceApplicationWorkflowTransitionKind;
  from: ApiServiceWorkflowState;
  to: ApiServiceWorkflowState;
  executerType: ApiServiceWorkflowTransitionExecuterType;
  direction: ApiServicesWorkflowTransitionDirection;
  requisites: ApiServiceWorkflowTransitionRequisite[];
}

/** @format int32 */
export enum ApiServiceWorkflowTransitionExecuterType {
  Enterprise = 'Enterprise',
  Counterparty = 'Counterparty',
}

export interface ApiServiceWorkflowTransitionRequisite {
  /** @format uuid */
  id: string;
  requisiteType: string;
}

export interface ApiTariffAlgorithm {
  /** @format uuid */
  id: string;
  title: string;
  description?: string | null;
  calculationNotice?: string | null;
  unit: ApiTariffsUnit;
  calculationBasis: ApiTariffCalculationBasis;
  serviceTypes: ApiServiceType[];
}

/** @format int32 */
export enum ApiTariffCalculationBasis {
  ManualQuantity = 'ManualQuantity',
  Duration = 'Duration',
  CounterpartyBoatConditionalVolume = 'CounterpartyBoatConditionalVolume',
  CounterpartyBoatDimensionDuration = 'CounterpartyBoatDimensionDuration',
  FixedRate = 'FixedRate',
}

/** @format int32 */
export enum ApiTariffsUnit {
  MeterPerDay = 'MeterPerDay',
  CubicMeter = 'CubicMeter',
  Hour = 'Hour',
  Month = 'Month',
  Day = 'Day',
  Item = 'Item',
  MeterPerHour = 'MeterPerHour',
}

/** @format int32 */
export enum ApiServicesVat {
  Vat0 = 'Vat0',
  Vat10 = 'Vat10',
  Vat20 = 'Vat20',
  Vat22 = 'Vat22',
  NoVat = 'NoVat',
}

export interface ApiServicesWorkflowState {
  /** @format uuid */
  id: string;
  name: string;
  code: ApiServicesAgreementWorkflowStateKind;
}

/** @format int32 */
export enum ApiServicesWorkflowTransitionDirection {
  Direct = 'Direct',
  Reverse = 'Reverse',
}

export type ApiFnsDisableUpToDateEntrepreneurResponse = ApiFnsUpToDateEntrepreneurResponseBase;

export type ApiFnsDisableUpToDateLegalEntityResponse = ApiFnsUpToDateLegalEntityResponseBase;

export type ApiFnsEnableUpToDateEntrepreneurResponse = ApiFnsUpToDateEntrepreneurResponseBase;

export type ApiFnsEnableUpToDateLegalEntityResponse = ApiFnsUpToDateLegalEntityResponseBase;

export type ApiFnsForceCheckUpToDateEntrepreneurResponse = ApiFnsUpToDateEntrepreneurResponseBase;

export type ApiFnsForceCheckUpToDateLegalEntityResponse = ApiFnsUpToDateLegalEntityResponseBase;

export interface ApiFnsUpToDateEntrepreneurResponseBase {
  inn: string;
  ogrn: string;
  /** @format uuid */
  externalId: string;
}

export interface ApiFnsUpToDateLegalEntityResponse {
  upToDateLegalEntityPersisted: ApiFnsUpToDateLegalEntityPersisted;
}

export interface ApiFnsUpToDateLegalEntityResponseBase {
  inn: string;
  ogrn: string;
  kpp: string;
  /** @format uuid */
  externalId: string;
}

export interface ApiFnsCounterpartyPersistedBase {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface ApiFnsUpToDateCounterparty {
  type: ApiCounterpartyType;
  /** @format uuid */
  externalId: string;
  isEnabled: boolean;
  /** @format date-time */
  lastChecked: string | null;
  /** @format date-time */
  lastUpdated: string | null;
}

export type ApiFnsUpToDateEntrepreneur = ApiFnsUpToDateCounterparty & {
  inn: string;
  ogrn: string;
};

export type ApiFnsUpToDateEntrepreneurPersisted = ApiFnsCounterpartyPersistedBase & {
  upToDateEntrepreneur: ApiFnsUpToDateEntrepreneur;
};

export type ApiFnsUpToDateLegalEntity = ApiFnsUpToDateCounterparty & {
  inn: string;
  ogrn: string;
  kpp: string;
};

export type ApiFnsUpToDateLegalEntityPersisted = ApiFnsCounterpartyPersistedBase & {
  upToDateLegalEntity: ApiFnsUpToDateLegalEntity;
};

export interface ApiHealthCheckResponse {
  harbourDuesDatabaseHealthChecks: ApiHealthCheckResponse_HarbourDuesDatabaseHealthCheck[];
}

export interface ApiHealthCheckResponse_HarbourDuesDatabaseHealthCheck {
  /** @format uuid */
  divisionId: string;
  connectionAvailable: boolean;
  errorMessage?: string | null;
}

export interface ApiHarbourDuesDivisionSettings {
  /** @format uuid */
  divisionId: string;
  isActive: boolean;
  /** @format date-time */
  updatedAtUtc: string;
}

export interface ApiIntegrationDispatchPortalDivisionSettings {
  /** @format uuid */
  divisionId: string;
  /** @format int32 */
  dispatchPortalFilialId: number;
  /** @format date-time */
  updatedAtUtc?: string | null;
  isActive: boolean;
}

export interface ApiIntegrationKonturDiadocGetCounterpartyEdoCandidatesResponse {
  candidates: ApiIntegrationKonturDiadocGetCounterpartyEdoCandidatesResponse_CounterpartyEdoCandidate[];
}

export interface ApiIntegrationKonturDiadocGetCounterpartyEdoCandidatesResponse_CounterpartyEdoCandidate {
  boxId: string;
  fnsParticipantId: string;
  name: string;
  kpp?: string | null;
}

export type ApiIntegrationKonturDiadocInviteCounterpartyResponse = object;

/** @format int32 */
export enum ApiIntegrationKonturDiadocCounteragentStatus {
  NotLinked = 'NotLinked',
  IsInvited = 'IsInvited',
  IsLinked = 'IsLinked',
}

export interface ApiIntegrationKonturDiadocCounterpartyLink {
  status: ApiIntegrationKonturDiadocCounteragentStatus;
  boxId: string;
  fnsParticipantId: string;
  /** @format date-time */
  lastVerifiedAt: string;
}

export interface ApiIntegrationKonturDiadocDivisionSettings {
  /** @format uuid */
  divisionId: string;
  diadocDepartmentId?: string | null;
  /** @format date-time */
  updatedAtUtc: string;
  isActive: boolean;
}

export interface ApiIntegrationOperationalApprovalDivisionSettings {
  /** @format uuid */
  divisionId: string;
  isActive: boolean;
  /** @format date-time */
  updatedAtUtc: string;
}

export interface ApiJcpCertificateData {
  name: string;
  issuer: string;
  friendlyName: string;
  serialNumber: string;
  signatureAlgorithm: string;
  thumbprint: string;
  subject: string;
  subjectAttributesByName: Record<string, string>;
  subjectAttributesByOid: Record<string, string>;
  issuerAttributesByName: Record<string, string>;
  issuerAttributesByOid: Record<string, string>;
  /** @format date-time */
  notAfter: string;
  /** @format date-time */
  notBefore: string;
  version: string;
  certificate: string;
}

export interface ApiCreateNotificationTemplateRequest_CreatedNotificationTemplate {
  subjectTemplate: string;
  bodyTemplate: string;
  layoutDataTemplate: string;
  /** @format uuid */
  divisionId: string;
  /** @format uuid */
  notificationDefinitionId: string;
  isActive: boolean;
}

export interface ApiUpdateNotificationTemplateRequest_UpdatedNotificationTemplate {
  subjectTemplate: string;
  bodyTemplate: string;
  layoutDataTemplate: string;
  isActive: boolean;
}

export interface ApiNotificationsCreateFooterTemplateResponse {
  footerTemplate: ApiNotificationsFooterTemplatePersisted;
}

export interface ApiCreateNotificationTemplateResponse {
  notificationTemplate: ApiNotificationTemplatePersisted;
}

export interface ApiNotificationsCreateRecipientRuleResponse {
  recipientRule: ApiRecipientRulePersisted;
}

export interface ApiGetNotificationDefinitionRecipientRuleResponse {
  recipientRule: ApiRecipientRulePersisted;
}

export interface ApiGetNotificationDefinitionTemplateOverridesResponse {
  defaultTemplateOverrides: {
    NotifyChangeAccountPassword: boolean;
    NotifyChangeAccountStatus: boolean;
    NotifyConfirmEmail: boolean;
    NotifyResetPassword: boolean;
    NotifyResetAccount: boolean;
    NotifyAccountRegistered: boolean;
    NotifyMasterAccountCounterpartyCreated: boolean;
    NotifyMasterAccountCounterpartyEmailChanged: boolean;
    NotifyMasterApplicationCounterpartyCreated: boolean;
    NotifyMasterApplicationCounterpartyRejected: boolean;
    NotifyMasterAccountAccessRequestByEds: boolean;
    NotifyMasterAccountAccessRequestBySubmittedDocuments: boolean;
    NotifyMasterAccountAccessRequestByEmployeeEmail: boolean;
    NotifyMasterAccountAccessRequestByNewEmailAndEds: boolean;
    NotifyMasterAccountAccessRequestByNewEmailAndSubmittedDocuments: boolean;
    NotifyCounterpartyAgreementStatusChanged: boolean;
    NotifyEnterpriseAgreementStatusChanged: boolean;
    NotifyEnterpriseAgreementChatMessageCreated: boolean;
    NotifyCounterpartyAgreementChatMessageCreated: boolean;
    NotifyCounterpartyCounterpartyBoatApplicationChatMessageCreated: boolean;
    NotifyEnterpriseCounterpartyBoatApplicationChatMessageCreated: boolean;
    NotifyEnterpriseServiceApplicationChatMessageCreated: boolean;
    NotifyCounterpartyServiceApplicationChatMessageCreated: boolean;
    NotifyCounterpartyDocumentArchived: boolean;
    NotifyCounterpartyDocumentUnarchived: boolean;
    NotifyCounterpartyDocumentCreated: boolean;
    NotifyCounterpartyEmployeeAssignedToAccountCreated: boolean;
    NotifyCounterpartyEmployeeCreated: boolean;
    NotifyOfficeEmployeeAssignedToAccountCreated: boolean;
    NotifyProfileActivationToggled: boolean;
    NotifyServiceTimeout: boolean;
    SendExpiredServicesEmailsToCounterparty: boolean;
    NotifyCounterpartyServiceApplicationTransitioned: boolean;
    NotifyEnterpriseServiceApplicationTransitioned: boolean;
    NotifyCounterpartyTrustAcceptCanceled: boolean;
    NotifyCounterpartyTrustAccepted: boolean;
    NotifyCounterpartyTrustCreated: boolean;
    NotifyCounterpartyTrustDeclined: boolean;
    NotifyCounterpartyBoatApplicationApproved: boolean;
    NotifyCounterpartyBoatApplicationDeclined: boolean;
    NotifyCounterpartyBoatApplicationCreated: boolean;
    NotifyOfficeEmployeeCreated: boolean;
    NotifyPublicOfferPublished: boolean;
  };
}

export interface ApiGetNotificationDefinitionTemplateResponse {
  notificationTemplate: ApiNotificationTemplatePersisted;
}

export interface ApiGetNotificationDefinitionTypesResponse {
  notificationDefinitions: ApiNotificationDefinitionPersisted[];
}

export interface ApiNotificationsInitDivisionRecipientRulesResponse {
  isSuccess: boolean;
}

export interface ApiResetNotificationTemplateResponse {
  defaultTemplate: ApiNotificationTemplatePersisted;
}

export interface ApiNotificationsUpdateFooterTemplateResponse {
  footerTemplate: ApiNotificationsFooterTemplatePersisted;
}

export interface ApiUpdateNotificationTemplateResponse {
  notificationTemplate: ApiNotificationTemplatePersisted;
}

export interface ApiNotificationsUpdateRecipientRuleResponse {
  recipientRule: ApiRecipientRulePersisted;
}

export interface ApiNotificationsFooterTemplate {
  bodyTemplate: string;
  layoutDataTemplate: string;
  /** @format uuid */
  divisionId?: string | null;
}

export interface ApiNotificationsFooterTemplatePersisted {
  /** @format uuid */
  id: string;
  footerTemplate: ApiNotificationsFooterTemplate;
}

export interface ApiNotificationDefinition {
  commandCode: ApiNotificationDefinitionType;
  name: string;
  recipientType: ApiNotificationsRecipientType;
}

export interface ApiNotificationDefinitionPersisted {
  /** @format uuid */
  id: string;
  notificationDefinition: ApiNotificationDefinition;
}

/** @format int32 */
export enum ApiNotificationDefinitionType {
  NotifyChangeAccountPassword = 'NotifyChangeAccountPassword',
  NotifyChangeAccountStatus = 'NotifyChangeAccountStatus',
  NotifyConfirmEmail = 'NotifyConfirmEmail',
  NotifyResetPassword = 'NotifyResetPassword',
  NotifyResetAccount = 'NotifyResetAccount',
  NotifyAccountRegistered = 'NotifyAccountRegistered',
  NotifyMasterAccountCounterpartyCreated = 'NotifyMasterAccountCounterpartyCreated',
  NotifyMasterAccountCounterpartyEmailChanged = 'NotifyMasterAccountCounterpartyEmailChanged',
  NotifyMasterApplicationCounterpartyCreated = 'NotifyMasterApplicationCounterpartyCreated',
  NotifyMasterApplicationCounterpartyRejected = 'NotifyMasterApplicationCounterpartyRejected',
  NotifyMasterAccountAccessRequestByEds = 'NotifyMasterAccountAccessRequestByEds',
  NotifyMasterAccountAccessRequestBySubmittedDocuments = 'NotifyMasterAccountAccessRequestBySubmittedDocuments',
  NotifyMasterAccountAccessRequestByEmployeeEmail = 'NotifyMasterAccountAccessRequestByEmployeeEmail',
  NotifyMasterAccountAccessRequestByNewEmailAndEds = 'NotifyMasterAccountAccessRequestByNewEmailAndEds',
  NotifyMasterAccountAccessRequestByNewEmailAndSubmittedDocuments = 'NotifyMasterAccountAccessRequestByNewEmailAndSubmittedDocuments',
  NotifyCounterpartyAgreementStatusChanged = 'NotifyCounterpartyAgreementStatusChanged',
  NotifyEnterpriseAgreementStatusChanged = 'NotifyEnterpriseAgreementStatusChanged',
  NotifyEnterpriseAgreementChatMessageCreated = 'NotifyEnterpriseAgreementChatMessageCreated',
  NotifyCounterpartyAgreementChatMessageCreated = 'NotifyCounterpartyAgreementChatMessageCreated',
  NotifyCounterpartyCounterpartyBoatApplicationChatMessageCreated = 'NotifyCounterpartyCounterpartyBoatApplicationChatMessageCreated',
  NotifyEnterpriseCounterpartyBoatApplicationChatMessageCreated = 'NotifyEnterpriseCounterpartyBoatApplicationChatMessageCreated',
  NotifyEnterpriseServiceApplicationChatMessageCreated = 'NotifyEnterpriseServiceApplicationChatMessageCreated',
  NotifyCounterpartyServiceApplicationChatMessageCreated = 'NotifyCounterpartyServiceApplicationChatMessageCreated',
  NotifyCounterpartyDocumentArchived = 'NotifyCounterpartyDocumentArchived',
  NotifyCounterpartyDocumentUnarchived = 'NotifyCounterpartyDocumentUnarchived',
  NotifyCounterpartyDocumentCreated = 'NotifyCounterpartyDocumentCreated',
  NotifyCounterpartyEmployeeAssignedToAccountCreated = 'NotifyCounterpartyEmployeeAssignedToAccountCreated',
  NotifyCounterpartyEmployeeCreated = 'NotifyCounterpartyEmployeeCreated',
  NotifyOfficeEmployeeAssignedToAccountCreated = 'NotifyOfficeEmployeeAssignedToAccountCreated',
  NotifyProfileActivationToggled = 'NotifyProfileActivationToggled',
  NotifyServiceTimeout = 'NotifyServiceTimeout',
  SendExpiredServicesEmailsToCounterparty = 'SendExpiredServicesEmailsToCounterparty',
  NotifyCounterpartyServiceApplicationTransitioned = 'NotifyCounterpartyServiceApplicationTransitioned',
  NotifyEnterpriseServiceApplicationTransitioned = 'NotifyEnterpriseServiceApplicationTransitioned',
  NotifyCounterpartyTrustAcceptCanceled = 'NotifyCounterpartyTrustAcceptCanceled',
  NotifyCounterpartyTrustAccepted = 'NotifyCounterpartyTrustAccepted',
  NotifyCounterpartyTrustCreated = 'NotifyCounterpartyTrustCreated',
  NotifyCounterpartyTrustDeclined = 'NotifyCounterpartyTrustDeclined',
  NotifyCounterpartyBoatApplicationApproved = 'NotifyCounterpartyBoatApplicationApproved',
  NotifyCounterpartyBoatApplicationDeclined = 'NotifyCounterpartyBoatApplicationDeclined',
  NotifyCounterpartyBoatApplicationCreated = 'NotifyCounterpartyBoatApplicationCreated',
  NotifyOfficeEmployeeCreated = 'NotifyOfficeEmployeeCreated',
  NotifyPublicOfferPublished = 'NotifyPublicOfferPublished',
}

export interface ApiNotificationTemplate {
  notificationDefinitionType: ApiNotificationDefinitionType;
  recipientType: ApiNotificationsRecipientType;
  subjectTemplate: string;
  bodyTemplate: string;
  layoutDataTemplate: string;
  /** @format uuid */
  divisionId?: string | null;
  /** @format uuid */
  notificationDefinitionId: string;
  notificationDefinitionName: string;
  isActive: boolean;
}

export interface ApiNotificationTemplatePersisted {
  /** @format uuid */
  id: string;
  notificationTemplate: ApiNotificationTemplate;
}

export type ApiAgreementTransitionFilter = ApiRecipientFilterBase & {
  agreementTransitionRules: ApiAgreementTransitionRule[];
};

export interface ApiAgreementTransitionRule {
  /** @format uuid */
  agreementDefinitionId: string;
  workflowTransitionRoles: ApiAgreementWorkflowTransitionRolesLink[];
}

export interface ApiAgreementWorkflowTransitionRolesLink {
  stateFrom: string;
  stateTo: string;
  direction: ApiServicesWorkflowTransitionDirection;
  enterpriseRoleIds: number[];
}

export type ApiCounterpartyChatMessageFilter = ApiRecipientFilterBase & {
  counterpartyChatMessageRules: ApiCounterpartyChatMessageRule[];
};

export interface ApiCounterpartyChatMessageRule {
  status: ApiCounterpartyBoatApplicationStatus;
  enterpriseRoleIds: number[];
}

export type ApiCounterpartyBoatApplicationTransitionFilter = ApiRecipientFilterBase & {
  counterpartyBoatApplicationTransitionRules: ApiCounterpartyBoatApplicationTransitionRule[];
};

export interface ApiCounterpartyBoatApplicationTransitionRule {
  status: ApiCounterpartyBoatApplicationStatus;
  enterpriseRoleIds: number[];
}

export type ApiRecipientFilterBase = object;

export type ApiRolesRecipientFilter = ApiRecipientFilterBase & {
  enterpriseRoleIds: number[];
};

export type ApiServiceApplicationTransitionFilter = ApiRecipientFilterBase & {
  serviceApplicationTransitionRules: ApiServiceApplicationTransitionRule[];
};

export interface ApiServiceApplicationTransitionRule {
  /** @format uuid */
  serviceDefinitionId: string;
  workflowTransitionRoles: ApiServiceApplicationWorkflowTransitionRolesLink[];
}

export interface ApiServiceApplicationWorkflowTransitionRolesLink {
  stateFrom: string;
  stateTo: string;
  direction: ApiServicesWorkflowTransitionDirection;
  enterpriseRoleIds: number[];
}

export interface ApiNotificationsRecipientRuleBase {
  /** @format uuid */
  divisionId?: string | null;
  /** @format uuid */
  notificationDefinitionId: string;
}

/** @format int32 */
export enum ApiNotificationsRecipientType {
  TargetUser = 'TargetUser',
  CounterpartyEmployees = 'CounterpartyEmployees',
  EnterpriseEmployees = 'EnterpriseEmployees',
}

export type ApiCounterpartyEmployeeRecipientRule = ApiNotificationsRecipientRuleBase;

export type ApiEnterpriseEmployeeRecipientRule = ApiNotificationsRecipientRuleBase & {
  recipientFilter?:
    | ApiRolesRecipientFilter
    | ApiServiceApplicationTransitionFilter
    | ApiCounterpartyBoatApplicationTransitionFilter
    | ApiCounterpartyChatMessageFilter
    | ApiAgreementTransitionFilter
    | null;
};

export interface ApiRecipientRulePersisted {
  /** @format uuid */
  id: string;
  recipientRule:
    | ApiCounterpartyEmployeeRecipientRule
    | ApiEnterpriseEmployeeRecipientRule
    | ApiTargetUserRecipientRule;
}

export type ApiTargetUserRecipientRule = ApiNotificationsRecipientRuleBase;

export interface ApiPortFeesDivisionSettings {
  /** @format uuid */
  divisionId: string;
  isActive: boolean;
  /** @format date-time */
  updatedAtUtc: string;
}

export interface ApiRadiusDivisionSettings {
  /** @format uuid */
  divisionId: string;
  isActive: boolean;
  /** @format date-time */
  updatedAtUtc: string;
}

export interface ApiRmpRole {
  /** @format int32 */
  id: number;
  name: string;
  /** @format uuid */
  divisionId: string;
  isArchived: boolean;
  /** @format date-time */
  createdAt: string;
  additionalAuthorizedDivisionIds: string[];
}

/** @format int32 */
export enum ApiServiceRequestsMasterApplicationsSortingField {
  Id = 'Id',
  MasterAccountRequestStatus = 'MasterAccountRequestStatus',
  RequestorEmail = 'RequestorEmail',
  CreatedAt = 'CreatedAt',
  UpdatedAt = 'UpdatedAt',
  Inn = 'Inn',
  Ogrn = 'Ogrn',
  Kpp = 'Kpp',
  LongName = 'LongName',
  ShortName = 'ShortName',
  Snils = 'Snils',
  FirstName = 'FirstName',
  MiddleName = 'MiddleName',
  LastName = 'LastName',
  Status = 'Status',
}

export interface ApiServiceRequestsGetMasterApplicationsRequestResponse {
  requests: (
    | ApiServiceRequestsMasterApplicationPersistedEntrepreneur
    | ApiServiceRequestsMasterApplicationPersistedLegalEntity
  )[];
  /** @format int32 */
  totalCount: number;
}

/** @format int32 */
export enum ApiCounterpartyApplicationApplicationType {
  Unknown = 'Unknown',
  InitialWithDocumentsVerification = 'InitialWithDocumentsVerification',
  InitialWithHeadDigitalSignature = 'InitialWithHeadDigitalSignature',
  RepeatWithEmployeeEmail = 'RepeatWithEmployeeEmail',
  RepeatWithMasterAccountEmail = 'RepeatWithMasterAccountEmail',
  RepeatWithNewEmailAndDocuments = 'RepeatWithNewEmailAndDocuments',
  RepeatWithNewEmailAndHeadSignature = 'RepeatWithNewEmailAndHeadSignature',
  ManualMasterAccountCreation = 'ManualMasterAccountCreation',
}

/** @format int32 */
export enum ApiCounterpartyApplicationStatus {
  Undefined = 'Undefined',
  Created = 'Created',
  Approved = 'Approved',
  Rejected = 'Rejected',
}

export interface ApiServiceRequestsMasterApplicationPersistedBase {
  /** @format uuid */
  id: string;
  requestorEmail: string;
  documentIds: string[];
  /** @format uuid */
  divisionId: string;
  status: ApiServiceRequestsMasterApplicationStatus;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  type: ApiCounterpartyType;
  applicationType?: ApiCounterpartyApplicationApplicationType;
  reviewComment?: string | null;
  /** @format uuid */
  reviewedByEmployeeId?: string | null;
}

export type ApiServiceRequestsMasterApplicationPersistedEntrepreneur = UtilRequiredKeys<
  ApiServiceRequestsMasterApplicationPersistedBase,
  'type'
> & {
  entrepreneur: ApiEntrepreneur;
  type: ApiCounterpartyType;
};

export type ApiServiceRequestsMasterApplicationPersistedLegalEntity = UtilRequiredKeys<
  ApiServiceRequestsMasterApplicationPersistedBase,
  'type'
> & {
  legalEntity: ApiLegalEntity;
  type: ApiCounterpartyType;
};

/** @format int32 */
export enum ApiServiceRequestsMasterApplicationStatus {
  Undefined = 'Undefined',
  Created = 'Created',
  Approved = 'Approved',
  Rejected = 'Rejected',
}

export type ApiCreateTrustRequest = ApiTrustBase & {
  /** @format uuid */
  fileId: string;
};

export interface ApiTrustResponse {
  trust: ApiTrustPersisted;
}

export interface ApiTrustsResponse {
  trusts: ApiTrustPersisted[];
  /** @format int32 */
  totalCount: number;
}

export interface ApiUpdatedTrustsResponse {
  trusts: ApiTrustPersisted[];
}

export type ApiTrust = ApiTrustBase & {
  /** @format uuid */
  fileId: string;
  isSigned: boolean;
  /** @format date-time */
  uploadedAt: string;
  /** @format date-time */
  acceptedAt?: string | null;
  /** @format uuid */
  acceptorOfficeEmployeeId?: string | null;
  /** @format uuid */
  acceptorCounterpartyEmployeeId?: string | null;
  /** @format date-time */
  declinedAt?: string | null;
  /** @format uuid */
  declinerOfficeEmployeeId?: string | null;
  /** @format uuid */
  declinerCounterpartyEmployeeId?: string | null;
  /** @format date-time */
  canceledAt?: string | null;
  /** @format uuid */
  cancellerOfficeEmployeeId?: string | null;
  /** @format uuid */
  cancellerCounterpartyEmployeeId?: string | null;
  status: ApiTrustStatus;
  declineReason?: string | null;
};

export interface ApiTrustBase {
  /** @format uuid */
  counterpartyId: string;
  /** @format uuid */
  divisionId?: string | null;
  /** @format uuid */
  trusteeEmployeeId: string;
  trusteeSnils: string;
  trusteeInn?: string | null;
  /** @format date */
  expireAt: string;
}

export interface ApiTrustPersisted {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  trust: ApiTrust;
}

/** @format int32 */
export enum ApiTrustStatus {
  Undefined = 'Undefined',
  Created = 'Created',
  Accepted = 'Accepted',
  Declined = 'Declined',
}

/** Данные пользователя */
export interface ApiHelpersUserData {
  /** @format uuid */
  accountId: string;
  /** @format uuid */
  profileId?: string | null;
}

export interface ApiDtoChangeAccountEmailRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface ApiDtoChangeAccountPasswordRequest {
  /** @minLength 1 */
  password: string;
}

/** Изменение статуса аккаунта */
export interface ApiDtoChangeAccountStatusRequest {
  isActive: boolean;
}

export interface ApiDtoCheckEmailRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface ApiCreateAgreementDefinition_CreatingAgreementDefinition {
  /**
   * Наименование вида договора
   * @example "Договор на оказание буксирных услуг"
   */
  name: string;
  /**
   * Идентификатор подразделения, к которому юридически относится договор
   * @format uuid
   */
  divisionId: string;
  /** Подразделения, в которых также действует договор */
  appliedDivisionIds: string[];
  /** Идентификаторы портов, в которых действует шаблон договора. Null означает все порты оказывающего подразделения */
  portIds: string[] | null;
  /** Типы услуг, которые покрывает договор */
  serviceTypes: ApiServiceType[];
  /**
   * Лимит суммы по договору
   * @format double
   */
  amountLimit: number;
}

export interface ApiAgreementDefinitionsCreateAgreementDocumentTemplate_AgreementDocumentTemplate {
  /**
   * Наименование шаблона
   * @example "Договор на оказание буксирных услуг"
   */
  name: string;
  /**
   * Идентификатор файла шаблона
   * @format uuid
   */
  fileId: string;
}

export interface ApiAgreementDefinitionsSetAgreementTransitionPermissionRoles_Request_Payload {
  enterpriseRoleIds: number[];
  /** @format uuid */
  workflowTransitionId: string;
}

export interface ApiUpdateAgreementDefinition_UpdatingAgreementDefinition {
  /** Наименование вида договора */
  name: string;
  /** Точные идентификаторы подразделений, для которых шаблон договора отображается в списках. */
  appliedDivisionIds: string[];
  /** Идентификаторы портов, в которых действует шаблон договора. Null означает все порты оказывающего подразделения */
  portIds: string[] | null;
}

export interface ApiCreateChatBody {
  /**
   * Источник чата
   * @format uuid
   */
  sourceId: string;
  sourceKind: ApiChatSourceKind;
}

export interface ApiChatCreateMessage {
  /** Сообщение */
  message: string;
}

export interface ApiEntepriseBranchesCreateCounterpartyEnterpriseBranches_CreateEnterpriseBranch {
  /** Идентификаторы филиалов предприятия */
  enterpriseBranchIds: string[];
  /**
   * Идентификатор филиала предприятия по умолчанию
   * @format uuid
   */
  defaultEnterpriseBranchId?: string | null;
}

export interface ApiEntrepreneursCheckAccountWithEmailExists_Request {
  employerIdentifiers: ApiCounterpartiesIdentifiersEntrepreneur;
  email: string;
}

export interface ApiCheckEntrepreneurProfileByIdentifiers_Request {
  /**
   * ИНН
   * @minLength 1
   */
  inn: string;
  /**
   * ОГРНИП
   * @minLength 1
   */
  ogrnIp: string;
}

export interface ApiDtoDeclineTrustRequest {
  /**
   * @minLength 0
   * @maxLength 250
   */
  declineReason: string;
}

export interface ApiGenericCounterpartiesSaveCounterpartyEdoSettings_Request_Payload {
  boxId: string;
}

export interface ApiGenericCounterpartiesSetServiceApplicationNotificationsEmployeeSettings_Request_Data {
  serviceApplicationCreatedByRecipient: ApiCounterpartyEmployeesServiceApplicationCreatedByRecipientNotificationSettingKind;
  serviceApplicationStatusChanges: ApiCounterpartyEmployeesServiceApplicationStatusChangesNotificationSettingKind;
  /** Флаг — хочет ли сотрудник получать уведомления */
  receiveNotifications: boolean;
}

export interface ApiLegalEntitiesCheckAccountWithEmailExists_Request {
  legalEntityIdentifiers: ApiCounterpartiesIdentifiersLegalEntity;
  email: string;
}

export interface ApiCheckLegalEntityProfileByIdentifiers_Request {
  /**
   * ИНН
   * @minLength 1
   */
  inn: string;
  /**
   * ОГРН
   * @minLength 1
   */
  ogrn: string;
  /**
   * КПП
   * @minLength 1
   */
  kpp: string;
}

export type ApiDiagnosticGetHarbourduesHealthCheck_Request = object;

export interface ApiAxaptaUpdateSettings_Request_Payload {
  isActive: boolean;
}

export interface ApiDiadocUpdateSettings_Request_Payload {
  diadocDepartmentId: string | null;
  isActive: boolean;
}

export interface ApiHarborDuesUpdateSettings_Request_Payload {
  isActive: boolean;
}

export interface ApiOperationalApprovalUpdateSettings_Request_Payload {
  isActive: boolean;
}

export interface ApiPortFeesUpdateSettings_Request_Payload {
  isActive: boolean;
}

export interface ApiRadiusUpdateSettings_Request_Payload {
  isActive: boolean;
}

export interface ApiDivisionsAssignInvoiceDocumentTemplate_InvoiceDocumentTemplate {
  /**
   * Идентификатор шаблона документа
   * @format uuid
   */
  documentTemplateId: string;
}

export interface ApiCreateDivisionBranchBasin_CreatingDivisionBranchBasin {
  /** Сокращенное имя */
  shortName: string;
  /** Актуальный адрес */
  actualAddress: string;
  /** КПП */
  kpp?: string | null;
  /** Может ли подразделение выступать оказывающим подразделением. */
  canActAsServiceProvider: boolean;
  /**
   * Идентификатор родительской сущности
   * @format uuid
   */
  parentId: string;
  /** Полное имя */
  fullName: string;
  /** Код */
  code: string;
  /** IANA-идентификатор часового пояса */
  timeZone: string;
}

export interface ApiCreateDivisionDepartment_CreatingDivisionDepartment {
  /**
   * Идентификатор родительской сущности
   * @format uuid
   */
  parentId: string;
  /** Сокращенное имя */
  shortName: string;
  /** Актуальный адрес */
  actualAddress: string;
  /** КПП */
  kpp?: string | null;
  /** Может ли подразделение выступать оказывающим подразделением. */
  canActAsServiceProvider: boolean;
  /** Полное имя */
  fullName: string;
  /** Код */
  code: string;
  /** IANA-идентификатор часового пояса */
  timeZone: string;
}

export interface ApiCreateDivisionPort_CreatingDivisionPort {
  /**
   * Идентификатор родительской сущности
   * @format uuid
   */
  parentId: string;
  /**
   * Широта
   * @format double
   */
  latitude: number;
  /**
   * Долгота
   * @format double
   */
  longitude: number;
  /** Полное имя */
  fullName: string;
  /** Код */
  code: string;
  /** IANA-идентификатор часового пояса */
  timeZone: string;
}

export interface ApiGetDivisionBranchBasinList_Response {
  items: ApiDivisionBranchBasinPersisted[];
  /** @format int32 */
  totalCount: number;
}

export interface ApiGetDivisionDepartmentList_Response {
  items: ApiDivisionDepartmentPersisted[];
  /** @format int32 */
  totalCount: number;
}

export interface ApiGetDivisionPortList_Response {
  items: ApiDivisionPortPersisted[];
  /** @format int32 */
  totalCount: number;
}

export interface ApiGetDivisionStructure_Response {
  head: ApiDivisionHeadPersisted;
  /** Список филиалов */
  branches: ApiDivisionBranchBasinPersisted[];
  /** Список управлений */
  departments: ApiDivisionDepartmentPersisted[];
  /** Список портов */
  ports: ApiDivisionPortPersisted[];
}

export interface ApiUpdateDivisionDispatchPortalSettings_Request_Payload {
  /** @format int32 */
  dispatchPortalFilialId: number;
  isActive: boolean;
}

export interface ApiCreateDocumentTemplate_DocumentTemplate {
  /** Наименование шаблона */
  name: string;
  /**
   * Идентификатор файла шаблона
   * @format uuid
   */
  fileId: string;
}

export interface ApiValidateGuaranteeLetterDefinitionDocumentTemplate_DocumentTemplate {
  /**
   * Идентификатор файла шаблона
   * @format uuid
   */
  fileId: string;
}

export interface ApiJcpGetSignersCertificates_Request {
  /**
   * Подпись
   * @minLength 1
   */
  signature: string;
}

export interface ApiMaintenanceSeed_Request_Payload {
  enterprise: ApiMaintenanceSeed_Request_Payload_EnterpriseSeed;
  enterpriseServices: ApiMaintenanceSeed_Request_Payload_EnterpriseServicesSeed;
}

export interface ApiMaintenanceSeed_Request_Payload_EnterpriseSeed {
  divisions: boolean;
  roles: boolean;
}

export interface ApiMaintenanceSeed_Request_Payload_EnterpriseServicesSeed {
  services: ApiMaintenanceSeed_Request_Payload_EnterpriseServicesSeed_ServicesSeed;
  enterprise: ApiMaintenanceSeed_Request_Payload_EnterpriseServicesSeed_EnterpriseSeed;
}

export interface ApiMaintenanceSeed_Request_Payload_EnterpriseServicesSeed_EnterpriseSeed {
  properties: boolean;
  divisionsProperties: boolean;
}

export interface ApiMaintenanceSeed_Request_Payload_EnterpriseServicesSeed_ServicesSeed {
  tariffs: boolean;
  serviceDefinitions: boolean;
  serviceTransitionPermissions: boolean;
  globalAdminServiceTransitionPermissions: boolean;
  agreementDefinitions: boolean;
  agreementTransitionPermissions: boolean;
  rolesAgreementTransitionPermissions: boolean;
  globalAdminAgreementTransitionPermissions: boolean;
}

export type ApiMaintenanceUpdateTotalAmounts_Request = object;

export interface ApiGetMasterApplicationById_Response {
  /** Заявка */
  masterApplication:
    | ApiServiceRequestsMasterApplicationPersistedEntrepreneur
    | ApiServiceRequestsMasterApplicationPersistedLegalEntity;
  employee?: ApiEmployee;
}

export type ApiOfficesGetOwnEmployee_Request = object;

export interface ApiPermissionsAuthorizeServiceTransition_Request_Payload {
  serviceType: ApiServiceType;
  transition: ApiServiceApplicationWorkflowTransitionKind;
  /** @format uuid */
  serviceApplicationId: string;
}

export interface ApiPermissionsCreateDivisionRole_Request_RoleDto {
  /** Название роли */
  name: string;
  /** Дополнительные подразделения, в которых действует роль */
  additionalAuthorizedDivisionIds: string[];
}

export interface ApiGetDivisionRolePermissions_Response {
  /** Разрешения */
  permissions: ApiAuthorizationPermissionEnum[];
}

export type ApiGetPermissionRole_Request = object;

export type ApiGetPermissions_Request = object;

export interface ApiPermissionsUpdateDivisionRoleAdditionalAuthorizedDivisions_Body {
  /** Дополнительные подразделения, в которых действует роль */
  additionalAuthorizedDivisionIds: string[];
}

export interface ApiPermissionsUpdateDivisionRole_Request_RoleDto {
  /** Название роли */
  name: string;
  /** Дополнительные подразделения, в которых действует роль */
  additionalAuthorizedDivisionIds: string[];
}

export type ApiGetProfilesByToken_Request = object;

export interface ApiProfilesToggleSignatureRequired_Request_Payload {
  isSignatureRequired: boolean;
}

export interface ApiCreatePublicOfferDefinitionDocumentTemplate_PublicOfferDefinitionDocumentTemplate {
  /**
   * Наименование шаблона
   * @example "Публичная оферта на оказание буксирных услуг"
   */
  name: string;
  /**
   * Идентификатор файла шаблона
   * @format uuid
   */
  fileId: string;
}

export interface ApiCreatePublicOfferDefinition_CreatingPublicOfferDefinition {
  /**
   * Наименование вида публичной оферты
   * @example "Публичная оферта на оказание буксирных услуг"
   */
  name: string;
  /**
   * Идентификатор подразделения, к которому юридически относится публичная оферта
   * @format uuid
   */
  divisionId: string;
  /** Подразделения, в которых также действует публичная оферта */
  appliedDivisionIds: string[];
  /** Типы услуг, которые покрывает публичная оферта */
  serviceTypes: ApiServiceType[];
  /**
   * Лимит на одну заявку
   * @format double
   */
  limitAmount: number;
}

export interface ApiUpdatePublicOfferDefinition_UpdatingPublicOfferDefinition {
  /** Наименование вида публичной оферты */
  name: string;
  /** Точные идентификаторы подразделений, для которых шаблон публичной оферты отображается в списках. */
  appliedDivisionIds: string[];
}

export interface ApiServiceDefinitionsCreateServiceConfirmationDocumentTemplate_DocumentTemplate {
  /**
   * Наименование шаблона
   * @example "Подтверждающий документ оказания буксирных услуг"
   */
  name: string;
  /**
   * Идентификатор файла шаблона
   * @format uuid
   */
  fileId: string;
}

export interface ApiGetServiceDefinitionTariffs_Response {
  /** @format int32 */
  totalCount: number;
  tariffs: ApiGetServiceDefinitionTariffs_ServiceDefinitionTariffData[];
}

export interface ApiGetServiceDefinitionTariffs_ServiceDefinitionTariffData {
  /** @format uuid */
  id: string;
  title: string;
  /** @format double */
  unitPrice: number | null;
  unit: ApiTariffsUnit;
  vat: ApiServicesVat;
  algorithmTitle: string;
  propertyName: string;
  isArchived: boolean;
}

export interface ApiSetServiceDefinitionTransitionPermissionRoles_Request_Payload {
  enterpriseRoleIds: number[];
  /** @format uuid */
  serviceDefinitionId: string;
  /** @format uuid */
  serviceWorkflowTransitionId: string;
}

/** @format int32 */
export enum ApiGetTrustActioner_ActionerKind {
  Acceptor = 'Acceptor',
  Canceller = 'Canceller',
  Decliner = 'Decliner',
}

export interface ApiTrustsPostMchd_MchdCreateDto {
  /** @format uuid */
  counterpartyEmployeeId: string;
  mainDto: ApiRestMainDto;
}

export type ApiUtilUpdateDivisionId_Request = object;

export interface ApiDtoCounterpartyEmployeePersistedWithTrustInfo {
  employee:
    | ApiCounterpartyEmployeePersistedEntrepreneur
    | ApiCounterpartyEmployeePersistedLegalEntity;
  trust: ApiDtoTrustInfo;
}

/** Ответ обработки запроса сотрудников организации (по Id контрагента) */
export interface ApiDtoCounterpartyEmployeesWithTrustInfo {
  /** Данные сотрудников организации */
  employees: ApiDtoCounterpartyEmployeePersistedWithTrustInfo[];
}

export interface ApiTrustActionerDto {
  fullname?: string | null;
}

export interface ApiDtoTrustInfo {
  status: ApiDtoTrustUiStatus;
}

/** @format int32 */
export enum ApiDtoTrustUiStatus {
  Absent = 'Absent',
  Review = 'Review',
  Active = 'Active',
  Rejected = 'Rejected',
  Outdated = 'Outdated',
}

export interface ApiCounterpartiesCheckExistsDto {
  exists: boolean;
}

export interface ApiCreateCounterpartyProfileDto {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface ApiMasterAccountApprovedMasterApplication {
  status: ApiCounterpartyApplicationStatus;
}

export interface ApiMasterAccountMasterApplicationEdsCreateDto {
  /**
   * закодированный в Base64 json представляющий dto
   * @minLength 1
   */
  data: string;
  /**
   * Подпись. base64 строка
   * @minLength 1
   */
  signature: string;
  /**
   * Идентификатор филиала
   * @format uuid
   */
  divisionId: string;
}

export interface ApiMasterAccountMasterApplicationEntrepreneurByEmployeeDto {
  entrepreneur: ApiEgrulEgripEntrepreneur;
  /**
   * Электронная почта сотрудника
   * @format email
   * @minLength 1
   * @example "pupkin_vi@email.ru"
   */
  email: string;
}

export interface ApiMasterAccountMasterApplicationEntrepreneurCreateDto {
  /**
   * Электронная почта
   * @format email
   * @minLength 1
   * @example "pupkin_vi@email.ru"
   */
  email: string;
  /** Идентификаторы файлов документов */
  documents: string[];
  /**
   * Идентификатор филиала
   * @format uuid
   */
  divisionId: string;
  entrepreneur: ApiEgrulEgripEntrepreneur;
}

export interface ApiMasterAccountMasterApplicationLegalEntityByEmployeeDto {
  legalEntity: ApiEgrulLegalEntity;
  /**
   * Электронная почта сотрудника
   * @format email
   * @minLength 1
   * @example "pupkin_vi@email.ru"
   */
  email: string;
}

export interface ApiMasterAccountMasterApplicationLegalEntityCreateDto {
  /**
   * Электронная почта
   * @format email
   * @minLength 1
   * @example "pupkin_vi@email.ru"
   */
  email: string;
  /** Идентификаторы файлов документов */
  documents: string[];
  /**
   * Идентификатор филиала
   * @format uuid
   */
  divisionId: string;
  legalEntity: ApiEgrulLegalEntity;
}

export interface ApiMasterAccountRejectedMasterApplication {
  status: ApiCounterpartyApplicationStatus;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  rejectReason: string;
}

export interface ApiPermissionInfo {
  systemName: ApiAuthorizationPermissionEnum;
  name: string;
}

export interface ApiRoleIdItem {
  /** @format int32 */
  id: number;
}

/** Dto для GET /user/{id}/role */
export interface ApiRoleWithDescription {
  /**
   * Идентификатор роли
   * @format int32
   */
  id: number;
  /**
   * Наименование роли
   * @minLength 1
   */
  code: string;
  /**
   * Наименование роли (расшифровка)
   * @minLength 1
   */
  description: string;
}

export interface ApiRoles {
  roles: ApiRoleWithDescription[];
}

/** @format int32 */
export enum ApiRestEnumВидДоверенности {
  ValueОбычная = 'Обычная',
}

/** @format int32 */
export enum ApiRestEnumВозможностьПередоверия {
  ValueБезПраваПередоверия = 'БезПраваПередоверия',
  ValueОднократноеПередоверие = 'ОднократноеПередоверие',
  ValueСПравомПоследующегоПередоверия = 'СПравомПоследующегоПередоверия',
}

/** @format int32 */
export enum ApiRestEnumУтратаПриПередоверии {
  ValueНеУтрачиваются = 'НеУтрачиваются',
  ValueУтрачиваются = 'Утрачиваются',
}

export interface ApiRestMainDto {
  /** @format date */
  датаФормированияФайла?: string | null;
  иныеСведения?: string | null;
  видДоверенности: ApiRestEnumВидДоверенности;
  возможностьПередоверия: ApiRestEnumВозможностьПередоверия;
  внутреннийНомерДоверенности: string;
  /** @format uuid */
  единыйРегистрационныйНомерДоверенности?: string | null;
  /** @format date */
  датаСовершенияДоверенности: string;
  /** @format date */
  срокДействияДоверенности: string;
  сведенияОбИнформационнойСистеме: string;
  текстПолномочий: string;
  утратаПриПередоверии?: ApiRestEnumУтратаПриПередоверии;
}

export type ApiSwaggerDefault404NotFoundExamples = object;

export interface ApiProfileListByRequestParams {
  request?: ApiGetProfilesByToken_Request;
}

export interface ApiAccountListByQueryParams {
  /** строка совпадения */
  query?: string;
  sortField?: ApiAccountSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
}

export interface ApiGetbyemailListByEmailParams {
  /**
   * Email аккаунта
   * @format email
   */
  email: string;
}

export interface ApiEmployeeGetbyemailListByEmailParams {
  /**
   * Email аккаунта
   * @format email
   */
  email: string;
}

export interface ApiMasterGetbyemailListByEmailParams {
  /**
   * Email аккаунта
   * @format email
   */
  email: string;
}

export interface ApiChatListBySourceIdParams {
  /**
   * ID источника
   * @format uuid
   */
  sourceId: string;
}

export interface ApiMessagesListByIdParams {
  /**
   * Skip
   * @format int32
   */
  skip?: number;
  /**
   * Take
   * @format int32
   */
  take?: number;
  /**
   * ID чата
   * @format uuid
   */
  id: string;
}

export interface ApiCounterpartyListByQueryParams {
  /** Строка совпадения */
  query?: string;
  /** Список типов контрагентов */
  counterpartyTypes?: ApiCounterpartyType[];
  /** Список филиалов */
  branchIds?: string[];
  sortField?: ApiCounterpartiesSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
}

export interface ApiUpdatedListByUpdatedAtFromParams {
  /** @format date-time */
  updatedAtFrom?: string;
  /** @format date-time */
  updatedAtTill?: string;
}

export interface ApiEmployeeListByCounterpartyIdParams {
  /** @format email */
  employeeEmail?: string;
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  /**
   * ID контрагента
   * @format uuid
   */
  counterpartyId: string;
}

export interface ApiEmployeeUpdatedListByUpdatedAtFromParams {
  /** @format date-time */
  updatedAtFrom?: string;
  /** @format date-time */
  updatedAtTill?: string;
}

export interface ApiEmployeeTrustListByCounterpartyIdParams {
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  /**
   * ID контрагента
   * @format uuid
   */
  counterpartyId: string;
  /**
   * ID сотрудника
   * @format uuid
   */
  employeeId: string;
}

export interface ApiDocumentListByIdParams {
  query?: string;
  isArchived?: boolean;
  sortField?: ApiCounterpartyDocumentsDocumentSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  /** @format uuid */
  id: string;
}

export interface ApiHarbourduesListByRequestParams {
  request?: ApiDiagnosticGetHarbourduesHealthCheck_Request;
}

export interface ApiSettingsListByDivisionIdsParams {
  divisionIds?: string[];
}

export interface ApiBranchBasinListByQueryParams {
  /** Строка совпадения */
  query?: string;
  /** Статус */
  isArchived?: boolean;
  /**
   * Идентификатор филиала
   * @format uuid
   */
  branchId?: string;
  sortField?: ApiDivisionSortField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
}

export interface ApiDepartmentListByQueryParams {
  /** Строка совпадения */
  query?: string;
  /** Статус */
  isArchived?: boolean;
  /**
   * Идентификатор филиала
   * @format uuid
   */
  branchId?: string;
  sortField?: ApiDivisionSortField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
}

export interface ApiPortListByQueryParams {
  /** Строка совпадения */
  query?: string;
  /** Статус */
  isArchived?: boolean;
  /**
   * Идентификатор филиала
   * @format uuid
   */
  branchId?: string;
  sortField?: ApiDivisionSortField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
}

export interface ApiPortServiceDefinitionListByIdParams {
  sortField?: ApiServiceDefinitionSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  /** @format uuid */
  id: string;
}

export interface ApiServiceDefinitionListByIdParams {
  sortField?: ApiServiceDefinitionSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  /** @format uuid */
  id: string;
}

export interface ApiAgreementDefinitionListByIdParams {
  sortField?: ApiAgreementDefinitionSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  /** @format uuid */
  id: string;
}

export interface ApiPublicOfferDefinitionListByIdParams {
  sortField?: ApiPublicOfferDefinitionSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  /** @format uuid */
  id: string;
}

export interface ApiGuaranteeLetterDefinitionListByIdParams {
  sortField?: ApiGuaranteeLetterDefinitionSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  /** @format uuid */
  id: string;
}

export interface ApiEmployeeListByDivisionIdParams {
  /** Строка совпадения */
  query?: string;
  /** Идентификаторы ролей */
  roleIds?: number[];
  sortField?: ApiEmployeesSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  /**
   * Идентификатор подразделения
   * @format uuid
   */
  divisionId: string;
}

/** Сотрудник */
export type ApiEmployeeCreateByDivisionIdPayload = ApiOfficeEmployee | ApiEmployee;

export interface ApiEmployeeCreateByDivisionIdParams {
  /** Привязать к пользователю */
  assignToAccount?: boolean;
  /**
   * Идентификатор подразделения
   * @format uuid
   */
  divisionId: string;
}

/** Сотрудник */
export type ApiEmployeeUpdateByDivisionIdPayload = ApiOfficeEmployee | ApiEmployee;

export interface ApiNotificationDefinitionListByRecipientTypeParams {
  recipientType?: ApiNotificationsRecipientType;
}

export interface ApiBankAccountListByDivisionIdParams {
  isArchived?: boolean;
  /** @format uuid */
  divisionId: string;
}

export type ApiBankAccountCreateByDivisionIdPayload =
  | ApiDivisionBankAccount
  | ApiDivisionBankAccountPersisted;

export type ApiBankAccountUpdateByDivisionIdPayload =
  | ApiDivisionBankAccount
  | ApiDivisionBankAccountPersisted;

export interface ApiContactListByQueryParams {
  query?: string;
  isPublic?: boolean;
  sortField?: ApiDivisionContactSortField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  /** @format uuid */
  divisionId: string;
}

export interface ApiCounterpartyEntrepreneurEmployeeListByEmployeeEmailParams {
  /** @format email */
  employeeEmail?: string;
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
}

export type ApiCounterpartyEntrepreneurEmployeeCreateByAssignToAccountPayload =
  | ApiCounterpartyEmployee
  | ApiCounterpartyEmployeeEntrepreneur
  | ApiCounterpartyEmployeeLegalEntity;

export interface ApiCounterpartyEntrepreneurEmployeeCreateByAssignToAccountParams {
  /** Привязать к пользователю */
  assignToAccount?: boolean;
}

export type ApiCounterpartyEntrepreneurEmployeeUpdateByEmployeeIdPayload =
  | ApiCounterpartyEmployee
  | ApiCounterpartyEmployeeEntrepreneur
  | ApiCounterpartyEmployeeLegalEntity;

export interface ApiEntrepreneurListByQueryParams {
  /** строка совпадения */
  query?: string;
  sortField?: ApiEntrepreneursSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
}

export interface ApiEntrepreneurUpdatedListByUpdatedAtFromParams {
  /** @format date-time */
  updatedAtFrom?: string;
  /** @format date-time */
  updatedAtTill?: string;
}

export interface ApiEntrepreneurSearchListByInnParams {
  /** ИНН */
  inn?: string;
  /** ОГРН */
  ogrn?: string;
}

export interface ApiEntrepreneurExistsListByInnParams {
  /** ИНН */
  inn?: string;
  /** ОГРН */
  ogrn?: string;
}

export interface ApiEntrepreneurSuggestionCompleteListByInnParams {
  /** ИНН */
  inn?: string;
  /** ОГРН */
  ogrn?: string;
}

export interface ApiEntrepreneurEmployeeListByCounterpartyIdParams {
  /** @format email */
  employeeEmail?: string;
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  /**
   * Идентификатор работодателя сотрудников
   * @format uuid
   */
  counterpartyId: string;
}

export type ApiEntrepreneurEmployeeCreateByCounterpartyIdPayload =
  | ApiCounterpartyEmployee
  | ApiCounterpartyEmployeeEntrepreneur
  | ApiCounterpartyEmployeeLegalEntity;

export interface ApiEntrepreneurEmployeeCreateByCounterpartyIdParams {
  /** Привязать к пользователю */
  assignToAccount?: boolean;
  /**
   * ID ИП-работодателя сотрудника
   * @format uuid
   */
  counterpartyId: string;
}

export type ApiEntrepreneurEmployeeUpdateByEmployeeIdPayload =
  | ApiCounterpartyEmployee
  | ApiCounterpartyEmployeeEntrepreneur
  | ApiCounterpartyEmployeeLegalEntity;

export interface ApiEgripEntrepreneurListByOgrnParams {
  /** ОГРН */
  ogrn: string;
  /** ИНН */
  inn: string;
}

export interface ApiEgripEntrepreneurInnListByInnParams {
  /** ИНН */
  inn: string;
}

export interface ApiEgripEntrepreneurOgrnListByOgrnParams {
  /** ОГРН */
  ogrn: string;
}

export interface ApiEgrulLegalEntityListByOgrnParams {
  /** ОГРН */
  ogrn: string;
  /** ИНН */
  inn: string;
  /** КПП */
  kpp: string;
}

export interface ApiEgrulLegalEntityInnListByInnParams {
  /** ИНН */
  inn: string;
}

export interface ApiEgrulLegalEntityOgrnListByOgrnParams {
  /** ОГРН */
  ogrn: string;
}

export interface ApiUpToDateLegalEntityUpdateByInnParams {
  /** ИНН */
  inn: string;
  /** ОГРН */
  ogrn: string;
  /** КПП */
  kpp: string;
  /**
   * суррогатного внутреннего идентификатор ЮЛ
   * @format uuid
   */
  externalId: string;
}

export interface ApiUpToDateLegalEntityDeleteByInnParams {
  /** ИНН */
  inn: string;
  /** ОГРН */
  ogrn: string;
  /** КПП */
  kpp: string;
  /**
   * суррогатного внутреннего идентификатор ЮЛ
   * @format uuid
   */
  externalId: string;
}

export interface ApiUpToDateLegalEntityListByInnParams {
  /** ИНН */
  inn: string;
  /** ОГРН */
  ogrn: string;
  /** КПП */
  kpp: string;
}

export interface ApiUpToDateLegalEntityForceCreateByInnParams {
  /** ИНН */
  inn: string;
  /** ОГРН */
  ogrn: string;
  /** КПП */
  kpp: string;
  /**
   * суррогатного внутреннего идентификатор ЮЛ
   * @format uuid
   */
  externalId: string;
}

export interface ApiUpToDateEntrepreneurUpdateByInnParams {
  /** ИНН */
  inn: string;
  /** ОГРН */
  ogrn: string;
  /**
   * суррогатного внутреннего идентификатор ИП
   * @format uuid
   */
  externalId: string;
}

export interface ApiUpToDateEntrepreneurDeleteByInnParams {
  /** ИНН */
  inn: string;
  /** ОГРН */
  ogrn: string;
  /**
   * суррогатного внутреннего идентификатор ИП
   * @format uuid
   */
  externalId: string;
}

export interface ApiUpToDateEntrepreneurListByInnParams {
  /** ИНН */
  inn: string;
  /** ОГРН */
  ogrn: string;
}

export interface ApiUpToDateEntrepreneurForceCreateByInnParams {
  /** ИНН */
  inn: string;
  /** ОГРН */
  ogrn: string;
  /**
   * суррогатного внутреннего идентификатор ИП
   * @format uuid
   */
  externalId: string;
}

export interface ApiCounterpartyLegalEntityEmployeeListByEmployeeEmailParams {
  /** @format email */
  employeeEmail?: string;
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
}

/** Сотрудник */
export type ApiCounterpartyLegalEntityEmployeeCreateByAssignToAccountPayload =
  | ApiCounterpartyEmployee
  | ApiCounterpartyEmployeeEntrepreneur
  | ApiCounterpartyEmployeeLegalEntity;

export interface ApiCounterpartyLegalEntityEmployeeCreateByAssignToAccountParams {
  /** Привязать к пользователю */
  assignToAccount?: boolean;
}

/** Сотрудник */
export type ApiCounterpartyLegalEntityEmployeeUpdateByEmployeeIdPayload =
  | ApiCounterpartyEmployee
  | ApiCounterpartyEmployeeEntrepreneur
  | ApiCounterpartyEmployeeLegalEntity;

export interface ApiLegalEntityListByQueryParams {
  /** строка совпадения */
  query?: string;
  /** список типов контрагентов */
  counterpartyTypes?: ApiCounterpartyType[];
  sortField?: ApiCounterpartiesSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
}

export interface ApiLegalEntityUpdatedListByUpdatedAtFromParams {
  /** @format date-time */
  updatedAtFrom?: string;
  /** @format date-time */
  updatedAtTill?: string;
}

export interface ApiLegalEntitySuggestionCompleteListByInnParams {
  /**
   * ИНН
   * @example "7743104500"
   */
  inn?: string;
  /**
   * ОГРН
   * @example "1157746527432"
   */
  ogrn?: string;
}

export interface ApiLegalEntitySearchListByInnParams {
  /**
   * ИНН
   * @example "7743104500"
   */
  inn: string;
  /**
   * КПП
   * @example "774301001"
   */
  kpp: string;
  /**
   * ОГРН
   * @example "1157746527432"
   */
  ogrn: string;
}

export interface ApiLegalEntityExistsListByInnParams {
  /**
   * ИНН
   * @example "7743104500"
   */
  inn: string;
  /**
   * КПП
   * @example "774301001"
   */
  kpp: string;
  /**
   * ОГРН
   * @example "1157746527432"
   */
  ogrn: string;
}

export interface ApiLegalEntityEmployeeListByLegalEntityIdParams {
  /** @format email */
  employeeEmail?: string;
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  /**
   * Идентификатор работодателя сотрудника
   * @format uuid
   */
  legalEntityId: string;
}

/** Сотрудник */
export type ApiLegalEntityEmployeeCreateByLegalEntityIdPayload =
  | ApiCounterpartyEmployee
  | ApiCounterpartyEmployeeEntrepreneur
  | ApiCounterpartyEmployeeLegalEntity;

export interface ApiLegalEntityEmployeeCreateByLegalEntityIdParams {
  /** Привязать к пользователю */
  assignToAccount?: boolean;
  /**
   * Идентификатор работодателя сотрудника
   * @format uuid
   */
  legalEntityId: string;
}

/** Сотрудник */
export type ApiLegalEntityEmployeeUpdateByLegalEntityIdPayload =
  | ApiCounterpartyEmployee
  | ApiCounterpartyEmployeeEntrepreneur
  | ApiCounterpartyEmployeeLegalEntity;

export interface ApiTotalAmountUpdateByRequestParams {
  request?: ApiMaintenanceUpdateTotalAmounts_Request;
}

export interface ApiInitDivisionidUpdateByRequestParams {
  request?: ApiUtilUpdateDivisionId_Request;
}

export interface ApiLegalEntityExistsListByInnParams2 {
  /** ИНН */
  inn: string;
  /** ОГРН */
  ogrn: string;
  /** КПП */
  kpp: string;
  /** Статус */
  status: ApiServiceRequestsMasterApplicationStatus;
}

export interface ApiEntrepreneurExistsListByInnParams2 {
  /** ИНН */
  inn: string;
  /** ОГРН */
  ogrnIp: string;
  /** Статус */
  status: ApiServiceRequestsMasterApplicationStatus;
}

export interface ApiMasterApplicationListByIdsParams {
  ids?: string[];
  divisionIds?: string[];
  query?: string;
  inn?: string;
  kpp?: string;
  ogrn?: string;
  snils?: string;
  requestorEmail?: string;
  statuses?: ApiServiceRequestsMasterApplicationStatus[];
  branchIds?: string[];
  sortField?: ApiServiceRequestsMasterApplicationsSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
}

export interface ApiPermissionsListByRequestParams {
  request?: ApiGetPermissions_Request;
}

export interface ApiFileUpdateByIdParams {
  /**
   * Идентификатор файла
   * @format uuid
   */
  fileId: string;
  /**
   * Идентификатор публичной оферты
   * @format uuid
   */
  id: string;
}

export interface ApiPublicOfferAcceptanceListByIdParams {
  /** Строка поиска */
  query?: string;
  sortField?: ApiServicesPublicOfferAcceptanceSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  /**
   * Идентификатор публичной оферты
   * @format uuid
   */
  id: string;
}

export interface ApiPublicOfferCreateByIdParams {
  /**
   * Дата начала действия
   * @format date
   */
  validFrom: string;
  /**
   * Дата окончания действия
   * @format date
   */
  validTo?: string;
  /**
   * Идентификатор шаблона публичной оферты
   * @format uuid
   */
  id: string;
}

export interface ApiPublicOfferAcceptanceListByIdParams2 {
  /** Строка поиска */
  query?: string;
  sortField?: ApiServicesPublicOfferAcceptanceSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  /**
   * Идентификатор шаблона публичной оферты
   * @format uuid
   */
  id: string;
}

export type ApiOfficeEmployeeUpdateByProfileIdPayload = ApiRoleIdItem[];

export interface ApiTariffListByServiceDefinitionIdParams {
  /** Фильтр по признаку архивности */
  isArchived?: boolean;
  sortField?: ApiServicesTariffSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
  /**
   * Идентификатор шаблона услуги
   * @format uuid
   */
  serviceDefinitionId: string;
}

export interface ApiAdditionalServiceListByServiceDefinitionIdParams {
  /** Обязательна ли дополнительная услуга */
  isRequired?: boolean;
  /**
   * Идентификатор основной услуги
   * @format uuid
   */
  serviceDefinitionId: string;
}

export interface ApiRoleListByDivisionIdsParams {
  /** Подразделения, к которым относятся роли */
  divisionIds?: string[];
  query?: string;
  isArchived?: boolean;
  sortField?: ApiRoleSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
}

export interface ApiPermissionListByRequestParams {
  request?: ApiGetPermissionRole_Request;
}

export interface ApiDivisionRoleListByDivisionIdParams {
  query?: string;
  /** @format uuid */
  divisionId: string;
}

export type ApiDivisionRoleAppsUpdateByDivisionIdPayload = number[];

/** Разрешения роли предприятия */
export type ApiDivisionRolePermissionUpdateByDivisionIdPayload = ApiAuthorizationPermissionEnum[];

export interface ApiEmployeeListByQueryParams {
  /** Строка совпадения */
  query?: string;
  /** ID ролей */
  roleIds?: number[];
  /**
   * Идентификатор филиала (Branch/BranchBasin).
   * Фильтр всегда охватывает филиал и всё его физическое поддерево.
   * @format uuid
   */
  branchId?: string;
  sortField?: ApiEmployeesSortingField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
}

export interface ApiEmployeeUpdatedListByUpdatedAtFromParams2 {
  /** @format date-time */
  updatedAtFrom?: string;
  /** @format date-time */
  updatedAtTill?: string;
}

export interface ApiStaffEmployeeListByRequestParams {
  request?: ApiOfficesGetOwnEmployee_Request;
}

export interface ApiContactListByQueryParams2 {
  query?: string;
  isPublic?: boolean;
  sortField?: ApiDivisionContactSortField[];
  sortingDirection?: ApiSortingDirection[];
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
}

export interface ApiTrustListByCounterpartyIdParams {
  /** @format uuid */
  counterpartyId?: string;
  /** @format uuid */
  trusteeEmployeeId?: string;
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
}

export interface ApiUpdatedListByUpdatedAtFromParams2 {
  /** @format date-time */
  updatedAtFrom?: string;
  /** @format date-time */
  updatedAtTill?: string;
}

export interface ApiActiveListByCounterpartyIdParams {
  /** @format uuid */
  counterpartyId: string;
  /** @format uuid */
  trusteeEmployeeId: string;
  /** @format int32 */
  take?: number;
  /** @format int32 */
  skip?: number;
}

export interface ApiActionerListByIdParams {
  actionerKind: ApiGetTrustActioner_ActionerKind;
  /** @format uuid */
  id: string;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;

  abortService?: {
    getSignal(): AbortSignal;
  };
  instance?: AxiosInstance;
  injectHeaders?: (data: any) => any;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;
  private injectHeaders?: (data: any) => any;
  private abortService: {
    getSignal(): AbortSignal;
  };

  constructor({
    securityWorker,
    secure,
    format,
    instance,
    injectHeaders,
    abortService,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance =
      instance ?? axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
    this.injectHeaders = injectHeaders;
    this.abortService = abortService!;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T, _E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    let headers = {
      ...(requestParams.headers || {}),
      ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
    };

    if (this.injectHeaders) {
      headers = await this.injectHeaders(headers);
    }

    return this.instance.request({
      ...requestParams,
      headers,
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
      signal: this.abortService.getSignal(),
    });
  };
}

/**
 * @title RMP Api
 * @version v1
 * @license
 * @contact RMP Api
 *
 * RMP Api
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  account = {
    /**
     * @description <b>Права доступа:</b><ul><li>account:read</li></ul>
     *
     * @tags Account
     * @name ProfileListByAccountId
     * @summary Получение списка профилей по ID пользователя
     * @request GET:/account/{accountId}/profile
     * @secure
     */
    profileListByAccountId: (accountId: string, params: RequestParams = {}) =>
      this.request<ApiProfilesResponse, ApiValidationProblemDetails | void>({
        path: `/account/${accountId}/profile`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>account:read</li></ul>
     *
     * @tags Account
     * @name ProfileDetailByAccountId
     * @summary Получение профиля по ID
     * @request GET:/account/{accountId}/profile/{id}
     * @secure
     */
    profileDetailByAccountId: (accountId: string, id: string, params: RequestParams = {}) =>
      this.request<ApiProfileResponse, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/account/${accountId}/profile/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>account:update</li></ul>
     *
     * @tags Account
     * @name ProfileActivateCreateByAccountId
     * @summary Активация профиля
     * @request POST:/account/{accountId}/profile/{id}/activate
     * @secure
     */
    profileActivateCreateByAccountId: (accountId: string, id: string, params: RequestParams = {}) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/account/${accountId}/profile/${id}/activate`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>account:update</li></ul>
     *
     * @tags Account
     * @name ProfileDeactivateCreateByAccountId
     * @summary Деактивация профиля
     * @request POST:/account/{accountId}/profile/{id}/deactivate
     * @secure
     */
    profileDeactivateCreateByAccountId: (
      accountId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/account/${accountId}/profile/${id}/deactivate`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name ProfileListByRequest
     * @summary Получить профили аккаунта используя токен
     * @request GET:/account/profile
     * @secure
     */
    profileListByRequest: (query: ApiProfileListByRequestParams, params: RequestParams = {}) =>
      this.request<ApiProfilesResponse, void>({
        path: `/account/profile`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name ProfileDetailById
     * @summary Получить профиль аккаунта используя токен
     * @request GET:/account/profile/{id}
     * @secure
     */
    profileDetailById: (id: string, params: RequestParams = {}) =>
      this.request<
        | ApiCounterpartyProfilePersistedBase
        | ApiEntrepreneurEmployeeProfilePersisted
        | ApiEntrepreneurProfilePersisted
        | ApiLegalEntityProfilePersisted
        | ApiLegalEntityEmployeeProfilePersisted
        | ApiOfficeEmployeeProfilePersisted,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/account/profile/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>account:read</li></ul>
     *
     * @tags Account
     * @name AccountListByQuery
     * @summary Получить список пользователей (Сортировка по умолчанию: по дате создания, нисходящая)
     * @request GET:/account
     * @secure
     */
    accountListByQuery: (query: ApiAccountListByQueryParams, params: RequestParams = {}) =>
      this.request<ApiAccountsResponse, void>({
        path: `/account`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>account:read</li></ul>
     *
     * @tags Account
     * @name AccountDetailById
     * @summary Получение пользователя по ID
     * @request GET:/account/{id}
     * @secure
     */
    accountDetailById: (id: string, params: RequestParams = {}) =>
      this.request<ApiAccountResponse, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/account/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>account:read</li></ul>
     *
     * @tags Account
     * @name GetbyemailListByEmail
     * @summary Получить аккаунты по email
     * @request GET:/account/getbyemail
     * @secure
     */
    getbyemailListByEmail: (query: ApiGetbyemailListByEmailParams, params: RequestParams = {}) =>
      this.request<ApiAccountsResponse, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/account/getbyemail`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>account:read</li></ul>
     *
     * @tags Account
     * @name EmployeeGetbyemailListByEmail
     * @summary Получить аккаунт сотрудника по email
     * @request GET:/account/employee/getbyemail
     * @secure
     */
    employeeGetbyemailListByEmail: (
      query: ApiEmployeeGetbyemailListByEmailParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiAccountResponse, ApiValidationProblemDetails | void>({
        path: `/account/employee/getbyemail`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>account:read</li></ul>
     *
     * @tags Account
     * @name MasterGetbyemailListByEmail
     * @summary Получить мастер-аккаунт по email
     * @request GET:/account/master/getbyemail
     * @secure
     */
    masterGetbyemailListByEmail: (
      query: ApiMasterGetbyemailListByEmailParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiAccountResponse, ApiValidationProblemDetails | void>({
        path: `/account/master/getbyemail`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name CheckemailCreate
     * @summary Проверить существует ли аккаунт с определенным email
     * @request POST:/account/checkemail
     */
    checkemailCreate: (data: ApiDtoCheckEmailRequest, params: RequestParams = {}) =>
      this.request<ApiAccountWithEmailExistsResponse, ApiValidationProblemDetails>({
        path: `/account/checkemail`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name CheckemailCreateById
     * @summary Проверить существует ли другой аккаунт того же типа с определенным email
     * @request POST:/account/{id}/checkemail
     */
    checkemailCreateById: (id: string, data: ApiDtoCheckEmailRequest, params: RequestParams = {}) =>
      this.request<
        ApiAccountWithEmailExistsResponse,
        ApiValidationProblemDetails | ApiProblemDetails
      >({
        path: `/account/${id}/checkemail`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name EmployeeCheckemailCreate
     * @summary Проверить существует ли аккаунт сотрудника с определенным email
     * @request POST:/account/employee/checkemail
     */
    employeeCheckemailCreate: (data: ApiDtoCheckEmailRequest, params: RequestParams = {}) =>
      this.request<ApiAccountWithEmailExistsResponse, ApiValidationProblemDetails>({
        path: `/account/employee/checkemail`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name MasterCheckemailCreate
     * @summary Проверить существует ли мастер аккаунт с определенным email
     * @request POST:/account/master/checkemail
     */
    masterCheckemailCreate: (data: ApiDtoCheckEmailRequest, params: RequestParams = {}) =>
      this.request<ApiAccountWithEmailExistsResponse, ApiValidationProblemDetails>({
        path: `/account/master/checkemail`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>account:update</li></ul>
     *
     * @tags Account
     * @name ActiveUpdateById
     * @summary Сменить статус аккаунта
     * @request PUT:/account/{id}/active
     * @secure
     */
    activeUpdateById: (
      id: string,
      data: ApiDtoChangeAccountStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<ApiChangeAccountStatusResponse, ApiValidationProblemDetails | void>({
        path: `/account/${id}/active`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>account:update</li></ul>
     *
     * @tags Account
     * @name PasswordUpdateById
     * @summary Сменить пароль аккаунта
     * @request PUT:/account/{id}/password
     * @secure
     */
    passwordUpdateById: (
      id: string,
      data: ApiDtoChangeAccountPasswordRequest,
      params: RequestParams = {},
    ) =>
      this.request<ApiChangeAccountPasswordResponse, ApiValidationProblemDetails | void>({
        path: `/account/${id}/password`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>account:update</li></ul>
     *
     * @tags Account
     * @name EmailUpdateById
     * @summary Сменить почту аккаунта
     * @request PUT:/account/{id}/email
     * @secure
     */
    emailUpdateById: (
      id: string,
      data: ApiDtoChangeAccountEmailRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void>({
        path: `/account/${id}/email`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>account:update</li></ul>
     *
     * @tags Account
     * @name ResetPasswordCreateById
     * @summary Сброс пароля
     * @request POST:/account/{id}/reset-password
     * @secure
     */
    resetPasswordCreateById: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiValidationProblemDetails | void>({
        path: `/account/${id}/reset-password`,
        method: 'POST',
        secure: true,
        ...params,
      }),
  };
  profile = {
    /**
     * No description
     *
     * @tags Account
     * @name ProfileDetailById
     * @summary Получение непривязанного (не проставлен AccountId у профиля) профиля по ID
     * @request GET:/profile/{id}
     * @secure
     */
    profileDetailById: (id: string, params: RequestParams = {}) =>
      this.request<
        | ApiCounterpartyProfilePersistedBase
        | ApiEntrepreneurEmployeeProfilePersisted
        | ApiEntrepreneurProfilePersisted
        | ApiLegalEntityProfilePersisted
        | ApiLegalEntityEmployeeProfilePersisted
        | ApiOfficeEmployeeProfilePersisted,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/profile/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AssignCreateById
     * @summary Активация непривязанного (не проставлен AccountId у профиля) профиля по ID, проставляется AccountId текущего пользователя
     * @request POST:/profile/{id}/assign
     * @secure
     */
    assignCreateById: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/profile/${id}/assign`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>account:update</li></ul>
     *
     * @tags Account
     * @name ToggleSignatureRequiredCreateById
     * @summary Изменение требования "Необходимо подтверждение с помощью ЭЦП при входе"
     * @request POST:/profile/{id}/toggle-signature-required
     * @secure
     */
    toggleSignatureRequiredCreateById: (
      id: string,
      data: ApiProfilesToggleSignatureRequired_Request_Payload,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/profile/${id}/toggle-signature-required`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  agreementDefinition = {
    /**
     * No description
     *
     * @tags AgreementDefinition
     * @name AgreementDefinitionDetailById
     * @summary Получение шаблона договоров
     * @request GET:/agreement-definition/{id}
     * @secure
     */
    agreementDefinitionDetailById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiGetAgreementDefinitionByIdResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/agreement-definition/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgreementDefinition
     * @name AgreementDefinitionUpdateById
     * @summary Редактирование шаблона договоров
     * @request PUT:/agreement-definition/{id}
     * @secure
     */
    agreementDefinitionUpdateById: (
      id: string,
      data: ApiUpdateAgreementDefinition_UpdatingAgreementDefinition,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiUpdateAgreementDefinitionResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/agreement-definition/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgreementDefinition
     * @name DocumentTemplateListById
     * @summary Получение шаблона
     * @request GET:/agreement-definition/{id}/document-template
     * @secure
     */
    documentTemplateListById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiGetAgreementDocumentTemplateByAgreementDefinitionIdResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/agreement-definition/${id}/document-template`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgreementDefinition
     * @name DocumentTemplateCreateById
     * @summary Создание шаблона
     * @request POST:/agreement-definition/{id}/document-template
     * @secure
     */
    documentTemplateCreateById: (
      id: string,
      data: ApiAgreementDefinitionsCreateAgreementDocumentTemplate_AgreementDocumentTemplate,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCreateAgreementDocumentTemplateResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/agreement-definition/${id}/document-template`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgreementDefinition
     * @name AgreementDefinitionCreate
     * @summary Создание шаблона договоров
     * @request POST:/agreement-definition
     * @secure
     */
    agreementDefinitionCreate: (
      data: ApiCreateAgreementDefinition_CreatingAgreementDefinition,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCreateAgreementDefinitionResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/agreement-definition`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgreementDefinition
     * @name ArchiveCreateById
     * @summary Архивировать шаблон договоров
     * @request POST:/agreement-definition/{id}/archive
     * @secure
     */
    archiveCreateById: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/agreement-definition/${id}/archive`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgreementDefinition
     * @name UnarchiveCreateById
     * @summary Разархивировать шаблон договоров
     * @request POST:/agreement-definition/{id}/unarchive
     * @secure
     */
    unarchiveCreateById: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/agreement-definition/${id}/unarchive`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgreementDefinition
     * @name SetTransitionPermissionRolesUpdateById
     * @summary Метод установки разрешения для роли на выполнение перехода.
     * @request PUT:/agreement-definition/{id}/set-transition-permission-roles
     * @secure
     */
    setTransitionPermissionRolesUpdateById: (
      id: string,
      data: ApiAgreementDefinitionsSetAgreementTransitionPermissionRoles_Request_Payload,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/agreement-definition/${id}/set-transition-permission-roles`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgreementDefinition
     * @name TransitionsListById
     * @summary Метод получения списка переходов рабочего процесса шаблона договора.
     * @request GET:/agreement-definition/{id}/transitions
     * @secure
     */
    transitionsListById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiServicesGetAgreementDefinitionWorkflowTransitionsResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/agreement-definition/${id}/transitions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgreementDefinition
     * @name RolesTransitionsListById
     * @summary Метод получения списка ролей, доступных для переходов рабочего процесса шаблона договора.
     * @request GET:/agreement-definition/{id}/roles-transitions
     * @secure
     */
    rolesTransitionsListById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiServicesGetRoleAgreementTransitionsResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/agreement-definition/${id}/roles-transitions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  apps = {
    /**
     * No description
     *
     * @tags Apps
     * @name GetApps
     * @summary Получение доступных приложений
     * @request GET:/apps/own
     * @secure
     */
    getApps: (params: RequestParams = {}) =>
      this.request<ApiAuthorizationApp[], void>({
        path: `/apps/own`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Apps
     * @name AppsList
     * @summary Получение всех приложений.
     * @request GET:/apps
     * @secure
     */
    appsList: (params: RequestParams = {}) =>
      this.request<ApiAuthorizationGetAppsResponse, void>({
        path: `/apps`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  authCheck = {
    /**
     * No description
     *
     * @tags AuthCheck
     * @name WhoAmIList
     * @summary Информация о пользователе из токена
     * @request GET:/AuthCheck/whoAmI
     * @secure
     */
    whoAmIList: (params: RequestParams = {}) =>
      this.request<ApiHelpersUserData, void>({
        path: `/AuthCheck/whoAmI`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  chat = {
    /**
     * No description
     *
     * @tags Chat
     * @name ChatListBySourceId
     * @summary Поиск чата по параметрам
     * @request GET:/chat
     * @secure
     */
    chatListBySourceId: (query: ApiChatListBySourceIdParams, params: RequestParams = {}) =>
      this.request<string, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/chat`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chat
     * @name ChatCreate
     * @summary Создание чата
     * @request POST:/chat
     * @secure
     */
    chatCreate: (data: ApiCreateChatBody, params: RequestParams = {}) =>
      this.request<string, ApiValidationProblemDetails | void>({
        path: `/chat`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chat
     * @name MessagesListById
     * @summary Сообщения чата
     * @request GET:/chat/{id}/messages
     * @secure
     */
    messagesListById: ({ id, ...query }: ApiMessagesListByIdParams, params: RequestParams = {}) =>
      this.request<ApiChatMessage[], void>({
        path: `/chat/${id}/messages`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chat
     * @name MessagesCreateById
     * @summary Создать сообщение в чат
     * @request POST:/chat/{id}/messages
     * @secure
     */
    messagesCreateById: (id: string, data: ApiChatCreateMessage, params: RequestParams = {}) =>
      this.request<ApiChatMessage, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/chat/${id}/messages`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  counterparty = {
    /**
     * No description
     *
     * @tags Counterparty
     * @name RoleList
     * @summary Получить список всех возможных ролей сотрудника
     * @request GET:/counterparty/role
     */
    roleList: (params: RequestParams = {}) =>
      this.request<ApiCounterpartyEmployeesRolesResponse, any>({
        path: `/counterparty/role`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name BankAccountsListById
     * @summary Получить счета контрагента по Id
     * @request GET:/counterparty/{id}/bank-accounts
     */
    bankAccountsListById: (id: string, params: RequestParams = {}) =>
      this.request<ApiCounterpartyBankAccountsResponse, any>({
        path: `/counterparty/${id}/bank-accounts`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name BankAccountsCreateById
     * @summary Создание банковского счета контрагента
     * @request POST:/counterparty/{id}/bank-accounts
     */
    bankAccountsCreateById: (id: string, data: ApiBankAccount, params: RequestParams = {}) =>
      this.request<ApiBankAccountPersisted, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/counterparty/${id}/bank-accounts`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name BankAccountsDetailById
     * @summary Получить счет контрагента по Id
     * @request GET:/counterparty/{id}/bank-accounts/{accountId}
     */
    bankAccountsDetailById: (id: string, accountId: string, params: RequestParams = {}) =>
      this.request<ApiBankAccountPersisted, any>({
        path: `/counterparty/${id}/bank-accounts/${accountId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name BankAccountsUpdateById
     * @summary Изменение банковского счета контрагента
     * @request PUT:/counterparty/{id}/bank-accounts/{accountId}
     */
    bankAccountsUpdateById: (
      id: string,
      accountId: string,
      data: ApiBankAccount,
      params: RequestParams = {},
    ) =>
      this.request<ApiBankAccountPersisted, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/counterparty/${id}/bank-accounts/${accountId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name CounterpartyListByQuery
     * @summary Получить список Контрагентов (Сортировка по умолчанию: По дате создания; Направление сортировки по возрастанию)
     * @request GET:/counterparty
     * @secure
     */
    counterpartyListByQuery: (
      query: ApiCounterpartyListByQueryParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiCounterpartiesResponse, ApiValidationProblemDetails | void>({
        path: `/counterparty`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name UpdatedListByUpdatedAtFrom
     * @summary Получить список Контрагентов измененных за промежуток времени
     * @request GET:/counterparty/updated
     * @secure
     */
    updatedListByUpdatedAtFrom: (
      query: ApiUpdatedListByUpdatedAtFromParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiCounterpartiesUpdatedResponse, ApiValidationProblemDetails | void>({
        path: `/counterparty/updated`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name CounterpartyDetailById
     * @summary Получить Контрагента по ID
     * @request GET:/counterparty/{id}
     * @secure
     */
    counterpartyDetailById: (id: string, params: RequestParams = {}) =>
      this.request<ApiCounterpartyResponse, ApiValidationProblemDetails | void | ApiProblemDetails>(
        {
          path: `/counterparty/${id}`,
          method: 'GET',
          secure: true,
          format: 'json',
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Counterparty
     * @name CounterpartyDeleteById
     * @summary Удалить контрагента по ID
     * @request DELETE:/counterparty/{id}
     * @secure
     */
    counterpartyDeleteById: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/counterparty/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name CanBeDeletedListById
     * @summary Проверить возможность удаления контрагента по ID
     * @request GET:/counterparty/{id}/can-be-deleted
     * @secure
     */
    canBeDeletedListById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiCounterpartyCanBeDeletedCheckResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/counterparty/${id}/can-be-deleted`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name InviteToDiadocCreateById
     * @summary Пригласить контрагента в Контур.Диадок
     * @request POST:/counterparty/{id}/invite-to-diadoc
     * @secure
     */
    inviteToDiadocCreateById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiIntegrationKonturDiadocInviteCounterpartyResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/counterparty/${id}/invite-to-diadoc`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee:read</li></ul>
     *
     * @tags Counterparty
     * @name EmployeeListByCounterpartyId
     * @summary Получить список сотрудников контрагента
     * @request GET:/counterparty/{counterpartyId}/employee
     * @secure
     */
    employeeListByCounterpartyId: (
      { counterpartyId, ...query }: ApiEmployeeListByCounterpartyIdParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiDtoCounterpartyEmployeesWithTrustInfo, ApiValidationProblemDetails | void>({
        path: `/counterparty/${counterpartyId}/employee`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee:read</li></ul>
     *
     * @tags Counterparty
     * @name EmployeeDetailById
     * @summary Получить сотрудника контрагента
     * @request GET:/counterparty/{counterpartyId}/employee/{id}
     * @secure
     */
    employeeDetailById: (id: string, counterpartyId: string, params: RequestParams = {}) =>
      this.request<
        ApiCounterpartyEmployeeResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/counterparty/${counterpartyId}/employee/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name EmployeeProfileListByCounterpartyId
     * @summary Получить профиль сотрудника
     * @request GET:/counterparty/{counterpartyId}/employee/{employeeId}/profile
     */
    employeeProfileListByCounterpartyId: (
      counterpartyId: string,
      employeeId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        | ApiCounterpartyProfilePersistedBase
        | ApiEntrepreneurEmployeeProfilePersisted
        | ApiEntrepreneurProfilePersisted
        | ApiLegalEntityProfilePersisted
        | ApiLegalEntityEmployeeProfilePersisted
        | ApiOfficeEmployeeProfilePersisted,
        ApiValidationProblemDetails | ApiProblemDetails
      >({
        path: `/counterparty/${counterpartyId}/employee/${employeeId}/profile`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee:update</li></ul>
     *
     * @tags Counterparty
     * @name EmployeeActivateCreateByCounterpartyId
     * @summary Активировать сотрудника
     * @request POST:/counterparty/{counterpartyId}/employee/{employeeId}/activate
     * @secure
     */
    employeeActivateCreateByCounterpartyId: (
      counterpartyId: string,
      employeeId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ApiProblemDetails>({
        path: `/counterparty/${counterpartyId}/employee/${employeeId}/activate`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee:update</li></ul>
     *
     * @tags Counterparty
     * @name EmployeeDeactivateCreateByCounterpartyId
     * @summary Деактивировать сотрудника
     * @request POST:/counterparty/{counterpartyId}/employee/{employeeId}/deactivate
     * @secure
     */
    employeeDeactivateCreateByCounterpartyId: (
      counterpartyId: string,
      employeeId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ApiProblemDetails>({
        path: `/counterparty/${counterpartyId}/employee/${employeeId}/deactivate`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:read</li></ul>
     *
     * @tags Counterparty
     * @name EmployeeUpdatedListByUpdatedAtFrom
     * @summary Получить список сотрудников контрагентов измененных за промежуток времени
     * @request GET:/counterparty/employee/updated
     * @secure
     */
    employeeUpdatedListByUpdatedAtFrom: (
      query: ApiEmployeeUpdatedListByUpdatedAtFromParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiCounterpartyEmployeesUpdatedResponse, ApiValidationProblemDetails | void>({
        path: `/counterparty/employee/updated`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name EmployeeSettingsListByCounterpartyId
     * @request GET:/counterparty/{counterpartyId}/employee/{employeeId}/settings
     */
    employeeSettingsListByCounterpartyId: (
      counterpartyId: string,
      employeeId: string,
      params: RequestParams = {},
    ) =>
      this.request<string, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/counterparty/${counterpartyId}/employee/${employeeId}/settings`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name EmployeeSettingsUpdateByCounterpartyId
     * @request PUT:/counterparty/{counterpartyId}/employee/{employeeId}/settings
     */
    employeeSettingsUpdateByCounterpartyId: (
      counterpartyId: string,
      employeeId: string,
      data: ApiGenericCounterpartiesSetServiceApplicationNotificationsEmployeeSettings_Request_Data,
      params: RequestParams = {},
    ) =>
      this.request<string, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/counterparty/${counterpartyId}/employee/${employeeId}/settings`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee-trust:read</li></ul>
     *
     * @tags Counterparty
     * @name EmployeeTrustListByCounterpartyId
     * @summary Получить доверенности сотрудника
     * @request GET:/counterparty/{counterpartyId}/employee/{employeeId}/trust
     * @secure
     */
    employeeTrustListByCounterpartyId: (
      { counterpartyId, employeeId, ...query }: ApiEmployeeTrustListByCounterpartyIdParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiTrustsResponse, ApiValidationProblemDetails | void>({
        path: `/counterparty/${counterpartyId}/employee/${employeeId}/trust`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee-trust:create</li></ul>
     *
     * @tags Counterparty
     * @name EmployeeTrustCreateByCounterpartyId
     * @summary Создание доверенности
     * @request POST:/counterparty/{counterpartyId}/employee/{employeeId}/trust
     * @secure
     */
    employeeTrustCreateByCounterpartyId: (
      counterpartyId: string,
      employeeId: string,
      data: ApiCreateTrustRequest,
      params: RequestParams = {},
    ) =>
      this.request<string, ApiValidationProblemDetails | void>({
        path: `/counterparty/${counterpartyId}/employee/${employeeId}/trust`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee-trust:read</li></ul>
     *
     * @tags Counterparty
     * @name EmployeeTrustDetailByCounterpartyId
     * @summary Получить доверенность сотрудника
     * @request GET:/counterparty/{counterpartyId}/employee/{employeeId}/trust/{trustId}
     * @secure
     */
    employeeTrustDetailByCounterpartyId: (
      counterpartyId: string,
      employeeId: string,
      trustId: string,
      params: RequestParams = {},
    ) =>
      this.request<ApiTrustResponse, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/counterparty/${counterpartyId}/employee/${employeeId}/trust/${trustId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee-trust:accept</li></ul>
     *
     * @tags Counterparty
     * @name EmployeeTrustAcceptCreateByTrustId
     * @summary Подтверждение доверенности
     * @request POST:/counterparty/{counterpartyId}/employee/{employeeId}/trust/{trustId}/accept
     * @secure
     */
    employeeTrustAcceptCreateByTrustId: (
      trustId: string,
      counterpartyId: string,
      employeeId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void>({
        path: `/counterparty/${counterpartyId}/employee/${employeeId}/trust/${trustId}/accept`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee-trust:decline</li></ul>
     *
     * @tags Counterparty
     * @name EmployeeTrustCancelCreateByTrustId
     * @summary Отклонение подтвержденной доверенности
     * @request POST:/counterparty/{counterpartyId}/employee/{employeeId}/trust/{trustId}/cancel
     * @secure
     */
    employeeTrustCancelCreateByTrustId: (
      trustId: string,
      counterpartyId: string,
      employeeId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void>({
        path: `/counterparty/${counterpartyId}/employee/${employeeId}/trust/${trustId}/cancel`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee-trust:decline</li></ul>
     *
     * @tags Counterparty
     * @name EmployeeTrustDeclineCreateByTrustId
     * @summary Отклонение доверенности
     * @request POST:/counterparty/{counterpartyId}/employee/{employeeId}/trust/{trustId}/decline
     * @secure
     */
    employeeTrustDeclineCreateByTrustId: (
      trustId: string,
      counterpartyId: string,
      employeeId: string,
      data: ApiDtoDeclineTrustRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/counterparty/${counterpartyId}/employee/${employeeId}/trust/${trustId}/decline`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-master-account:read</li></ul>
     *
     * @tags Counterparty
     * @name ProfileListByCounterpartyId
     * @summary Получить профиль контрагента
     * @request GET:/counterparty/{counterpartyId}/profile
     * @secure
     */
    profileListByCounterpartyId: (counterpartyId: string, params: RequestParams = {}) =>
      this.request<
        ApiEntrepreneurProfileResponse | ApiLegalEntityProfileResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/counterparty/${counterpartyId}/profile`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name EnterpriseBranchListByCounterpartyId
     * @summary Получить список доступных филиалов предприятия контрагента
     * @request GET:/counterparty/{counterpartyId}/enterprise-branch
     * @secure
     */
    enterpriseBranchListByCounterpartyId: (counterpartyId: string, params: RequestParams = {}) =>
      this.request<
        ApiCounterpartyEnterpriseBranchesResponse,
        void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/counterparty/${counterpartyId}/enterprise-branch`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name EnterpriseBranchCreateByCounterpartyId
     * @summary Массовое создание привязок.
     * @request POST:/counterparty/{counterpartyId}/enterprise-branch
     * @secure
     */
    enterpriseBranchCreateByCounterpartyId: (
      counterpartyId: string,
      data: ApiEntepriseBranchesCreateCounterpartyEnterpriseBranches_CreateEnterpriseBranch,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartyEnterpriseBranchesResponse,
        | ApiValidationProblemDetails
        | void
        | ApiSwaggerDefault404NotFoundExamples
        | ApiProblemDetails
      >({
        path: `/counterparty/${counterpartyId}/enterprise-branch`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name EnterpriseBranchDeleteByCounterpartyId
     * @summary Удаление одной конкретной привязки
     * @request DELETE:/counterparty/{counterpartyId}/enterprise-branch/{enterpriseBranchId}
     * @secure
     */
    enterpriseBranchDeleteByCounterpartyId: (
      counterpartyId: string,
      enterpriseBranchId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartyEnterpriseBranchesResponse,
        void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/counterparty/${counterpartyId}/enterprise-branch/${enterpriseBranchId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty
     * @name EnterpriseBranchDefaultUpdateByCounterpartyId
     * @summary Переключить филиал предприятия по умолчанию.
     * @request PUT:/counterparty/{counterpartyId}/enterprise-branch/{enterpriseBranchId}/default
     * @secure
     */
    enterpriseBranchDefaultUpdateByCounterpartyId: (
      counterpartyId: string,
      enterpriseBranchId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartyEnterpriseBranchesResponse,
        | ApiValidationProblemDetails
        | void
        | ApiSwaggerDefault404NotFoundExamples
        | ApiProblemDetails
      >({
        path: `/counterparty/${counterpartyId}/enterprise-branch/${enterpriseBranchId}/default`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Counterparty - Documents
     * @name DocumentListById
     * @request GET:/counterparty/{id}/document
     * @secure
     */
    documentListById: ({ id, ...query }: ApiDocumentListByIdParams, params: RequestParams = {}) =>
      this.request<
        ApiCounterpartyDocumentsGetDocumentsResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/counterparty/${id}/document`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:read</li></ul>
     *
     * @tags CounterpartyEdo
     * @name GetCounterpartyByCounterpartyId
     * @summary Получить сохранённые реквизиты ЭДО
     * @request GET:/counterparty/{counterpartyId}/edo
     * @secure
     */
    getCounterpartyByCounterpartyId: (counterpartyId: string, params: RequestParams = {}) =>
      this.request<
        ApiIntegrationKonturDiadocCounterpartyLink,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/counterparty/${counterpartyId}/edo`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:update</li></ul>
     *
     * @tags CounterpartyEdo
     * @name PutCounterpartyByCounterpartyId
     * @summary Проверить и сохранить выбранный ящик
     * @request PUT:/counterparty/{counterpartyId}/edo
     * @secure
     */
    putCounterpartyByCounterpartyId: (
      counterpartyId: string,
      data: ApiGenericCounterpartiesSaveCounterpartyEdoSettings_Request_Payload,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiIntegrationKonturDiadocCounterpartyLink,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/counterparty/${counterpartyId}/edo`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:update</li></ul>
     *
     * @tags CounterpartyEdo
     * @name EdoCandidatesListByCounterpartyId
     * @summary Получить действующие подключения в Диадоке
     * @request GET:/counterparty/{counterpartyId}/edo/candidates
     * @secure
     */
    edoCandidatesListByCounterpartyId: (counterpartyId: string, params: RequestParams = {}) =>
      this.request<
        ApiIntegrationKonturDiadocGetCounterpartyEdoCandidatesResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/counterparty/${counterpartyId}/edo/candidates`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:read</li></ul>
     *
     * @tags Entrepreneur
     * @name EntrepreneurListByQuery
     * @summary Получить список ИП
     * @request GET:/counterparty/entrepreneur
     * @secure
     */
    entrepreneurListByQuery: (
      query: ApiEntrepreneurListByQueryParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartyEntrepreneursResponse | ApiCounterpartyEntrepreneursUpdatedResponse,
        void
      >({
        path: `/counterparty/entrepreneur`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:create</li></ul>
     *
     * @tags Entrepreneur
     * @name EntrepreneurCreate
     * @summary Создать ИП
     * @request POST:/counterparty/entrepreneur
     * @secure
     */
    entrepreneurCreate: (data: ApiEntrepreneur, params: RequestParams = {}) =>
      this.request<string, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/counterparty/entrepreneur`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:read</li></ul>
     *
     * @tags Entrepreneur
     * @name EntrepreneurUpdatedListByUpdatedAtFrom
     * @summary Получить список измененных ИП за промежуток времени
     * @request GET:/counterparty/entrepreneur/updated
     * @secure
     */
    entrepreneurUpdatedListByUpdatedAtFrom: (
      query: ApiEntrepreneurUpdatedListByUpdatedAtFromParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartyEntrepreneursResponse | ApiCounterpartyEntrepreneursUpdatedResponse,
        ApiValidationProblemDetails | void
      >({
        path: `/counterparty/entrepreneur/updated`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:read</li></ul>
     *
     * @tags Entrepreneur
     * @name EntrepreneurDetailByCounterpartyId
     * @summary Получить ИП по ID
     * @request GET:/counterparty/entrepreneur/{counterpartyId}
     * @secure
     */
    entrepreneurDetailByCounterpartyId: (counterpartyId: string, params: RequestParams = {}) =>
      this.request<
        ApiEntrepreneurPersisted,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/counterparty/entrepreneur/${counterpartyId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:update</li></ul>
     *
     * @tags Entrepreneur
     * @name EntrepreneurUpdateByCounterpartyId
     * @summary Изменить ИП
     * @request PUT:/counterparty/entrepreneur/{counterpartyId}
     * @secure
     */
    entrepreneurUpdateByCounterpartyId: (
      counterpartyId: string,
      data: ApiEntrepreneur,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/counterparty/entrepreneur/${counterpartyId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:read</li></ul>
     *
     * @tags Entrepreneur
     * @name EntrepreneurSearchListByInn
     * @summary Поиск ИП по ИНН или ОГРН
     * @request GET:/counterparty/entrepreneur/search
     * @secure
     */
    entrepreneurSearchListByInn: (
      query: ApiEntrepreneurSearchListByInnParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiEntrepreneurPersisted,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/counterparty/entrepreneur/search`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entrepreneur
     * @name EntrepreneurExistsListByInn
     * @summary Проверка существования ИП по ИНН или ОГРН
     * @request GET:/counterparty/entrepreneur/exists
     */
    entrepreneurExistsListByInn: (
      query: ApiEntrepreneurExistsListByInnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiCounterpartiesCheckExistsDto, ApiValidationProblemDetails>({
        path: `/counterparty/entrepreneur/exists`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entrepreneur
     * @name EntrepreneurSuggestionCompleteListByInn
     * @summary Поиск ИП по ИНН\ОГРН
     * @request GET:/counterparty/entrepreneur/suggestion/complete
     */
    entrepreneurSuggestionCompleteListByInn: (
      query: ApiEntrepreneurSuggestionCompleteListByInnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiEgrulEgripEntrepreneur, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/counterparty/entrepreneur/suggestion/complete`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entrepreneur
     * @name EntrepreneurProfileCheckCreate
     * @summary Проверить существование профиля
     * @request POST:/counterparty/entrepreneur/profile-check
     */
    entrepreneurProfileCheckCreate: (
      data: ApiCheckEntrepreneurProfileByIdentifiers_Request,
      params: RequestParams = {},
    ) =>
      this.request<ApiCounterpartiesCheckExistsDto, ApiValidationProblemDetails>({
        path: `/counterparty/entrepreneur/profile-check`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entrepreneur
     * @name EntrepreneurCheckAccountExistsCreate
     * @summary Проверяет существования пользователя c email у контрагента
     * @request POST:/counterparty/entrepreneur/check-account-exists
     */
    entrepreneurCheckAccountExistsCreate: (
      data: ApiEntrepreneursCheckAccountWithEmailExists_Request,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartiesCheckExistsDto,
        ApiValidationProblemDetails | ApiProblemDetails
      >({
        path: `/counterparty/entrepreneur/check-account-exists`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee:read</li></ul>
     *
     * @tags Entrepreneur
     * @name EntrepreneurEmployeeListByCounterpartyId
     * @summary Получить список сотрудников контрагента
     * @request GET:/counterparty/entrepreneur/{counterpartyId}/employee
     * @secure
     */
    entrepreneurEmployeeListByCounterpartyId: (
      { counterpartyId, ...query }: ApiEntrepreneurEmployeeListByCounterpartyIdParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartyEmployeePersistedEntrepreneur[],
        ApiValidationProblemDetails | void
      >({
        path: `/counterparty/entrepreneur/${counterpartyId}/employee`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee:create</li></ul>
     *
     * @tags Entrepreneur
     * @name EntrepreneurEmployeeCreateByCounterpartyId
     * @summary Создание сотрудника контрагента
     * @request POST:/counterparty/entrepreneur/{counterpartyId}/employee
     * @secure
     */
    entrepreneurEmployeeCreateByCounterpartyId: (
      { counterpartyId, ...query }: ApiEntrepreneurEmployeeCreateByCounterpartyIdParams,
      data: ApiEntrepreneurEmployeeCreateByCounterpartyIdPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/counterparty/entrepreneur/${counterpartyId}/employee`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee:read</li></ul>
     *
     * @tags Entrepreneur
     * @name EntrepreneurEmployeeDetailByCounterpartyId
     * @summary Получить сотрудника ИП по ID
     * @request GET:/counterparty/entrepreneur/{counterpartyId}/employee/{employeeId}
     * @secure
     */
    entrepreneurEmployeeDetailByCounterpartyId: (
      counterpartyId: string,
      employeeId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartyEmployeePersistedEntrepreneur,
        ApiValidationProblemDetails | void
      >({
        path: `/counterparty/entrepreneur/${counterpartyId}/employee/${employeeId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee:update</li></ul>
     *
     * @tags Entrepreneur
     * @name EntrepreneurEmployeeUpdateByEmployeeId
     * @summary Изменение сотрудника контрагента
     * @request PUT:/counterparty/entrepreneur/{counterpartyId}/employee/{employeeId}
     * @secure
     */
    entrepreneurEmployeeUpdateByEmployeeId: (
      employeeId: string,
      counterpartyId: string,
      data: ApiEntrepreneurEmployeeUpdateByEmployeeIdPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/counterparty/entrepreneur/${counterpartyId}/employee/${employeeId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-master-account:read</li></ul>
     *
     * @tags Entrepreneur
     * @name EntrepreneurProfileListByEntrepreneurId
     * @summary Получить профиль ИП
     * @request GET:/counterparty/entrepreneur/{entrepreneurId}/profile
     * @secure
     */
    entrepreneurProfileListByEntrepreneurId: (entrepreneurId: string, params: RequestParams = {}) =>
      this.request<
        ApiEntrepreneurProfileResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/counterparty/entrepreneur/${entrepreneurId}/profile`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-master-account:create</li></ul>
     *
     * @tags Entrepreneur
     * @name EntrepreneurProfileCreateByEntrepreneurId
     * @summary Создать профиль ИП
     * @request POST:/counterparty/entrepreneur/{entrepreneurId}/profile
     * @secure
     */
    entrepreneurProfileCreateByEntrepreneurId: (
      entrepreneurId: string,
      data: ApiCreateCounterpartyProfileDto,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/counterparty/entrepreneur/${entrepreneurId}/profile`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-master-account:update</li></ul>
     *
     * @tags Entrepreneur
     * @name EntrepreneurProfileUpdateByEntrepreneurId
     * @summary Изменить почту профиля ИП
     * @request PUT:/counterparty/entrepreneur/{entrepreneurId}/profile
     * @secure
     */
    entrepreneurProfileUpdateByEntrepreneurId: (
      entrepreneurId: string,
      data: ApiCreateCounterpartyProfileDto,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/counterparty/entrepreneur/${entrepreneurId}/profile`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entrepreneur
     * @name EntrepreneurProfileCheckCreateByEntrepreneurId
     * @summary Проверить существование профиля
     * @request POST:/counterparty/entrepreneur/{entrepreneurId}/profile/check
     */
    entrepreneurProfileCheckCreateByEntrepreneurId: (
      entrepreneurId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartiesCheckExistsDto,
        ApiValidationProblemDetails | ApiProblemDetails
      >({
        path: `/counterparty/entrepreneur/${entrepreneurId}/profile/check`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:read</li></ul>
     *
     * @tags LegalEntity
     * @name LegalEntityListByQuery
     * @summary Получение списка юридических лиц
     * @request GET:/counterparty/legal-entity
     * @secure
     */
    legalEntityListByQuery: (query: ApiLegalEntityListByQueryParams, params: RequestParams = {}) =>
      this.request<
        ApiCounterpartyLegalEntitiesResponse | ApiCounterpartyLegalEntitiesUpdatedResponse,
        ApiValidationProblemDetails | void
      >({
        path: `/counterparty/legal-entity`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:create</li></ul>
     *
     * @tags LegalEntity
     * @name LegalEntityCreate
     * @summary Создание организации
     * @request POST:/counterparty/legal-entity
     * @secure
     */
    legalEntityCreate: (data: ApiLegalEntity, params: RequestParams = {}) =>
      this.request<string, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/counterparty/legal-entity`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:read</li></ul>
     *
     * @tags LegalEntity
     * @name LegalEntityLegalEntityBranchListByLegalEntityId
     * @summary Получение списка филиалов юридического лица
     * @request GET:/counterparty/legal-entity/{legalEntityId}/legal-entity-branch
     * @secure
     */
    legalEntityLegalEntityBranchListByLegalEntityId: (
      legalEntityId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartyLegalEntitiesResponse | ApiCounterpartyLegalEntitiesUpdatedResponse,
        ApiValidationProblemDetails | void
      >({
        path: `/counterparty/legal-entity/${legalEntityId}/legal-entity-branch`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:read</li></ul>
     *
     * @tags LegalEntity
     * @name LegalEntityUpdatedListByUpdatedAtFrom
     * @summary Получить список ЮЛ измененных за промежуток времени
     * @request GET:/counterparty/legal-entity/updated
     * @secure
     */
    legalEntityUpdatedListByUpdatedAtFrom: (
      query: ApiLegalEntityUpdatedListByUpdatedAtFromParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartyLegalEntitiesResponse | ApiCounterpartyLegalEntitiesUpdatedResponse,
        ApiValidationProblemDetails | void
      >({
        path: `/counterparty/legal-entity/updated`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:read</li></ul>
     *
     * @tags LegalEntity
     * @name LegalEntityDetailById
     * @summary Получить ЮЛ по ID
     * @request GET:/counterparty/legal-entity/{id}
     * @secure
     */
    legalEntityDetailById: (id: string, params: RequestParams = {}) =>
      this.request<ApiLegalEntityPersisted, ApiValidationProblemDetails | void | ApiProblemDetails>(
        {
          path: `/counterparty/legal-entity/${id}`,
          method: 'GET',
          secure: true,
          format: 'json',
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags LegalEntity
     * @name LegalEntitySuggestionCompleteListByInn
     * @summary Поиск Юридического лица по ИНН\ОГРН
     * @request GET:/counterparty/legal-entity/suggestion/complete
     */
    legalEntitySuggestionCompleteListByInn: (
      query: ApiLegalEntitySuggestionCompleteListByInnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiEgrulLegalEntity, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/counterparty/legal-entity/suggestion/complete`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:update</li></ul>
     *
     * @tags LegalEntity
     * @name LegalEntityUpdateByLegalEntityId
     * @summary Изменение организации
     * @request PUT:/counterparty/legal-entity/{legalEntityId}
     * @secure
     */
    legalEntityUpdateByLegalEntityId: (
      legalEntityId: string,
      data: ApiLegalEntity,
      params: RequestParams = {},
    ) =>
      this.request<string, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/counterparty/legal-entity/${legalEntityId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:read</li></ul>
     *
     * @tags LegalEntity
     * @name LegalEntitySearchListByInn
     * @summary Получение организации по ИНН,ОГРН,КПП
     * @request GET:/counterparty/legal-entity/search
     * @secure
     */
    legalEntitySearchListByInn: (
      query: ApiLegalEntitySearchListByInnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiLegalEntityPersisted, ApiValidationProblemDetails | void | ApiProblemDetails>(
        {
          path: `/counterparty/legal-entity/search`,
          method: 'GET',
          query: query,
          secure: true,
          format: 'json',
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags LegalEntity
     * @name LegalEntityExistsListByInn
     * @summary Проверка существования организации по ИНН,ОГРН,КПП
     * @request GET:/counterparty/legal-entity/exists
     */
    legalEntityExistsListByInn: (
      query: ApiLegalEntityExistsListByInnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiCounterpartiesCheckExistsDto, ApiValidationProblemDetails>({
        path: `/counterparty/legal-entity/exists`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LegalEntity
     * @name LegalEntityProfileCheckCreate
     * @summary Проверить существование профиля
     * @request POST:/counterparty/legal-entity/profile-check
     */
    legalEntityProfileCheckCreate: (
      data: ApiCheckLegalEntityProfileByIdentifiers_Request,
      params: RequestParams = {},
    ) =>
      this.request<ApiCounterpartiesCheckExistsDto, ApiValidationProblemDetails>({
        path: `/counterparty/legal-entity/profile-check`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LegalEntity
     * @name LegalEntityCheckAccountExistsCreate
     * @summary Проверяет существования пользователя с email у контрагента
     * @request POST:/counterparty/legal-entity/check-account-exists
     */
    legalEntityCheckAccountExistsCreate: (
      data: ApiLegalEntitiesCheckAccountWithEmailExists_Request,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartiesCheckExistsDto,
        ApiValidationProblemDetails | ApiProblemDetails
      >({
        path: `/counterparty/legal-entity/check-account-exists`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LegalEntity
     * @name LegalEntityEmployeeListByLegalEntityId
     * @summary Получить список сотрудников контрагента по ID
     * @request GET:/counterparty/legal-entity/{legalEntityId}/employee
     */
    legalEntityEmployeeListByLegalEntityId: (
      { legalEntityId, ...query }: ApiLegalEntityEmployeeListByLegalEntityIdParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiCounterpartyEmployeePersistedLegalEntity[], ApiValidationProblemDetails>({
        path: `/counterparty/legal-entity/${legalEntityId}/employee`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee:create</li></ul>
     *
     * @tags LegalEntity
     * @name LegalEntityEmployeeCreateByLegalEntityId
     * @summary Создание сотрудника контрагента
     * @request POST:/counterparty/legal-entity/{legalEntityId}/employee
     * @secure
     */
    legalEntityEmployeeCreateByLegalEntityId: (
      { legalEntityId, ...query }: ApiLegalEntityEmployeeCreateByLegalEntityIdParams,
      data: ApiLegalEntityEmployeeCreateByLegalEntityIdPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/counterparty/legal-entity/${legalEntityId}/employee`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LegalEntity
     * @name LegalEntityEmployeeDetailByLegalEntityId
     * @summary Получить сотрудника контрагента по ID
     * @request GET:/counterparty/legal-entity/{legalEntityId}/employee/{employeeId}
     */
    legalEntityEmployeeDetailByLegalEntityId: (
      legalEntityId: string,
      employeeId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartyEmployeePersistedLegalEntity,
        ApiValidationProblemDetails | ApiProblemDetails
      >({
        path: `/counterparty/legal-entity/${legalEntityId}/employee/${employeeId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee:update</li></ul>
     *
     * @tags LegalEntity
     * @name LegalEntityEmployeeUpdateByLegalEntityId
     * @summary Изменение сотрудника контрагента
     * @request PUT:/counterparty/legal-entity/{legalEntityId}/employee/{employeeId}
     * @secure
     */
    legalEntityEmployeeUpdateByLegalEntityId: (
      legalEntityId: string,
      employeeId: string,
      data: ApiLegalEntityEmployeeUpdateByLegalEntityIdPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/counterparty/legal-entity/${legalEntityId}/employee/${employeeId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:read</li></ul>
     *
     * @tags LegalEntity
     * @name LegalEntityHeadListByLegalEntityId
     * @summary Получить список руководителей ЮЛ
     * @request GET:/counterparty/legal-entity/{legalEntityId}/head
     * @secure
     */
    legalEntityHeadListByLegalEntityId: (legalEntityId: string, params: RequestParams = {}) =>
      this.request<ApiLegalEntityHeadPersisted[], void>({
        path: `/counterparty/legal-entity/${legalEntityId}/head`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty:read</li></ul>
     *
     * @tags LegalEntity
     * @name LegalEntityHeadDetailByLegalEntityId
     * @summary Получить руководителя ЮЛ по его ID
     * @request GET:/counterparty/legal-entity/{legalEntityId}/head/{id}
     * @secure
     */
    legalEntityHeadDetailByLegalEntityId: (
      legalEntityId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<ApiLegalEntityHeadPersisted, void | ApiProblemDetails>({
        path: `/counterparty/legal-entity/${legalEntityId}/head/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-master-account:read</li></ul>
     *
     * @tags LegalEntity
     * @name LegalEntityProfileListByLegalEntityId
     * @summary Получить профиль ЮЛ
     * @request GET:/counterparty/legal-entity/{legalEntityId}/profile
     * @secure
     */
    legalEntityProfileListByLegalEntityId: (legalEntityId: string, params: RequestParams = {}) =>
      this.request<
        ApiLegalEntityProfileResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/counterparty/legal-entity/${legalEntityId}/profile`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-master-account:create</li></ul>
     *
     * @tags LegalEntity
     * @name LegalEntityProfileCreateByLegalEntityId
     * @summary Создать профиль ЮЛ
     * @request POST:/counterparty/legal-entity/{legalEntityId}/profile
     * @secure
     */
    legalEntityProfileCreateByLegalEntityId: (
      legalEntityId: string,
      data: ApiCreateCounterpartyProfileDto,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/counterparty/legal-entity/${legalEntityId}/profile`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-master-account:update</li></ul>
     *
     * @tags LegalEntity
     * @name LegalEntityProfileUpdateByLegalEntityId
     * @summary Изменить почту профиля ЮЛ
     * @request PUT:/counterparty/legal-entity/{legalEntityId}/profile
     * @secure
     */
    legalEntityProfileUpdateByLegalEntityId: (
      legalEntityId: string,
      data: ApiCreateCounterpartyProfileDto,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/counterparty/legal-entity/${legalEntityId}/profile`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags LegalEntity
     * @name LegalEntityProfileCheckCreateByLegalEntityId
     * @summary Проверить существование профиля
     * @request POST:/counterparty/legal-entity/{legalEntityId}/profile/check
     */
    legalEntityProfileCheckCreateByLegalEntityId: (
      legalEntityId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartiesCheckExistsDto,
        ApiValidationProblemDetails | ApiProblemDetails
      >({
        path: `/counterparty/legal-entity/${legalEntityId}/profile/check`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
  diagnostic = {
    /**
     * No description
     *
     * @tags Diagnostics
     * @name HarbourduesListByRequest
     * @request GET:/diagnostic/harbourdues
     * @secure
     */
    harbourduesListByRequest: (
      query: ApiHarbourduesListByRequestParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiHealthCheckResponse, void>({
        path: `/diagnostic/harbourdues`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  division = {
    /**
     * No description
     *
     * @tags Divisions
     * @name AxaptaListById
     * @summary Получение настроек интеграции подразделения с Axapta.
     * @request GET:/division/{id}/axapta
     * @secure
     */
    axaptaListById: (id: string, params: RequestParams = {}) =>
      this.request<ApiAxaptaDivisionSettings, void | ApiProblemDetails>({
        path: `/division/${id}/axapta`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name AxaptaUpdateById
     * @summary Обновление настроек и активности интеграции подразделения с Axapta.
     * @request PUT:/division/{id}/axapta
     * @secure
     */
    axaptaUpdateById: (
      id: string,
      data: ApiAxaptaUpdateSettings_Request_Payload,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/division/${id}/axapta`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name DiadocListById
     * @summary Получение настроек интеграции подразделения с Диадок.
     * @request GET:/division/{id}/diadoc
     * @secure
     */
    diadocListById: (id: string, params: RequestParams = {}) =>
      this.request<ApiIntegrationKonturDiadocDivisionSettings, void | ApiProblemDetails>({
        path: `/division/${id}/diadoc`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name DiadocUpdateById
     * @summary Обновление настроек и активности интеграции подразделения с Диадок.
     * @request PUT:/division/{id}/diadoc
     * @secure
     */
    diadocUpdateById: (
      id: string,
      data: ApiDiadocUpdateSettings_Request_Payload,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/division/${id}/diadoc`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name DispatchPortalListByDivisionId
     * @summary Получение настроек интеграции Диспетчерского портала для подразделения.
     * @request GET:/division/{divisionId}/dispatch-portal
     * @secure
     */
    dispatchPortalListByDivisionId: (divisionId: string, params: RequestParams = {}) =>
      this.request<ApiIntegrationDispatchPortalDivisionSettings, void | ApiProblemDetails>({
        path: `/division/${divisionId}/dispatch-portal`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name DispatchPortalUpdateByDivisionId
     * @summary Обновление настроек и активности интеграции Диспетчерского портала для подразделения.
     * @request PUT:/division/{divisionId}/dispatch-portal
     * @secure
     */
    dispatchPortalUpdateByDivisionId: (
      divisionId: string,
      data: ApiUpdateDivisionDispatchPortalSettings_Request_Payload,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiProblemDetails | void>({
        path: `/division/${divisionId}/dispatch-portal`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name HarborDuesListById
     * @summary Получение настроек интеграции подразделения с HarborDues.
     * @request GET:/division/{id}/harbor-dues
     * @secure
     */
    harborDuesListById: (id: string, params: RequestParams = {}) =>
      this.request<ApiHarbourDuesDivisionSettings, void | ApiProblemDetails>({
        path: `/division/${id}/harbor-dues`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name HarborDuesUpdateById
     * @summary Обновление настроек и активности интеграции подразделения с HarborDues.
     * @request PUT:/division/{id}/harbor-dues
     * @secure
     */
    harborDuesUpdateById: (
      id: string,
      data: ApiHarborDuesUpdateSettings_Request_Payload,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/division/${id}/harbor-dues`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name OperationalApprovalListById
     * @summary Получение настроек интеграции подразделения с OperationalApproval.
     * @request GET:/division/{id}/operational-approval
     * @secure
     */
    operationalApprovalListById: (id: string, params: RequestParams = {}) =>
      this.request<ApiIntegrationOperationalApprovalDivisionSettings, void | ApiProblemDetails>({
        path: `/division/${id}/operational-approval`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name OperationalApprovalUpdateById
     * @summary Обновление настроек и активности интеграции подразделения с OperationalApproval.
     * @request PUT:/division/{id}/operational-approval
     * @secure
     */
    operationalApprovalUpdateById: (
      id: string,
      data: ApiOperationalApprovalUpdateSettings_Request_Payload,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/division/${id}/operational-approval`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name PortFeesListById
     * @summary Получение настроек интеграции подразделения с PortFees.
     * @request GET:/division/{id}/port-fees
     * @secure
     */
    portFeesListById: (id: string, params: RequestParams = {}) =>
      this.request<ApiPortFeesDivisionSettings, void | ApiProblemDetails>({
        path: `/division/${id}/port-fees`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name PortFeesUpdateById
     * @summary Обновление настроек и активности интеграции подразделения с PortFees.
     * @request PUT:/division/{id}/port-fees
     * @secure
     */
    portFeesUpdateById: (
      id: string,
      data: ApiPortFeesUpdateSettings_Request_Payload,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/division/${id}/port-fees`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name RadiusListById
     * @summary Получение настроек интеграции подразделения с Radius.
     * @request GET:/division/{id}/radius
     * @secure
     */
    radiusListById: (id: string, params: RequestParams = {}) =>
      this.request<ApiRadiusDivisionSettings, void | ApiProblemDetails>({
        path: `/division/${id}/radius`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name RadiusUpdateById
     * @summary Обновление настроек и активности интеграции подразделения с Radius.
     * @request PUT:/division/{id}/radius
     * @secure
     */
    radiusUpdateById: (
      id: string,
      data: ApiRadiusUpdateSettings_Request_Payload,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/division/${id}/radius`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name SettingsListByDivisionIds
     * @summary Получение настроек интеграций по подразделениям
     * @request GET:/division/settings
     * @secure
     */
    settingsListByDivisionIds: (
      query: ApiSettingsListByDivisionIdsParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiDivisionSettingsResponse, void>({
        path: `/division/settings`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name HeadList
     * @summary Получение ЦА
     * @request GET:/division/head
     * @secure
     */
    headList: (params: RequestParams = {}) =>
      this.request<ApiDivisionHeadPersisted, void | ApiProblemDetails>({
        path: `/division/head`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name HeadUpdate
     * @summary Обновление ЦА
     * @request PUT:/division/head
     * @secure
     */
    headUpdate: (data: ApiDivisionHead, params: RequestParams = {}) =>
      this.request<
        ApiDivisionHeadPersisted,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/head`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name DivisionDetailById
     * @summary Получение подразделения по идентификатору
     * @request GET:/division/{id}
     * @secure
     */
    divisionDetailById: (id: string, params: RequestParams = {}) =>
      this.request<
        | ApiDivisionBranchBasinPersisted
        | ApiDivisionBranchBasinPersistedTree
        | ApiDivisionBranchPersisted
        | ApiDivisionBranchPersistedTree
        | ApiDivisionDepartmentPersisted
        | ApiDivisionDepartmentPersistedTree
        | ApiDivisionHeadPersisted
        | ApiDivisionHeadPersistedTree
        | ApiDivisionPersistedTreeBase
        | ApiDivisionPortPersisted
        | ApiDivisionPortPersistedTree,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name BranchBasinListByQuery
     * @summary Получение бассейновых филиалов
     * @request GET:/division/branch-basin
     * @secure
     */
    branchBasinListByQuery: (query: ApiBranchBasinListByQueryParams, params: RequestParams = {}) =>
      this.request<ApiGetDivisionBranchBasinList_Response, void>({
        path: `/division/branch-basin`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name BranchBasinCreate
     * @summary Создание бассейнового филиала
     * @request POST:/division/branch-basin
     * @secure
     */
    branchBasinCreate: (
      data: ApiCreateDivisionBranchBasin_CreatingDivisionBranchBasin,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiDivisionBranchBasinPersisted,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/branch-basin`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name BranchBasinDetailById
     * @summary Получение бассейнового филиала
     * @request GET:/division/branch-basin/{id}
     * @secure
     */
    branchBasinDetailById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiDivisionBranchBasinPersisted,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/branch-basin/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name BranchBasinDeleteById
     * @summary Удаление бассейнового филиала
     * @request DELETE:/division/branch-basin/{id}
     * @secure
     */
    branchBasinDeleteById: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiProblemDetails | void>({
        path: `/division/branch-basin/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name BranchBasinUpdateById
     * @summary Обновление бассейнового филиала
     * @request PUT:/division/branch-basin/{id}
     * @secure
     */
    branchBasinUpdateById: (id: string, data: ApiDivisionBranchBasin, params: RequestParams = {}) =>
      this.request<
        ApiDivisionBranchBasinPersisted,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/branch-basin/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name BranchBasinDepartmentListById
     * @summary Получение управления филиала
     * @request GET:/division/branch-basin/{id}/department
     * @secure
     */
    branchBasinDepartmentListById: (id: string, params: RequestParams = {}) =>
      this.request<ApiDivisionsResponse, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/division/branch-basin/${id}/department`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name BranchBasinPortListById
     * @summary Получение портов филиала
     * @request GET:/division/branch-basin/{id}/port
     * @secure
     */
    branchBasinPortListById: (id: string, params: RequestParams = {}) =>
      this.request<ApiDivisionsResponse, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/division/branch-basin/${id}/port`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name DepartmentListByQuery
     * @summary Получение управлений
     * @request GET:/division/department
     * @secure
     */
    departmentListByQuery: (query: ApiDepartmentListByQueryParams, params: RequestParams = {}) =>
      this.request<ApiGetDivisionDepartmentList_Response, void>({
        path: `/division/department`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name DepartmentCreate
     * @summary Создание управления
     * @request POST:/division/department
     * @secure
     */
    departmentCreate: (
      data: ApiCreateDivisionDepartment_CreatingDivisionDepartment,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiDivisionDepartmentPersisted,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/department`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name DepartmentDetailById
     * @summary Получение департамента
     * @request GET:/division/department/{id}
     * @secure
     */
    departmentDetailById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiDivisionDepartmentPersisted,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/department/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name DepartmentDeleteById
     * @summary Удаление департамента
     * @request DELETE:/division/department/{id}
     * @secure
     */
    departmentDeleteById: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiProblemDetails | void>({
        path: `/division/department/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name DepartmentUpdateById
     * @summary Обновление управления
     * @request PUT:/division/department/{id}
     * @secure
     */
    departmentUpdateById: (id: string, data: ApiDivisionDepartment, params: RequestParams = {}) =>
      this.request<
        ApiDivisionDepartmentPersisted,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/department/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name DepartmentPortListById
     * @summary Получение портов управления
     * @request GET:/division/department/{id}/port
     * @secure
     */
    departmentPortListById: (id: string, params: RequestParams = {}) =>
      this.request<ApiDivisionsResponse, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/division/department/${id}/port`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name PortListByQuery
     * @summary Получение портов
     * @request GET:/division/port
     * @secure
     */
    portListByQuery: (query: ApiPortListByQueryParams, params: RequestParams = {}) =>
      this.request<ApiGetDivisionPortList_Response, void>({
        path: `/division/port`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name PortCreate
     * @summary Создание порта
     * @request POST:/division/port
     * @secure
     */
    portCreate: (data: ApiCreateDivisionPort_CreatingDivisionPort, params: RequestParams = {}) =>
      this.request<
        ApiDivisionPortPersisted,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/port`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name PortDetailById
     * @summary Получение порта
     * @request GET:/division/port/{id}
     * @secure
     */
    portDetailById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiDivisionPortPersisted,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/port/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name PortDeleteById
     * @summary Удаление порта
     * @request DELETE:/division/port/{id}
     * @secure
     */
    portDeleteById: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiProblemDetails | void>({
        path: `/division/port/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name PortUpdateById
     * @summary Обновление порта
     * @request PUT:/division/port/{id}
     * @secure
     */
    portUpdateById: (id: string, data: ApiDivisionPort, params: RequestParams = {}) =>
      this.request<
        ApiDivisionPortPersisted,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/port/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name PortServiceDefinitionListById
     * @summary Получение списка шаблонов услуг для порта
     * @request GET:/division/port/{id}/service-definition
     * @secure
     */
    portServiceDefinitionListById: (
      { id, ...query }: ApiPortServiceDefinitionListByIdParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiGetServiceDefinitionsResponse, ApiValidationProblemDetails | void>({
        path: `/division/port/${id}/service-definition`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name ArchiveCreateById
     * @summary Архивировать подразделение
     * @request POST:/division/{id}/archive
     * @secure
     */
    archiveCreateById: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/division/${id}/archive`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name UnarchiveCreateById
     * @summary Разархивировать подразделение
     * @request POST:/division/{id}/unarchive
     * @secure
     */
    unarchiveCreateById: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/division/${id}/unarchive`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name CanBeDeletedListById
     * @summary Проверка возможности удаления подразделения
     * @request GET:/division/{id}/can-be-deleted
     * @secure
     */
    canBeDeletedListById: (id: string, params: RequestParams = {}) =>
      this.request<ApiDivisionCanBeDeletedCheckResponse, void | ApiProblemDetails>({
        path: `/division/${id}/can-be-deleted`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name ServiceDefinitionListById
     * @summary Получение списка шаблонов услуг для подразделения
     * @request GET:/division/{id}/service-definition
     * @secure
     */
    serviceDefinitionListById: (
      { id, ...query }: ApiServiceDefinitionListByIdParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiGetServiceDefinitionsResponse, ApiValidationProblemDetails | void>({
        path: `/division/${id}/service-definition`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name AgreementDefinitionListById
     * @summary Получение списка шаблонов договоров для подразделения
     * @request GET:/division/{id}/agreement-definition
     * @secure
     */
    agreementDefinitionListById: (
      { id, ...query }: ApiAgreementDefinitionListByIdParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiGetAgreementDefinitionsByDivisionIdResponse,
        ApiValidationProblemDetails | void
      >({
        path: `/division/${id}/agreement-definition`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name PublicOfferDefinitionListById
     * @summary Получение списка шаблонов публичных оферт
     * @request GET:/division/{id}/public-offer-definition
     * @secure
     */
    publicOfferDefinitionListById: (
      { id, ...query }: ApiPublicOfferDefinitionListByIdParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiGetPublicOfferDefinitionsByDivisionIdResponse,
        ApiValidationProblemDetails | void
      >({
        path: `/division/${id}/public-offer-definition`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name GuaranteeLetterDefinitionListById
     * @summary Получение списка шаблонов гарантийного письма
     * @request GET:/division/{id}/guarantee-letter-definition
     * @secure
     */
    guaranteeLetterDefinitionListById: (
      { id, ...query }: ApiGuaranteeLetterDefinitionListByIdParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiGetGuaranteeLetterDefinitionsByDivisionIdResponse,
        ApiValidationProblemDetails | void
      >({
        path: `/division/${id}/guarantee-letter-definition`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name InvoiceDocumentTemplateCreateById
     * @summary Привязка шаблона счета к подразделению
     * @request POST:/division/{id}/invoice-document-template
     * @secure
     */
    invoiceDocumentTemplateCreateById: (
      id: string,
      data: ApiDivisionsAssignInvoiceDocumentTemplate_InvoiceDocumentTemplate,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiAssignInvoiceDocumentTemplateResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/${id}/invoice-document-template`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name InvoiceDocumentTemplateListById
     * @summary Получение шаблона счета по идентификатору подразделения
     * @request GET:/division/{id}/invoice-document-template
     * @secure
     */
    invoiceDocumentTemplateListById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiGetDocumentTemplateResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/${id}/invoice-document-template`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name DivisionList
     * @summary Получение оргструктуры предприятия
     * @request GET:/division
     * @secure
     */
    divisionList: (params: RequestParams = {}) =>
      this.request<ApiGetDivisionStructure_Response, void>({
        path: `/division`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions
     * @name AccessList
     * @summary Получение точной области доступных подразделений текущего сотрудника.
     * @request GET:/division/access
     * @secure
     */
    accessList: (params: RequestParams = {}) =>
      this.request<ApiRmpDivisionAccessFilter, void>({
        path: `/division/access`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-employee:read</li></ul>
     *
     * @tags Divisions - Employees
     * @name EmployeeListByDivisionId
     * @summary Получить сотрудников подразделения
     * @request GET:/division/{divisionId}/employee
     * @secure
     */
    employeeListByDivisionId: (
      { divisionId, ...query }: ApiEmployeeListByDivisionIdParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiOfficeEmployeesResponse, ApiValidationProblemDetails | void>({
        path: `/division/${divisionId}/employee`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-employee:create</li></ul>
     *
     * @tags Divisions - Employees
     * @name EmployeeCreateByDivisionId
     * @summary Создание сотрудника офиса
     * @request POST:/division/{divisionId}/employee
     * @secure
     */
    employeeCreateByDivisionId: (
      { divisionId, ...query }: ApiEmployeeCreateByDivisionIdParams,
      data: ApiEmployeeCreateByDivisionIdPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/division/${divisionId}/employee`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-employee:read</li></ul>
     *
     * @tags Divisions - Employees
     * @name EmployeeDetailByDivisionId
     * @summary Получить сотрудника подразделения
     * @request GET:/division/{divisionId}/employee/{id}
     * @secure
     */
    employeeDetailByDivisionId: (divisionId: string, id: string, params: RequestParams = {}) =>
      this.request<ApiOfficeEmployeeResponse, ApiValidationProblemDetails | void>({
        path: `/division/${divisionId}/employee/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-employee:update</li></ul>
     *
     * @tags Divisions - Employees
     * @name EmployeeUpdateByDivisionId
     * @summary Обновление сотрудника офиса
     * @request PUT:/division/{divisionId}/employee/{id}
     * @secure
     */
    employeeUpdateByDivisionId: (
      divisionId: string,
      id: string,
      data: ApiEmployeeUpdateByDivisionIdPayload,
      params: RequestParams = {},
    ) =>
      this.request<ApiMediatRUnit, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/division/${divisionId}/employee/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-employee:read</li></ul>
     *
     * @tags Divisions - Employees
     * @name EmployeeProfileListByDivisionId
     * @summary Получить профиль сотрудника
     * @request GET:/division/{divisionId}/employee/{id}/profile
     * @secure
     */
    employeeProfileListByDivisionId: (divisionId: string, id: string, params: RequestParams = {}) =>
      this.request<
        ApiOfficeEmployeeProfilePersisted,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/${divisionId}/employee/${id}/profile`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-employee:update</li></ul>
     *
     * @tags Divisions - Employees
     * @name EmployeeActivateCreateByDivisionId
     * @summary Активировать сотрудника
     * @request POST:/division/{divisionId}/employee/{id}/activate
     * @secure
     */
    employeeActivateCreateByDivisionId: (
      divisionId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/division/${divisionId}/employee/${id}/activate`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-employee:update</li></ul>
     *
     * @tags Divisions - Employees
     * @name EmployeeDeactivateCreateByDivisionId
     * @summary Деактивировать сотрудника
     * @request POST:/division/{divisionId}/employee/{id}/deactivate
     * @secure
     */
    employeeDeactivateCreateByDivisionId: (
      divisionId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/division/${divisionId}/employee/${id}/deactivate`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions - Notifications
     * @name NotificationDefinitionTemplateOverridesListByDivisionId
     * @summary Получить признаки переопределения дефолтных шаблонов писем подразделения
     * @request GET:/division/{divisionId}/notification-definition/template-overrides
     * @secure
     */
    notificationDefinitionTemplateOverridesListByDivisionId: (
      divisionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiGetNotificationDefinitionTemplateOverridesResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/division/${divisionId}/notification-definition/template-overrides`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions - Notifications
     * @name NotificationDefinitionTemplateListByNotificationDefinitionId
     * @summary Получение шаблона письма
     * @request GET:/division/{divisionId}/notification-definition/{notificationDefinitionId}/template
     * @secure
     */
    notificationDefinitionTemplateListByNotificationDefinitionId: (
      notificationDefinitionId: string,
      divisionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiGetNotificationDefinitionTemplateResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/division/${divisionId}/notification-definition/${notificationDefinitionId}/template`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions - Notifications
     * @name NotificationDefinitionTemplateDeleteByNotificationDefinitionId
     * @summary Сброс кастомного шаблона письма подразделения
     * @request DELETE:/division/{divisionId}/notification-definition/{notificationDefinitionId}/template
     * @secure
     */
    notificationDefinitionTemplateDeleteByNotificationDefinitionId: (
      notificationDefinitionId: string,
      divisionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiResetNotificationTemplateResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/${divisionId}/notification-definition/${notificationDefinitionId}/template`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions - Notifications
     * @name NotificationDefinitionTemplateCreateByDivisionId
     * @summary Создать шаблон письма
     * @request POST:/division/{divisionId}/notification-definition/{notificationDefinitionId}/template
     * @secure
     */
    notificationDefinitionTemplateCreateByDivisionId: (
      divisionId: string,
      notificationDefinitionId: string,
      data: ApiCreateNotificationTemplateRequest_CreatedNotificationTemplate,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCreateNotificationTemplateResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/division/${divisionId}/notification-definition/${notificationDefinitionId}/template`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions - Notifications
     * @name NotificationDefinitionTemplateUpdateByNotificationDefinitionId
     * @summary Обновить шаблон письма
     * @request PUT:/division/{divisionId}/notification-definition/{notificationDefinitionId}/template
     * @secure
     */
    notificationDefinitionTemplateUpdateByNotificationDefinitionId: (
      notificationDefinitionId: string,
      divisionId: string,
      data: ApiUpdateNotificationTemplateRequest_UpdatedNotificationTemplate,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiUpdateNotificationTemplateResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/division/${divisionId}/notification-definition/${notificationDefinitionId}/template`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions - Notifications
     * @name FooterCreateByDivisionId
     * @summary Создать шаблон футера
     * @request POST:/division/{divisionId}/footer
     * @secure
     */
    footerCreateByDivisionId: (
      divisionId: string,
      data: ApiNotificationsFooterTemplate,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiNotificationsCreateFooterTemplateResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/division/${divisionId}/footer`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions - Notifications
     * @name NotificationDefinitionRecipientRuleListByNotificationDefinitionId
     * @summary Получить правило получателей письма
     * @request GET:/division/{divisionId}/notification-definition/{notificationDefinitionId}/recipient-rule
     * @secure
     */
    notificationDefinitionRecipientRuleListByNotificationDefinitionId: (
      notificationDefinitionId: string,
      divisionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiGetNotificationDefinitionRecipientRuleResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/division/${divisionId}/notification-definition/${notificationDefinitionId}/recipient-rule`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions - Notifications
     * @name NotificationDefinitionRecipientRuleTargetCreateByNotificationDefinitionId
     * @summary Создать правило получателей письма с типом получателя TargetUser
     * @request POST:/division/{divisionId}/notification-definition/{notificationDefinitionId}/recipient-rule/target
     * @secure
     */
    notificationDefinitionRecipientRuleTargetCreateByNotificationDefinitionId: (
      notificationDefinitionId: string,
      divisionId: string,
      data: ApiTargetUserRecipientRule,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiNotificationsCreateRecipientRuleResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/division/${divisionId}/notification-definition/${notificationDefinitionId}/recipient-rule/target`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions - Notifications
     * @name NotificationDefinitionRecipientRuleTargetUpdateByDivisionId
     * @summary Обновить шаблон правил получателей письма с типом получателей TargetUser
     * @request PUT:/division/{divisionId}/notification-definition/{notificationDefinitionId}/recipient-rule/target
     * @secure
     */
    notificationDefinitionRecipientRuleTargetUpdateByDivisionId: (
      divisionId: string,
      notificationDefinitionId: string,
      data: ApiTargetUserRecipientRule,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiNotificationsUpdateRecipientRuleResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/division/${divisionId}/notification-definition/${notificationDefinitionId}/recipient-rule/target`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions - Notifications
     * @name NotificationDefinitionRecipientRuleCounterpartyCreateByNotificationDefinitionId
     * @summary Создать правило получателей письма с типом получателя CounterpartyEmployee
     * @request POST:/division/{divisionId}/notification-definition/{notificationDefinitionId}/recipient-rule/counterparty
     * @secure
     */
    notificationDefinitionRecipientRuleCounterpartyCreateByNotificationDefinitionId: (
      notificationDefinitionId: string,
      divisionId: string,
      data: ApiCounterpartyEmployeeRecipientRule,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiNotificationsCreateRecipientRuleResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/division/${divisionId}/notification-definition/${notificationDefinitionId}/recipient-rule/counterparty`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions - Notifications
     * @name NotificationDefinitionRecipientRuleCounterpartyUpdateByDivisionId
     * @summary Обновить шаблон правил получателей письма с типом получателей CounterpartyEmployee
     * @request PUT:/division/{divisionId}/notification-definition/{notificationDefinitionId}/recipient-rule/counterparty
     * @secure
     */
    notificationDefinitionRecipientRuleCounterpartyUpdateByDivisionId: (
      divisionId: string,
      notificationDefinitionId: string,
      data: ApiCounterpartyEmployeeRecipientRule,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiNotificationsUpdateRecipientRuleResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/division/${divisionId}/notification-definition/${notificationDefinitionId}/recipient-rule/counterparty`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions - Notifications
     * @name NotificationDefinitionRecipientRuleEnterpriseCreateByNotificationDefinitionId
     * @summary Создать правило получателей письма с типом получателя EnterpriseEmployee
     * @request POST:/division/{divisionId}/notification-definition/{notificationDefinitionId}/recipient-rule/enterprise
     * @secure
     */
    notificationDefinitionRecipientRuleEnterpriseCreateByNotificationDefinitionId: (
      notificationDefinitionId: string,
      divisionId: string,
      data: ApiEnterpriseEmployeeRecipientRule,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiNotificationsCreateRecipientRuleResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/division/${divisionId}/notification-definition/${notificationDefinitionId}/recipient-rule/enterprise`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions - Notifications
     * @name NotificationDefinitionRecipientRuleEnterpriseUpdateByDivisionId
     * @summary Обновить шаблон правил получателей письма с типом получателей EnterpriseEmployee
     * @request PUT:/division/{divisionId}/notification-definition/{notificationDefinitionId}/recipient-rule/enterprise
     * @secure
     */
    notificationDefinitionRecipientRuleEnterpriseUpdateByDivisionId: (
      divisionId: string,
      notificationDefinitionId: string,
      data: ApiEnterpriseEmployeeRecipientRule,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiNotificationsUpdateRecipientRuleResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/division/${divisionId}/notification-definition/${notificationDefinitionId}/recipient-rule/enterprise`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Enterprise - Bank accounts
     * @name BankAccountListByDivisionId
     * @summary Получение банковских реквизитов подразделения.
     * @request GET:/division/{divisionId}/bank-account
     * @secure
     */
    bankAccountListByDivisionId: (
      { divisionId, ...query }: ApiBankAccountListByDivisionIdParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiDivisionBankAccountsResponse, void | ApiProblemDetails>({
        path: `/division/${divisionId}/bank-account`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Enterprise - Bank accounts
     * @name BankAccountCreateByDivisionId
     * @summary Добавление банковских реквизитов подразделения.
     * @request POST:/division/{divisionId}/bank-account
     * @secure
     */
    bankAccountCreateByDivisionId: (
      divisionId: string,
      data: ApiBankAccountCreateByDivisionIdPayload,
      params: RequestParams = {},
    ) =>
      this.request<ApiDivisionBankAccountResponse, ApiProblemDetails | void>({
        path: `/division/${divisionId}/bank-account`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Enterprise - Bank accounts
     * @name BankAccountUpdateByDivisionId
     * @summary Изменение или архивация банковских реквизитов подразделения.
     * @request PUT:/division/{divisionId}/bank-account/{bankAccountId}
     * @secure
     */
    bankAccountUpdateByDivisionId: (
      divisionId: string,
      bankAccountId: string,
      data: ApiBankAccountUpdateByDivisionIdPayload,
      params: RequestParams = {},
    ) =>
      this.request<ApiDivisionBankAccountResponse, ApiProblemDetails | void>({
        path: `/division/${divisionId}/bank-account/${bankAccountId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Enterprise - Contacts
     * @name ContactListByQuery
     * @summary Получение контактов подразделения.
     * @request GET:/division/{divisionId}/contact
     * @secure
     */
    contactListByQuery: (
      { divisionId, ...query }: ApiContactListByQueryParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiDivisionContactResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/division/${divisionId}/contact`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Enterprise - Contacts
     * @name ContactCreateByDivisionId
     * @summary Создание контактов подразделения.
     * @request POST:/division/{divisionId}/contact
     * @secure
     */
    contactCreateByDivisionId: (
      divisionId: string,
      data: ApiDivisionContact,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiDivisionContactCreateResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/${divisionId}/contact`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Enterprise - Contacts
     * @name ContactHourListByDivisionId
     * @summary Получение времени работы.
     * @request GET:/division/{divisionId}/contact/{contactId}/hour
     * @secure
     */
    contactHourListByDivisionId: (
      divisionId: string,
      contactId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiDivisionContactHoursResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/division/${divisionId}/contact/${contactId}/hour`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Enterprise - Contacts
     * @name ContactHourCreateByContactId
     * @summary Создание времени работы.
     * @request POST:/division/{divisionId}/contact/{contactId}/hour
     * @secure
     */
    contactHourCreateByContactId: (
      contactId: string,
      divisionId: string,
      data: ApiDivisionContactHours,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiDivisionContactHoursCreateResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/${divisionId}/contact/${contactId}/hour`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Enterprise - Contacts
     * @name ContactDetailByContactId
     * @summary Получение контакта.
     * @request GET:/division/{divisionId}/contact/{contactId}
     * @secure
     */
    contactDetailByContactId: (contactId: string, divisionId: string, params: RequestParams = {}) =>
      this.request<
        ApiDivisionContactByIdResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/division/${divisionId}/contact/${contactId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Enterprise - Contacts
     * @name ContactUpdateByContactId
     * @summary Обновление контактов филиала.
     * @request PUT:/division/{divisionId}/contact/{contactId}
     * @secure
     */
    contactUpdateByContactId: (
      contactId: string,
      divisionId: string,
      data: ApiDivisionContact,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiDivisionContactUpdateResponse,
        | ApiValidationProblemDetails
        | void
        | ApiSwaggerDefault404NotFoundExamples
        | ApiProblemDetails
      >({
        path: `/division/${divisionId}/contact/${contactId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Enterprise - Contacts
     * @name ContactDeleteByContactId
     * @summary Удалить существующий контакт для подразделения
     * @request DELETE:/division/{divisionId}/contact/{contactId}
     * @secure
     */
    contactDeleteByContactId: (contactId: string, divisionId: string, params: RequestParams = {}) =>
      this.request<
        ApiDivisionContactDeleteResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/${divisionId}/contact/${contactId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Enterprise - Contacts
     * @name ContactHourUpdateByHourId
     * @summary Обновление существующего времени работы.
     * @request PUT:/division/{divisionId}/contact/{contactId}/hour/{hourId}
     * @secure
     */
    contactHourUpdateByHourId: (
      hourId: string,
      divisionId: string,
      contactId: string,
      data: ApiDivisionContactHours,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiDivisionContactHoursUpdateResponse,
        | ApiValidationProblemDetails
        | void
        | ApiSwaggerDefault404NotFoundExamples
        | ApiProblemDetails
      >({
        path: `/division/${divisionId}/contact/${contactId}/hour/${hourId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Enterprise - Contacts
     * @name ContactHourDeleteByHourId
     * @summary Удалить существующее время работы
     * @request DELETE:/division/{divisionId}/contact/{contactId}/hour/{hourId}
     * @secure
     */
    contactHourDeleteByHourId: (
      hourId: string,
      divisionId: string,
      contactId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiDivisionContactHoursDeleteResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/division/${divisionId}/contact/${contactId}/hour/${hourId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  notificationDefinition = {
    /**
     * No description
     *
     * @tags Divisions - Notifications
     * @name NotificationDefinitionListByRecipientType
     * @summary Получить список типов писем
     * @request GET:/notification-definition
     * @secure
     */
    notificationDefinitionListByRecipientType: (
      query: ApiNotificationDefinitionListByRecipientTypeParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiGetNotificationDefinitionTypesResponse, void>({
        path: `/notification-definition`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Divisions - Notifications
     * @name DefaultTemplateListByNotificationDefinitionId
     * @summary Получение дефолтного шаблона письма
     * @request GET:/notification-definition/{notificationDefinitionId}/default-template
     * @secure
     */
    defaultTemplateListByNotificationDefinitionId: (
      notificationDefinitionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiGetNotificationDefinitionTemplateResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/notification-definition/${notificationDefinitionId}/default-template`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  footer = {
    /**
     * No description
     *
     * @tags Divisions - Notifications
     * @name FooterUpdateById
     * @summary Обновить шаблон футера
     * @request PUT:/footer/{id}
     * @secure
     */
    footerUpdateById: (
      id: string,
      data: ApiNotificationsFooterTemplate,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiNotificationsUpdateFooterTemplateResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/footer/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  documentTemplate = {
    /**
     * No description
     *
     * @tags DocumentTemplates
     * @name DocumentTemplateCreate
     * @summary Создание шаблона документа
     * @request POST:/document-template
     * @secure
     */
    documentTemplateCreate: (
      data: ApiCreateDocumentTemplate_DocumentTemplate,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCreateDocumentTemplateResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/document-template`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  own = {
    /**
     * No description
     *
     * @tags Entrepreneur
     * @name CounterpartyEntrepreneurList
     * @summary Получить текущего ИП
     * @request GET:/own/counterparty/entrepreneur
     * @secure
     */
    counterpartyEntrepreneurList: (params: RequestParams = {}) =>
      this.request<ApiCounterpartyEntrepreneurResponse, void | ApiProblemDetails>({
        path: `/own/counterparty/entrepreneur`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entrepreneur
     * @name CounterpartyEntrepreneurEmployeeListByEmployeeEmail
     * @summary Получить список сотрудников контрагента
     * @request GET:/own/counterparty/entrepreneur/employee
     * @secure
     */
    counterpartyEntrepreneurEmployeeListByEmployeeEmail: (
      query: ApiCounterpartyEntrepreneurEmployeeListByEmployeeEmailParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartyEmployeePersistedEntrepreneur[],
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/own/counterparty/entrepreneur/employee`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entrepreneur
     * @name CounterpartyEntrepreneurEmployeeCreateByAssignToAccount
     * @summary Создание сотрудника контрагента
     * @request POST:/own/counterparty/entrepreneur/employee
     * @secure
     */
    counterpartyEntrepreneurEmployeeCreateByAssignToAccount: (
      query: ApiCounterpartyEntrepreneurEmployeeCreateByAssignToAccountParams,
      data: ApiCounterpartyEntrepreneurEmployeeCreateByAssignToAccountPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/own/counterparty/entrepreneur/employee`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entrepreneur
     * @name CounterpartyEntrepreneurEmployeeDetailByEmployeeId
     * @summary Получить сотрудника ИП по ID
     * @request GET:/own/counterparty/entrepreneur/employee/{employeeId}
     * @secure
     */
    counterpartyEntrepreneurEmployeeDetailByEmployeeId: (
      employeeId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartyEmployeePersistedEntrepreneur,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/own/counterparty/entrepreneur/employee/${employeeId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entrepreneur
     * @name CounterpartyEntrepreneurEmployeeUpdateByEmployeeId
     * @summary Изменение сотрудника контрагента
     * @request PUT:/own/counterparty/entrepreneur/employee/{employeeId}
     * @secure
     */
    counterpartyEntrepreneurEmployeeUpdateByEmployeeId: (
      employeeId: string,
      data: ApiCounterpartyEntrepreneurEmployeeUpdateByEmployeeIdPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/own/counterparty/entrepreneur/employee/${employeeId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags LegalEntity
     * @name CounterpartyLegalEntityList
     * @summary Получение текущего ЮЛ
     * @request GET:/own/counterparty/legal-entity
     * @secure
     */
    counterpartyLegalEntityList: (params: RequestParams = {}) =>
      this.request<ApiLegalEntityPersisted, void | ApiProblemDetails>({
        path: `/own/counterparty/legal-entity`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LegalEntity
     * @name CounterpartyLegalEntityEmployeeListByEmployeeEmail
     * @summary Получить список сотрудников текущего контрагента
     * @request GET:/own/counterparty/legal-entity/employee
     * @secure
     */
    counterpartyLegalEntityEmployeeListByEmployeeEmail: (
      query: ApiCounterpartyLegalEntityEmployeeListByEmployeeEmailParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartyEmployeePersistedLegalEntity[],
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/own/counterparty/legal-entity/employee`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LegalEntity
     * @name CounterpartyLegalEntityEmployeeCreateByAssignToAccount
     * @summary Создание сотрудника текущего контрагента
     * @request POST:/own/counterparty/legal-entity/employee
     * @secure
     */
    counterpartyLegalEntityEmployeeCreateByAssignToAccount: (
      query: ApiCounterpartyLegalEntityEmployeeCreateByAssignToAccountParams,
      data: ApiCounterpartyLegalEntityEmployeeCreateByAssignToAccountPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/own/counterparty/legal-entity/employee`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LegalEntity
     * @name CounterpartyLegalEntityEmployeeDetailByEmployeeId
     * @summary Получить сотрудника текущего контрагента по ID
     * @request GET:/own/counterparty/legal-entity/employee/{employeeId}
     * @secure
     */
    counterpartyLegalEntityEmployeeDetailByEmployeeId: (
      employeeId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCounterpartyEmployeePersistedLegalEntity,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/own/counterparty/legal-entity/employee/${employeeId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LegalEntity
     * @name CounterpartyLegalEntityEmployeeUpdateByEmployeeId
     * @summary Изменение сотрудника текущего контрагента
     * @request PUT:/own/counterparty/legal-entity/employee/{employeeId}
     * @secure
     */
    counterpartyLegalEntityEmployeeUpdateByEmployeeId: (
      employeeId: string,
      data: ApiCounterpartyLegalEntityEmployeeUpdateByEmployeeIdPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/own/counterparty/legal-entity/employee/${employeeId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags LegalEntity
     * @name CounterpartyLegalEntityHeadList
     * @summary Получить список руководителей текущего ЮЛ
     * @request GET:/own/counterparty/legal-entity/head
     * @secure
     */
    counterpartyLegalEntityHeadList: (params: RequestParams = {}) =>
      this.request<ApiLegalEntityHeadPersisted[], void | ApiProblemDetails>({
        path: `/own/counterparty/legal-entity/head`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LegalEntity
     * @name CounterpartyLegalEntityHeadDetailById
     * @summary Получить руководителя текущего ЮЛ
     * @request GET:/own/counterparty/legal-entity/head/{id}
     * @secure
     */
    counterpartyLegalEntityHeadDetailById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiLegalEntityHeadPersisted,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/own/counterparty/legal-entity/head/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Staff
     * @name StaffEmployeeListByRequest
     * @summary Получить текущего сотрудника
     * @request GET:/own/staff/employee
     * @secure
     */
    staffEmployeeListByRequest: (
      query: ApiStaffEmployeeListByRequestParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiEmployeeResponse, ApiValidationProblemDetails | void>({
        path: `/own/staff/employee`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  fns = {
    /**
     * No description
     *
     * @tags FNS
     * @name EgripEntrepreneurListByOgrn
     * @summary Получение индивидуального предпринимателя из ЕГРИП по ИНН, ОГРН
     * @request GET:/fns/egrip/entrepreneur
     * @secure
     */
    egripEntrepreneurListByOgrn: (
      query: ApiEgripEntrepreneurListByOgrnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiEgrulEgripEntrepreneur, void>({
        path: `/fns/egrip/entrepreneur`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FNS
     * @name EgripEntrepreneurInnListByInn
     * @summary Получение индивидуального предпринимателя из ЕГРИП по ИНН
     * @request GET:/fns/egrip/entrepreneur/inn
     * @secure
     */
    egripEntrepreneurInnListByInn: (
      query: ApiEgripEntrepreneurInnListByInnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiEgrulEgripEntrepreneur, void>({
        path: `/fns/egrip/entrepreneur/inn`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FNS
     * @name EgripEntrepreneurOgrnListByOgrn
     * @summary Получение индивидуального предпринимателя из ЕГРИП по ОГРН
     * @request GET:/fns/egrip/entrepreneur/ogrn
     * @secure
     */
    egripEntrepreneurOgrnListByOgrn: (
      query: ApiEgripEntrepreneurOgrnListByOgrnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiEgrulEgripEntrepreneur, void>({
        path: `/fns/egrip/entrepreneur/ogrn`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FNS
     * @name EgrulLegalEntityListByOgrn
     * @summary Получение организации из ЕГРЮЛ по ИНН, ОГРН, КПП
     * @request GET:/fns/egrul/legal-entity
     * @secure
     */
    egrulLegalEntityListByOgrn: (
      query: ApiEgrulLegalEntityListByOgrnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiEgrulLegalEntity, void>({
        path: `/fns/egrul/legal-entity`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FNS
     * @name EgrulLegalEntityInnListByInn
     * @summary Получение организации из ЕГРЮЛ по ИНН
     * @request GET:/fns/egrul/legal-entity/inn
     * @secure
     */
    egrulLegalEntityInnListByInn: (
      query: ApiEgrulLegalEntityInnListByInnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiEgrulLegalEntity, void>({
        path: `/fns/egrul/legal-entity/inn`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FNS
     * @name EgrulLegalEntityOgrnListByOgrn
     * @summary Получение организации из ЕГРЮЛ по ОГРН
     * @request GET:/fns/egrul/legal-entity/ogrn
     * @secure
     */
    egrulLegalEntityOgrnListByOgrn: (
      query: ApiEgrulLegalEntityOgrnListByOgrnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiEgrulLegalEntity, void>({
        path: `/fns/egrul/legal-entity/ogrn`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-fns:update</li></ul>
     *
     * @tags FNS
     * @name UpToDateLegalEntityUpdateByInn
     * @summary Включение обновления ЮЛ из ЕГРЮЛ по ИНН, ОГРН, КПП и суррогатного внутреннего идентификатора
     * @request PUT:/fns/up-to-date/legal-entity
     * @secure
     */
    upToDateLegalEntityUpdateByInn: (
      query: ApiUpToDateLegalEntityUpdateByInnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiFnsEnableUpToDateLegalEntityResponse, void>({
        path: `/fns/up-to-date/legal-entity`,
        method: 'PUT',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-fns:update</li></ul>
     *
     * @tags FNS
     * @name UpToDateLegalEntityDeleteByInn
     * @summary Выключение обновления ЮЛ из ЕГРЮЛ по ИНН, ОГРН, КПП и суррогатного внутреннего идентификатора
     * @request DELETE:/fns/up-to-date/legal-entity
     * @secure
     */
    upToDateLegalEntityDeleteByInn: (
      query: ApiUpToDateLegalEntityDeleteByInnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiFnsDisableUpToDateLegalEntityResponse, void>({
        path: `/fns/up-to-date/legal-entity`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-fns:read</li></ul>
     *
     * @tags FNS
     * @name UpToDateLegalEntityListByInn
     * @summary Получение информации об обновлении ЮЛ из ЕГРЮЛ по ИНН, ОГРН, КПП
     * @request GET:/fns/up-to-date/legal-entity
     * @secure
     */
    upToDateLegalEntityListByInn: (
      query: ApiUpToDateLegalEntityListByInnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiFnsUpToDateLegalEntityResponse, void>({
        path: `/fns/up-to-date/legal-entity`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-fns:update</li></ul>
     *
     * @tags FNS
     * @name UpToDateLegalEntityForceCreateByInn
     * @summary Принудительное обновление ЮЛ из ЕГРЮЛ по ИНН, ОГРН, КПП и суррогатного внутреннего идентификатора
     * @request POST:/fns/up-to-date/legal-entity/force
     * @secure
     */
    upToDateLegalEntityForceCreateByInn: (
      query: ApiUpToDateLegalEntityForceCreateByInnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiFnsForceCheckUpToDateLegalEntityResponse, void>({
        path: `/fns/up-to-date/legal-entity/force`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-fns:update</li></ul>
     *
     * @tags FNS
     * @name UpToDateEntrepreneurUpdateByInn
     * @summary Включение обновления ИП из ЕГРИП по ИНН, ОГРН и суррогатного внутреннего идентификатора
     * @request PUT:/fns/up-to-date/entrepreneur
     * @secure
     */
    upToDateEntrepreneurUpdateByInn: (
      query: ApiUpToDateEntrepreneurUpdateByInnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiFnsEnableUpToDateEntrepreneurResponse, void>({
        path: `/fns/up-to-date/entrepreneur`,
        method: 'PUT',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-fns:update</li></ul>
     *
     * @tags FNS
     * @name UpToDateEntrepreneurDeleteByInn
     * @summary Выключение обновления ЮЛ из ЕГРЮЛ по ИНН, ОГРН и суррогатного внутреннего идентификатора
     * @request DELETE:/fns/up-to-date/entrepreneur
     * @secure
     */
    upToDateEntrepreneurDeleteByInn: (
      query: ApiUpToDateEntrepreneurDeleteByInnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiFnsDisableUpToDateEntrepreneurResponse, void>({
        path: `/fns/up-to-date/entrepreneur`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-fns:read</li></ul>
     *
     * @tags FNS
     * @name UpToDateEntrepreneurListByInn
     * @summary Получение информации об обновлении ИП из ЕГРИП по ИНН, ОГРН
     * @request GET:/fns/up-to-date/entrepreneur
     * @secure
     */
    upToDateEntrepreneurListByInn: (
      query: ApiUpToDateEntrepreneurListByInnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiFnsUpToDateEntrepreneur, void>({
        path: `/fns/up-to-date/entrepreneur`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-fns:update</li></ul>
     *
     * @tags FNS
     * @name UpToDateEntrepreneurForceCreateByInn
     * @summary Принудительное обновление ИП из ЕГРИП по ИНН, ОГРН и суррогатного внутреннего идентификатора
     * @request POST:/fns/up-to-date/entrepreneur/force
     * @secure
     */
    upToDateEntrepreneurForceCreateByInn: (
      query: ApiUpToDateEntrepreneurForceCreateByInnParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiFnsForceCheckUpToDateEntrepreneurResponse, void>({
        path: `/fns/up-to-date/entrepreneur/force`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  serviceDefinition = {
    /**
     * No description
     *
     * @tags GuaranteeLetterDefinition
     * @name GuaranteeLetterListByServiceDefinitionId
     * @summary Неархивные настройки гарантийного письма услуги
     * @request GET:/service-definition/{serviceDefinitionId}/guarantee-letter
     * @secure
     */
    guaranteeLetterListByServiceDefinitionId: (
      serviceDefinitionId: string,
      params: RequestParams = {},
    ) =>
      this.request<ApiGetGuaranteeLetterDefinitionByServiceDefinitionIdResponse, void>({
        path: `/service-definition/${serviceDefinitionId}/guarantee-letter`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GuaranteeLetterDefinition
     * @name GuaranteeLetterDocumentTemplateListByServiceDefinitionId
     * @summary Получить шаблон гарантийного письма услуги
     * @request GET:/service-definition/{serviceDefinitionId}/guarantee-letter/document-template
     * @secure
     */
    guaranteeLetterDocumentTemplateListByServiceDefinitionId: (
      serviceDefinitionId: string,
      params: RequestParams = {},
    ) =>
      this.request<ApiGetDocumentTemplateResponse, void>({
        path: `/service-definition/${serviceDefinitionId}/guarantee-letter/document-template`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name TransitionListById
     * @summary Метод получения доступных в рамках шаблона услуг переходов
     * @request GET:/service-definition/{id}/transition
     * @secure
     */
    transitionListById: (id: string, params: RequestParams = {}) =>
      this.request<ApiGetServiceDefinitionTransitionsResponse, ApiValidationProblemDetails | void>({
        path: `/service-definition/${id}/transition`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name SetTransitionPermissionRolesCreate
     * @summary Метод установки разрешения для роли на выполнение перехода.
     * @request POST:/service-definition/set-transition-permission-roles
     * @secure
     */
    setTransitionPermissionRolesCreate: (
      data: ApiSetServiceDefinitionTransitionPermissionRoles_Request_Payload,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/service-definition/set-transition-permission-roles`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name RoleTransitionsListById
     * @summary Метод получения списка ролей, доступных для переходов рабочего процесса шаблона услуги.
     * @request GET:/service-definition/{id}/role-transitions
     * @secure
     */
    roleTransitionsListById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiGetServiceDefinitionRoleTransitionsResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/service-definition/${id}/role-transitions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name ServiceDefinitionDetailById
     * @summary Получение шаблона услуги
     * @request GET:/service-definition/{id}
     * @secure
     */
    serviceDefinitionDetailById: (id: string, params: RequestParams = {}) =>
      this.request<ApiGetServiceDefinitionResponse, ApiValidationProblemDetails | void>({
        path: `/service-definition/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name ServiceDefinitionUpdateById
     * @summary Обновление шаблона услуги
     * @request PUT:/service-definition/{id}
     * @secure
     */
    serviceDefinitionUpdateById: (
      id: string,
      data: ApiServiceDefinitionForUpdate,
      params: RequestParams = {},
    ) =>
      this.request<ApiUpdateServiceDefinitionResponse, ApiValidationProblemDetails | void>({
        path: `/service-definition/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name ProfileDefaultsDetailByServiceType
     * @summary Получение начального профиля шаблона для вида услуг
     * @request GET:/service-definition/profile-defaults/{serviceType}
     * @secure
     */
    profileDefaultsDetailByServiceType: (serviceType: ApiServiceType, params: RequestParams = {}) =>
      this.request<
        ApiGetServiceDefinitionProfileDefaultsResponse,
        ApiValidationProblemDetails | void
      >({
        path: `/service-definition/profile-defaults/${serviceType}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name ConfirmationDocumentSettingsListByServiceDefinitionId
     * @summary Получение настроек подтверждающего документа оказания услуги для шаблона услуги
     * @request GET:/service-definition/{serviceDefinitionId}/confirmation-document-settings
     * @secure
     */
    confirmationDocumentSettingsListByServiceDefinitionId: (
      serviceDefinitionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiServiceConfirmationDocumentSettings,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/service-definition/${serviceDefinitionId}/confirmation-document-settings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name ConfirmationDocumentSettingsCreateByServiceDefinitionId
     * @summary Создание настроек подтверждающего документа оказания услуги для шаблона услуги
     * @request POST:/service-definition/{serviceDefinitionId}/confirmation-document-settings
     * @secure
     */
    confirmationDocumentSettingsCreateByServiceDefinitionId: (
      serviceDefinitionId: string,
      data: ApiServiceConfirmationDocumentSettingsForCreate,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCreateServiceConfirmationDocumentSettingsResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/service-definition/${serviceDefinitionId}/confirmation-document-settings`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name ConfirmationDocumentTemplateListById
     * @summary Получение шаблона подтверждающего документа оказания услуги
     * @request GET:/service-definition/{id}/confirmation-document-template
     * @secure
     */
    confirmationDocumentTemplateListById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiGetDocumentTemplateResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/service-definition/${id}/confirmation-document-template`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name ConfirmationDocumentTemplateCreateById
     * @summary Создание или замена шаблона подтверждающего документа оказания услуги
     * @request POST:/service-definition/{id}/confirmation-document-template
     * @secure
     */
    confirmationDocumentTemplateCreateById: (
      id: string,
      data: ApiServiceDefinitionsCreateServiceConfirmationDocumentTemplate_DocumentTemplate,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCreateServiceConfirmationDocumentTemplateResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/service-definition/${id}/confirmation-document-template`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name TariffListByServiceDefinitionId
     * @summary Получение тарифов шаблона услуги
     * @request GET:/service-definition/{serviceDefinitionId}/tariff
     * @secure
     */
    tariffListByServiceDefinitionId: (
      { serviceDefinitionId, ...query }: ApiTariffListByServiceDefinitionIdParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiGetServiceDefinitionTariffs_Response, ApiValidationProblemDetails | void>({
        path: `/service-definition/${serviceDefinitionId}/tariff`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name TariffAlgorithmListByServiceDefinitionId
     * @summary Получение алгоритмов тарификации шаблона услуги
     * @request GET:/service-definition/{serviceDefinitionId}/tariff-algorithm
     * @secure
     */
    tariffAlgorithmListByServiceDefinitionId: (
      serviceDefinitionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiServicesGetTariffAlgorithmsResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/service-definition/${serviceDefinitionId}/tariff-algorithm`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name ServiceDefinitionCreate
     * @summary Создание шаблона услуги
     * @request POST:/service-definition
     * @secure
     */
    serviceDefinitionCreate: (data: ApiServiceDefinitionForCreate, params: RequestParams = {}) =>
      this.request<ApiCreateServiceDefinitionResponse, ApiValidationProblemDetails | void>({
        path: `/service-definition`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name ArchiveUpdateById
     * @summary Архивация шаблона услуги
     * @request PUT:/service-definition/{id}/archive
     * @secure
     */
    archiveUpdateById: (id: string, params: RequestParams = {}) =>
      this.request<ApiToggleArchiveServiceDefinitionResponse, ApiValidationProblemDetails | void>({
        path: `/service-definition/${id}/archive`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name UnarchiveUpdateById
     * @summary Разархивация шаблона услуги
     * @request PUT:/service-definition/{id}/unarchive
     * @secure
     */
    unarchiveUpdateById: (id: string, params: RequestParams = {}) =>
      this.request<ApiToggleArchiveServiceDefinitionResponse, ApiValidationProblemDetails | void>({
        path: `/service-definition/${id}/unarchive`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name ConfirmationDocumentSettingsUpdateByServiceDefinitionId
     * @summary Обновление настроек подтверждающего документа оказания услуги
     * @request PUT:/service-definition/{serviceDefinitionId}/confirmation-document-settings/{confirmationDocumentSettingsId}
     * @secure
     */
    confirmationDocumentSettingsUpdateByServiceDefinitionId: (
      serviceDefinitionId: string,
      confirmationDocumentSettingsId: string,
      data: ApiServiceConfirmationDocumentSettingsForUpdate,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiUpdateServiceConfirmationDocumentSettingsResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/service-definition/${serviceDefinitionId}/confirmation-document-settings/${confirmationDocumentSettingsId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name ConfirmationDocumentSettingsDeleteByServiceDefinitionId
     * @summary Удаление настроек подтверждающего документа оказания услуги
     * @request DELETE:/service-definition/{serviceDefinitionId}/confirmation-document-settings/{confirmationDocumentSettingsId}
     * @secure
     */
    confirmationDocumentSettingsDeleteByServiceDefinitionId: (
      serviceDefinitionId: string,
      confirmationDocumentSettingsId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/service-definition/${serviceDefinitionId}/confirmation-document-settings/${confirmationDocumentSettingsId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name AdditionalServiceListByServiceDefinitionId
     * @summary Получение списка дополнительных услуг для шаблона услуги
     * @request GET:/service-definition/{serviceDefinitionId}/additional-service
     * @secure
     */
    additionalServiceListByServiceDefinitionId: (
      { serviceDefinitionId, ...query }: ApiAdditionalServiceListByServiceDefinitionIdParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiGetAdditionalServiceDefinitionsResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/service-definition/${serviceDefinitionId}/additional-service`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name AdditionalServiceCreateByServiceDefinitionId
     * @summary Создание дополнительной услуги для шаблона услуги
     * @request POST:/service-definition/{serviceDefinitionId}/additional-service
     * @secure
     */
    additionalServiceCreateByServiceDefinitionId: (
      serviceDefinitionId: string,
      data: ApiCreateAdditionalServiceDefinitionRequest_AdditionalServiceDefinition,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCreateAdditionalServiceDefinitionResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/service-definition/${serviceDefinitionId}/additional-service`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name AdditionalServiceDetailByRelationId
     * @summary Получение дополнительной услуги по идентификатору связи
     * @request GET:/service-definition/{serviceDefinitionId}/additional-service/{relationId}
     * @secure
     */
    additionalServiceDetailByRelationId: (
      relationId: string,
      serviceDefinitionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiGetAdditionalServiceDefinitionResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/service-definition/${serviceDefinitionId}/additional-service/${relationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name AdditionalServiceUpdateByRelationId
     * @summary Обновление дополнительной услуги по идентификатору связи
     * @request PUT:/service-definition/{serviceDefinitionId}/additional-service/{relationId}
     * @secure
     */
    additionalServiceUpdateByRelationId: (
      relationId: string,
      serviceDefinitionId: string,
      data: ApiUpdateAdditionalServiceDefinitionRequest_AdditionalServiceDefinition,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiUpdateAdditionalServiceDefinitionResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/service-definition/${serviceDefinitionId}/additional-service/${relationId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServiceDefinition
     * @name AdditionalServiceDeleteByRelationId
     * @summary Удаление дополнительной услуги по идентификатору связи
     * @request DELETE:/service-definition/{serviceDefinitionId}/additional-service/{relationId}
     * @secure
     */
    additionalServiceDeleteByRelationId: (
      relationId: string,
      serviceDefinitionId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/service-definition/${serviceDefinitionId}/additional-service/${relationId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  guaranteeLetterDefinition = {
    /**
     * No description
     *
     * @tags GuaranteeLetterDefinition
     * @name GuaranteeLetterDefinitionDetailById
     * @summary Получение шаблона гарантийного письма
     * @request GET:/guarantee-letter-definition/{id}
     * @secure
     */
    guaranteeLetterDefinitionDetailById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiGetGuaranteeLetterDefinitionByIdResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/guarantee-letter-definition/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GuaranteeLetterDefinition
     * @name GuaranteeLetterDefinitionUpdateById
     * @summary Изменить услугу, лимит и шаблон гарантийного письма
     * @request PUT:/guarantee-letter-definition/{id}
     * @secure
     */
    guaranteeLetterDefinitionUpdateById: (
      id: string,
      data: ApiGuaranteeLetterDefinitionForSave,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiUpdateGuaranteeLetterDefinitionResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/guarantee-letter-definition/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GuaranteeLetterDefinition
     * @name DocumentTemplateListById
     * @summary Получение шаблона
     * @request GET:/guarantee-letter-definition/{id}/document-template
     * @secure
     */
    documentTemplateListById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiGetDocumentTemplateResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/guarantee-letter-definition/${id}/document-template`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GuaranteeLetterDefinition
     * @name DocumentTemplateValidateCreate
     * @summary Проверка валидности шаблона гарантийного письма
     * @request POST:/guarantee-letter-definition/document-template/validate
     * @secure
     */
    documentTemplateValidateCreate: (
      data: ApiValidateGuaranteeLetterDefinitionDocumentTemplate_DocumentTemplate,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiValidateGuaranteeLetterDefinitionDocumentTemplateResponse,
        ApiValidationProblemDetails | void
      >({
        path: `/guarantee-letter-definition/document-template/validate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GuaranteeLetterDefinition
     * @name GuaranteeLetterDefinitionCreate
     * @summary Создать настройки гарантийного письма
     * @request POST:/guarantee-letter-definition
     * @secure
     */
    guaranteeLetterDefinitionCreate: (
      data: ApiGuaranteeLetterDefinitionForSave,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCreateGuaranteeLetterDefinitionResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/guarantee-letter-definition`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GuaranteeLetterDefinition
     * @name ArchiveCreateById
     * @summary Архивировать настройки гарантийного письма
     * @request POST:/guarantee-letter-definition/{id}/archive
     * @secure
     */
    archiveCreateById: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/guarantee-letter-definition/${id}/archive`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GuaranteeLetterDefinition
     * @name UnarchiveCreateById
     * @summary Разархивировать настройки гарантийного письма
     * @request POST:/guarantee-letter-definition/{id}/unarchive
     * @secure
     */
    unarchiveCreateById: (id: string, params: RequestParams = {}) =>
      this.request<any, void | ApiProblemDetails>({
        path: `/guarantee-letter-definition/${id}/unarchive`,
        method: 'POST',
        secure: true,
        ...params,
      }),
  };
  jcp = {
    /**
     * No description
     *
     * @tags Jcp
     * @name SignatureSignerCreate
     * @summary Получить список сертификатов подписантов из подписи
     * @request POST:/jcp/signature/signer
     */
    signatureSignerCreate: (
      data: ApiJcpGetSignersCertificates_Request,
      params: RequestParams = {},
    ) =>
      this.request<ApiJcpCertificateData[], ApiValidationProblemDetails>({
        path: `/jcp/signature/signer`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  maintenance = {
    /**
     * No description
     *
     * @tags Maintenance
     * @name DispatchPortalShipsFetchCreate
     * @summary Немедленная загрузка и сопоставление судов из Диспетчерского портала.
     * @request POST:/maintenance/dispatch-portal/ships/fetch
     * @secure
     */
    dispatchPortalShipsFetchCreate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/maintenance/dispatch-portal/ships/fetch`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maintenance
     * @name DispatchPortalTechnicalReportsFetchCreate
     * @summary Немедленная загрузка технических отчётов из Диспетчерского портала.
     * @request POST:/maintenance/dispatch-portal/technical-reports/fetch
     * @secure
     */
    dispatchPortalTechnicalReportsFetchCreate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/maintenance/dispatch-portal/technical-reports/fetch`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maintenance
     * @name TotalAmountUpdateByRequest
     * @request PUT:/maintenance/total-amount
     * @secure
     */
    totalAmountUpdateByRequest: (
      query: ApiTotalAmountUpdateByRequestParams,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/maintenance/total-amount`,
        method: 'PUT',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maintenance
     * @name AgreementPortalLimitsUpdate
     * @request PUT:/maintenance/agreement-portal-limits
     * @secure
     */
    agreementPortalLimitsUpdate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/maintenance/agreement-portal-limits`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maintenance
     * @name InitDivisionidUpdateByRequest
     * @request PUT:/maintenance/init-divisionid
     * @secure
     */
    initDivisionidUpdateByRequest: (
      query: ApiInitDivisionidUpdateByRequestParams,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/maintenance/init-divisionid`,
        method: 'PUT',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maintenance
     * @name InitDivisionRecipientRulesCreate
     * @request POST:/maintenance/init-division-recipient-rules
     * @secure
     */
    initDivisionRecipientRulesCreate: (params: RequestParams = {}) =>
      this.request<ApiNotificationsInitDivisionRecipientRulesResponse, void>({
        path: `/maintenance/init-division-recipient-rules`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maintenance
     * @name InitAnalyticsCreate
     * @request POST:/maintenance/init-analytics
     * @secure
     */
    initAnalyticsCreate: (params: RequestParams = {}) =>
      this.request<ApiInitAnalyticsResponse, void>({
        path: `/maintenance/init-analytics`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maintenance
     * @name EnterpriseServiceTransitionsAssignCentralOfficeAdminRoleCreate
     * @request POST:/maintenance/enterprise-service-transitions/assign-central-office-admin-role
     * @secure
     */
    enterpriseServiceTransitionsAssignCentralOfficeAdminRoleCreate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/maintenance/enterprise-service-transitions/assign-central-office-admin-role`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maintenance
     * @name SeedCreate
     * @request POST:/maintenance/seed
     * @secure
     */
    seedCreate: (data: ApiMaintenanceSeed_Request_Payload, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/maintenance/seed`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maintenance
     * @name SeedFullCreate
     * @request POST:/maintenance/seed-full
     * @secure
     */
    seedFullCreate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/maintenance/seed-full`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maintenance
     * @name SeedDiadocCounterpartiesLinksCreate
     * @request POST:/maintenance/seed-diadoc-counterparties-links
     * @secure
     */
    seedDiadocCounterpartiesLinksCreate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/maintenance/seed-diadoc-counterparties-links`,
        method: 'POST',
        secure: true,
        ...params,
      }),
  };
  masterApplication = {
    /**
     * No description
     *
     * @tags MasterApplication
     * @name LegalEntityCreate
     * @summary Создание заявки на мастер-аккаунт Юр. лица
     * @request POST:/master-application/legal-entity
     */
    legalEntityCreate: (
      data: ApiMasterAccountMasterApplicationLegalEntityCreateDto,
      params: RequestParams = {},
    ) =>
      this.request<string, ApiValidationProblemDetails>({
        path: `/master-application/legal-entity`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MasterApplication
     * @name LegalEntityEmployeeCreate
     * @summary Восстановление доступа к мастер-аккаунту Юр. лица для сотрудника
     * @request POST:/master-application/legal-entity/employee
     */
    legalEntityEmployeeCreate: (
      data: ApiMasterAccountMasterApplicationLegalEntityByEmployeeDto,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails>({
        path: `/master-application/legal-entity/employee`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MasterApplication
     * @name LegalEntityEdsCreate
     * @summary Создание заявки на мастер-аккаунт Юр. лица c ЭЦП
     * @request POST:/master-application/legal-entity-eds
     */
    legalEntityEdsCreate: (
      data: ApiMasterAccountMasterApplicationEdsCreateDto,
      params: RequestParams = {},
    ) =>
      this.request<string, ApiValidationProblemDetails>({
        path: `/master-application/legal-entity-eds`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MasterApplication
     * @name EntrepreneurEdsCreate
     * @summary Создание заявки на мастер-аккаунт ИП c ЭЦП
     * @request POST:/master-application/entrepreneur-eds
     */
    entrepreneurEdsCreate: (
      data: ApiMasterAccountMasterApplicationEdsCreateDto,
      params: RequestParams = {},
    ) =>
      this.request<string, ApiValidationProblemDetails>({
        path: `/master-application/entrepreneur-eds`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MasterApplication
     * @name EntrepreneurCreate
     * @summary Создание заявки на мастер-аккаунт ИП
     * @request POST:/master-application/entrepreneur
     */
    entrepreneurCreate: (
      data: ApiMasterAccountMasterApplicationEntrepreneurCreateDto,
      params: RequestParams = {},
    ) =>
      this.request<string, ApiValidationProblemDetails>({
        path: `/master-application/entrepreneur`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MasterApplication
     * @name EntrepreneurEmployeeCreate
     * @summary Восстановление доступа к мастер-аккаунту ИП для сотрудника
     * @request POST:/master-application/entrepreneur/employee
     */
    entrepreneurEmployeeCreate: (
      data: ApiMasterAccountMasterApplicationEntrepreneurByEmployeeDto,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails>({
        path: `/master-application/entrepreneur/employee`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>master-account-application:update</li></ul>
     *
     * @tags MasterApplication
     * @name ApproveUpdateById
     * @summary Подтверждение заявки на создание Мастер-аккаунта
     * @request PUT:/master-application/{id}/approve
     * @secure
     */
    approveUpdateById: (
      id: string,
      data: ApiMasterAccountApprovedMasterApplication,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/master-application/${id}/approve`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>master-account-application:update</li></ul>
     *
     * @tags MasterApplication
     * @name RejectUpdateById
     * @summary Отклонение заявки на создание Мастер-аккаунта
     * @request PUT:/master-application/{id}/reject
     * @secure
     */
    rejectUpdateById: (
      id: string,
      data: ApiMasterAccountRejectedMasterApplication,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/master-application/${id}/reject`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MasterApplication
     * @name LegalEntityExistsListByInn
     * @summary Поиск заявки на создание Мастер-аккаунта для ЮЛ
     * @request GET:/master-application/legal-entity/exists
     */
    legalEntityExistsListByInn: (
      query: ApiLegalEntityExistsListByInnParams2,
      params: RequestParams = {},
    ) =>
      this.request<ApiCounterpartiesCheckExistsDto, ApiValidationProblemDetails>({
        path: `/master-application/legal-entity/exists`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MasterApplication
     * @name EntrepreneurExistsListByInn
     * @summary Поиск заявки на создание Мастер-аккаунта для ИП
     * @request GET:/master-application/entrepreneur/exists
     */
    entrepreneurExistsListByInn: (
      query: ApiEntrepreneurExistsListByInnParams2,
      params: RequestParams = {},
    ) =>
      this.request<ApiCounterpartiesCheckExistsDto, ApiValidationProblemDetails>({
        path: `/master-application/entrepreneur/exists`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>master-account-application:read</li></ul>
     *
     * @tags MasterApplication
     * @name MasterApplicationListByIds
     * @summary Поиск заявок на создание Мастер-аккаунта по нескольким параметрам
     * @request GET:/master-application
     * @secure
     */
    masterApplicationListByIds: (
      query: ApiMasterApplicationListByIdsParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiServiceRequestsGetMasterApplicationsRequestResponse,
        ApiValidationProblemDetails | void
      >({
        path: `/master-application`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>master-account-application:read</li></ul>
     *
     * @tags MasterApplication
     * @name MasterApplicationDetailById
     * @summary Поиск заявки на создание Мастер-аккаунта по ID
     * @request GET:/master-application/{id}
     * @secure
     */
    masterApplicationDetailById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiGetMasterApplicationById_Response,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/master-application/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  permissions = {
    /**
     * No description
     *
     * @tags Permissions
     * @name PermissionsListByRequest
     * @request GET:/permissions
     * @secure
     */
    permissionsListByRequest: (
      query: ApiPermissionsListByRequestParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiAuthorizationGetPermissionsResponse, void>({
        path: `/permissions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name GetPermissions
     * @summary Получение действующих разрешений пользователя
     * @request GET:/permissions/own
     * @secure
     */
    getPermissions: (params: RequestParams = {}) =>
      this.request<ApiPermissionInfo[], ApiProblemDetails | void>({
        path: `/permissions/own`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name OwnAuthorizeServiceTransitionCreate
     * @request POST:/permissions/own/authorize-service-transition
     * @secure
     */
    ownAuthorizeServiceTransitionCreate: (
      data: ApiPermissionsAuthorizeServiceTransition_Request_Payload,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiAuthorizationAuthorizeEnterpriseServiceTransitionResponse,
        ApiProblemDetails | void
      >({
        path: `/permissions/own/authorize-service-transition`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  public = {
    /**
     * No description
     *
     * @tags Public
     * @name OrganizationalStructureList
     * @summary Получение оргструктуры предприятия
     * @request GET:/public/organizational-structure
     */
    organizationalStructureList: (params: RequestParams = {}) =>
      this.request<ApiGetDivisionStructure_Response, any>({
        path: `/public/organizational-structure`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Public
     * @name PublicOfferFileListById
     * @summary Получение файла публичной оферты
     * @request GET:/public/public-offer/{id}/file
     */
    publicOfferFileListById: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/public/public-offer/${id}/file`,
        method: 'GET',
        ...params,
      }),
  };
  publicOffer = {
    /**
     * No description
     *
     * @tags PublicOffer
     * @name FileUpdateById
     * @summary Установка файла публичной оферты
     * @request PUT:/public-offer/{id}/file
     * @secure
     */
    fileUpdateById: ({ id, ...query }: ApiFileUpdateByIdParams, params: RequestParams = {}) =>
      this.request<
        ApiPublicOfferDefinitionsSetPublicOfferFileResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/public-offer/${id}/file`,
        method: 'PUT',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicOffer
     * @name PublishCreateById
     * @summary Публикация публичной оферты
     * @request POST:/public-offer/{id}/publish
     * @secure
     */
    publishCreateById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiPublicOfferDefinitionsPublishPublicOfferResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/public-offer/${id}/publish`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicOffer
     * @name GeneratedPublicOfferDocumentCreateById
     * @summary Сгенерировать документ публичной оферты по шаблону
     * @request POST:/public-offer/{id}/generated-public-offer-document
     * @secure
     */
    generatedPublicOfferDocumentCreateById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiGeneratedDocumentResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/public-offer/${id}/generated-public-offer-document`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicOffer
     * @name PublicOfferAcceptanceListById
     * @summary Получить акцепты по идентификатору публичной оферты
     * @request GET:/public-offer/{id}/public-offer-acceptance
     * @secure
     */
    publicOfferAcceptanceListById: (
      { id, ...query }: ApiPublicOfferAcceptanceListByIdParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiPublicOfferDefinitionsGetPublicOfferAcceptancesResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/public-offer/${id}/public-offer-acceptance`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  publicOfferDefinition = {
    /**
     * No description
     *
     * @tags PublicOfferDefinition
     * @name PublicOfferDefinitionDetailById
     * @summary Получение шаблона публичной оферты
     * @request GET:/public-offer-definition/{id}
     * @secure
     */
    publicOfferDefinitionDetailById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiGetPublicOfferDefinitionByIdResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/public-offer-definition/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicOfferDefinition
     * @name PublicOfferDefinitionUpdateById
     * @summary Редактирование шаблона публичной оферты
     * @request PUT:/public-offer-definition/{id}
     * @secure
     */
    publicOfferDefinitionUpdateById: (
      id: string,
      data: ApiUpdatePublicOfferDefinition_UpdatingPublicOfferDefinition,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiUpdatePublicOfferDefinitionResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/public-offer-definition/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicOfferDefinition
     * @name DocumentTemplateListById
     * @summary Получение шаблона
     * @request GET:/public-offer-definition/{id}/document-template
     * @secure
     */
    documentTemplateListById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiGetDocumentTemplateResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/public-offer-definition/${id}/document-template`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicOfferDefinition
     * @name DocumentTemplateCreateById
     * @summary Создание шаблона
     * @request POST:/public-offer-definition/{id}/document-template
     * @secure
     */
    documentTemplateCreateById: (
      id: string,
      data: ApiCreatePublicOfferDefinitionDocumentTemplate_PublicOfferDefinitionDocumentTemplate,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCreatePublicOfferDefinitionDocumentTemplateResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/public-offer-definition/${id}/document-template`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicOfferDefinition
     * @name PublicOfferDefinitionCreate
     * @summary Создание шаблона публичной оферты
     * @request POST:/public-offer-definition
     * @secure
     */
    publicOfferDefinitionCreate: (
      data: ApiCreatePublicOfferDefinition_CreatingPublicOfferDefinition,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiCreatePublicOfferDefinitionResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/public-offer-definition`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicOfferDefinition
     * @name ArchiveCreateById
     * @summary Архивировать шаблон публичной оферты
     * @request POST:/public-offer-definition/{id}/archive
     * @secure
     */
    archiveCreateById: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/public-offer-definition/${id}/archive`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicOfferDefinition
     * @name UnarchiveCreateById
     * @summary Разархивировать шаблон публичной оферты
     * @request POST:/public-offer-definition/{id}/unarchive
     * @secure
     */
    unarchiveCreateById: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/public-offer-definition/${id}/unarchive`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicOfferDefinition
     * @name PublicOfferCreateById
     * @summary Создание версии публичной оферты
     * @request POST:/public-offer-definition/{id}/public-offer
     * @secure
     */
    publicOfferCreateById: (
      { id, ...query }: ApiPublicOfferCreateByIdParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiServicesCreatePublicOfferResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/public-offer-definition/${id}/public-offer`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicOfferDefinition
     * @name PublicOfferListById
     * @summary Получение списка версий публичной оферты
     * @request GET:/public-offer-definition/{id}/public-offer
     * @secure
     */
    publicOfferListById: (id: string, params: RequestParams = {}) =>
      this.request<
        ApiGetPublicOffersByPublicOfferDefinitionIdResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/public-offer-definition/${id}/public-offer`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicOfferDefinition
     * @name PublicOfferDetailById
     * @summary Получение публичной оферты
     * @request GET:/public-offer-definition/{id}/public-offer/{publicOfferId}
     * @secure
     */
    publicOfferDetailById: (id: string, publicOfferId: string, params: RequestParams = {}) =>
      this.request<
        ApiGetPublicOfferByPublicOfferDefinitionIdResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/public-offer-definition/${id}/public-offer/${publicOfferId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicOfferDefinition
     * @name PublicOfferAcceptanceListById
     * @summary Получить акцепты по идентификатору шаблона публичной оферты
     * @request GET:/public-offer-definition/{id}/public-offer-acceptance
     * @secure
     */
    publicOfferAcceptanceListById: (
      { id, ...query }: ApiPublicOfferAcceptanceListByIdParams2,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiPublicOfferDefinitionsGetPublicOfferAcceptancesResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/public-offer-definition/${id}/public-offer-acceptance`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  role = {
    /**
     * No description
     *
     * @tags Roles
     * @name OfficeEmployeeList
     * @summary Метод получения списка всех доступных ролей для сотрудника офиса. Ожидается массив объектов с полями: ключ/идентификатор, название
     * @request GET:/role/office-employee
     */
    officeEmployeeList: (params: RequestParams = {}) =>
      this.request<ApiRmpRole[], any>({
        path: `/role/office-employee`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name OfficeEmployeeOwnRolesList
     * @summary Получение Ролей вызывающего пользователя
     * @request GET:/role/office-employee/own-roles
     * @secure
     */
    officeEmployeeOwnRolesList: (params: RequestParams = {}) =>
      this.request<number[], void>({
        path: `/role/office-employee/own-roles`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name OfficeEmployeeDetailByProfileId
     * @summary Получение Ролей пользователя по ID
     * @request GET:/role/office-employee/{profileId}
     */
    officeEmployeeDetailByProfileId: (profileId: string, params: RequestParams = {}) =>
      this.request<ApiRoles, ApiValidationProblemDetails>({
        path: `/role/office-employee/${profileId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name OfficeEmployeeUpdateByProfileId
     * @summary Сохранение Роли
     * @request PUT:/role/office-employee/{profileId}
     * @secure
     */
    officeEmployeeUpdateByProfileId: (
      profileId: string,
      data: ApiOfficeEmployeeUpdateByProfileIdPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void>({
        path: `/role/office-employee/${profileId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  staff = {
    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-role:read</li></ul>
     *
     * @tags Staff
     * @name RoleListByDivisionIds
     * @summary Получить список всех возможных ролей сотрудника офиса
     * @request GET:/staff/role
     * @secure
     */
    roleListByDivisionIds: (query: ApiRoleListByDivisionIdsParams, params: RequestParams = {}) =>
      this.request<ApiRolesResponse, void>({
        path: `/staff/role`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Staff
     * @name PermissionListByRequest
     * @summary Получение разрешений сотрудника офиса
     * @request GET:/staff/permission
     */
    permissionListByRequest: (
      query: ApiPermissionListByRequestParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiAuthorizationGetPermissionsResponse, any>({
        path: `/staff/permission`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Staff
     * @name DivisionRoleListByDivisionId
     * @summary Получение ролей подразделения
     * @request GET:/staff/division/{divisionId}/role
     */
    divisionRoleListByDivisionId: (
      { divisionId, ...query }: ApiDivisionRoleListByDivisionIdParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiRolesResponse, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/staff/division/${divisionId}/role`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-role:create</li></ul>
     *
     * @tags Staff
     * @name DivisionRoleCreateByDivisionId
     * @summary Создание роли
     * @request POST:/staff/division/{divisionId}/role
     * @secure
     */
    divisionRoleCreateByDivisionId: (
      divisionId: string,
      data: ApiPermissionsCreateDivisionRole_Request_RoleDto,
      params: RequestParams = {},
    ) =>
      this.request<ApiCreateRoleResponse, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/staff/division/${divisionId}/role`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Staff
     * @name DivisionRoleDetailByDivisionId
     * @summary Получение ролей подразделения по идентификатору
     * @request GET:/staff/division/{divisionId}/role/{roleId}
     */
    divisionRoleDetailByDivisionId: (
      divisionId: string,
      roleId: number,
      params: RequestParams = {},
    ) =>
      this.request<ApiRolesResponse, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/staff/division/${divisionId}/role/${roleId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-role:update</li></ul>
     *
     * @tags Staff
     * @name DivisionRoleUpdateByDivisionId
     * @summary Обновление роли
     * @request PUT:/staff/division/{divisionId}/role/{roleId}
     * @secure
     */
    divisionRoleUpdateByDivisionId: (
      divisionId: string,
      roleId: number,
      data: ApiPermissionsUpdateDivisionRole_Request_RoleDto,
      params: RequestParams = {},
    ) =>
      this.request<ApiUpdateRoleResponse, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/staff/division/${divisionId}/role/${roleId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-role:delete</li></ul>
     *
     * @tags Staff
     * @name DivisionRoleDeleteByRoleId
     * @summary Удаление роли
     * @request DELETE:/staff/division/{divisionId}/role/{roleId}
     * @secure
     */
    divisionRoleDeleteByRoleId: (roleId: number, divisionId: string, params: RequestParams = {}) =>
      this.request<ApiDeleteRoleResponse, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/staff/division/${divisionId}/role/${roleId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Staff
     * @name DivisionRoleAppsListByDivisionId
     * @summary Получение приложений по идентификатору роли
     * @request GET:/staff/division/{divisionId}/role/{roleId}/apps
     */
    divisionRoleAppsListByDivisionId: (
      divisionId: string,
      roleId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiAuthorizationGetAppsResponse,
        ApiValidationProblemDetails | ApiProblemDetails
      >({
        path: `/staff/division/${divisionId}/role/${roleId}/apps`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Staff
     * @name DivisionRoleAppsUpdateByDivisionId
     * @summary Изменение приложений по идентификатору роли
     * @request PUT:/staff/division/{divisionId}/role/{roleId}/apps
     */
    divisionRoleAppsUpdateByDivisionId: (
      divisionId: string,
      roleId: number,
      data: ApiDivisionRoleAppsUpdateByDivisionIdPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiAuthorizationGetAppsResponse,
        ApiValidationProblemDetails | ApiProblemDetails
      >({
        path: `/staff/division/${divisionId}/role/${roleId}/apps`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-role:update</li></ul>
     *
     * @tags Staff
     * @name DivisionRoleAdditionalAuthorizedDivisionsUpdateByDivisionId
     * @summary Обновление дополнительных подразделений, в которых действует роль
     * @request PUT:/staff/division/{divisionId}/role/{roleId}/additional-authorized-divisions
     * @secure
     */
    divisionRoleAdditionalAuthorizedDivisionsUpdateByDivisionId: (
      divisionId: string,
      roleId: number,
      data: ApiPermissionsUpdateDivisionRoleAdditionalAuthorizedDivisions_Body,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiUpdateRoleAdditionalAuthorizedDivisionsResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/staff/division/${divisionId}/role/${roleId}/additional-authorized-divisions`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Staff
     * @name DivisionRoleCanBeDeletedUpdateByRoleId
     * @summary Проверка на возможность удаления роли
     * @request PUT:/staff/division/{divisionId}/role/{roleId}/can-be-deleted
     */
    divisionRoleCanBeDeletedUpdateByRoleId: (
      roleId: number,
      divisionId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiRoleCanBeDeletedCheckResponse,
        ApiValidationProblemDetails | ApiProblemDetails
      >({
        path: `/staff/division/${divisionId}/role/${roleId}/can-be-deleted`,
        method: 'PUT',
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-role:update</li></ul>
     *
     * @tags Staff
     * @name DivisionRolePermissionUpdateByDivisionId
     * @summary Установка прав доступа для роли
     * @request PUT:/staff/division/{divisionId}/role/{roleId}/permission
     * @secure
     */
    divisionRolePermissionUpdateByDivisionId: (
      divisionId: string,
      roleId: number,
      data: ApiDivisionRolePermissionUpdateByDivisionIdPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/staff/division/${divisionId}/role/${roleId}/permission`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-role:read</li></ul>
     *
     * @tags Staff
     * @name DivisionRolePermissionListByDivisionId
     * @summary Получение прав доступа роли
     * @request GET:/staff/division/{divisionId}/role/{roleId}/permission
     * @secure
     */
    divisionRolePermissionListByDivisionId: (
      divisionId: string,
      roleId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiGetDivisionRolePermissions_Response,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/staff/division/${divisionId}/role/${roleId}/permission`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-role:update</li></ul>
     *
     * @tags Staff
     * @name DivisionRoleArchiveCreateByDivisionId
     * @summary Архивация роли
     * @request POST:/staff/division/{divisionId}/role/{roleId}/archive
     * @secure
     */
    divisionRoleArchiveCreateByDivisionId: (
      divisionId: string,
      roleId: number,
      params: RequestParams = {},
    ) =>
      this.request<ApiArchiveRoleResponse, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/staff/division/${divisionId}/role/${roleId}/archive`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-role:update</li></ul>
     *
     * @tags Staff
     * @name DivisionRoleUnarchiveCreateByDivisionId
     * @summary Разархивация роли
     * @request POST:/staff/division/{divisionId}/role/{roleId}/unarchive
     * @secure
     */
    divisionRoleUnarchiveCreateByDivisionId: (
      divisionId: string,
      roleId: number,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiUnarchiveRoleResponse,
        ApiValidationProblemDetails | void | ApiProblemDetails
      >({
        path: `/staff/division/${divisionId}/role/${roleId}/unarchive`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-employee:read</li></ul>
     *
     * @tags Staff
     * @name EmployeeListByQuery
     * @summary Получить список сотрудников
     * @request GET:/staff/employee
     * @secure
     */
    employeeListByQuery: (query: ApiEmployeeListByQueryParams, params: RequestParams = {}) =>
      this.request<ApiEmployeesResponse, ApiValidationProblemDetails | void>({
        path: `/staff/employee`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>enterprise-employee:read</li></ul>
     *
     * @tags Staff
     * @name EmployeeDetailById
     * @summary Получить сотрудника по ID
     * @request GET:/staff/employee/{id}
     * @secure
     */
    employeeDetailById: (id: string, params: RequestParams = {}) =>
      this.request<ApiEmployeeResponse, ApiValidationProblemDetails | void>({
        path: `/staff/employee/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Staff
     * @name EmployeeUpdatedListByUpdatedAtFrom
     * @summary Получить список сотрудников офисов измененных за промежуток времени
     * @request GET:/staff/employee/updated
     */
    employeeUpdatedListByUpdatedAtFrom: (
      query: ApiEmployeeUpdatedListByUpdatedAtFromParams2,
      params: RequestParams = {},
    ) =>
      this.request<ApiEmployeesUpdatedResponse, ApiValidationProblemDetails>({
        path: `/staff/employee/updated`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>division-contact:read</li></ul>
     *
     * @tags Staff
     * @name ContactListByQuery
     * @summary Получение всех контактов.
     * @request GET:/staff/contact
     * @secure
     */
    contactListByQuery: (query: ApiContactListByQueryParams2, params: RequestParams = {}) =>
      this.request<
        ApiDivisionContactResponse,
        ApiValidationProblemDetails | void | ApiSwaggerDefault404NotFoundExamples
      >({
        path: `/staff/contact`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  trust = {
    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee-trust:read</li></ul>
     *
     * @tags Trust
     * @name TrustListByCounterpartyId
     * @summary Получение списка доверенностей
     * @request GET:/trust
     * @secure
     */
    trustListByCounterpartyId: (
      query: ApiTrustListByCounterpartyIdParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiTrustsResponse, void>({
        path: `/trust`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee-trust:read</li></ul>
     *
     * @tags Trust
     * @name TrustDetailById
     * @summary Получение доверенности по ID
     * @request GET:/trust/{id}
     * @secure
     */
    trustDetailById: (id: string, params: RequestParams = {}) =>
      this.request<ApiTrustResponse, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/trust/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trust
     * @name UpdatedListByUpdatedAtFrom
     * @summary Получить список доверенностей измененных за промежуток времени
     * @request GET:/trust/updated
     * @secure
     */
    updatedListByUpdatedAtFrom: (
      query: ApiUpdatedListByUpdatedAtFromParams2,
      params: RequestParams = {},
    ) =>
      this.request<ApiUpdatedTrustsResponse, ApiValidationProblemDetails | void>({
        path: `/trust/updated`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trust
     * @name ActiveListByCounterpartyId
     * @summary Получить список активных доверенностей сотрудника
     * @request GET:/trust/active
     * @secure
     */
    activeListByCounterpartyId: (
      query: ApiActiveListByCounterpartyIdParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiTrustsResponse, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/trust/active`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description <b>Права доступа:</b><ul><li>counterparty-employee-trust:read</li></ul>
     *
     * @tags Trust
     * @name ActionerListById
     * @summary Получить сотрудника, который произвел действие с доверенностью
     * @request GET:/trust/{id}/actioner
     * @secure
     */
    actionerListById: ({ id, ...query }: ApiActionerListByIdParams, params: RequestParams = {}) =>
      this.request<ApiTrustActionerDto, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/trust/${id}/actioner`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  generatedMchd = {
    /**
     * No description
     *
     * @tags Trust
     * @name GeneratedMchdCreate
     * @summary генерация xml - МЧД
     * @request POST:/generated-mchd
     * @secure
     */
    generatedMchdCreate: (data: ApiTrustsPostMchd_MchdCreateDto, params: RequestParams = {}) =>
      this.request<void, ApiValidationProblemDetails | void | ApiProblemDetails>({
        path: `/generated-mchd`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
}
